import React, { useState, useEffect, useCallback } from 'react';
import { signInWithEmailAndPassword, signOut as fbSignOut, onAuthStateChanged, User } from 'firebase/auth';
import { collection, doc, addDoc, updateDoc, deleteDoc, onSnapshot, query, orderBy, getDoc, setDoc, getDocs, where } from 'firebase/firestore';
import { auth, db } from './api/firebase';

const LOGO = "data:image/jpeg;base64,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";

const COLORS:Record<string,string>={'Black':'#2C2C2A','White':'#E8E6DC','Red':'#E24B4A','Blue':'#378ADD','Green':'#639922','Yellow':'#EF9F27','Orange':'#D85A30','Purple':'#7F77DD','Pink':'#D4537E','Transparent':'#B4B2A9','Gray':'#888780','Teal':'#1D9E75','Natural':'#D3D1C7'};

function dFwd(n:number){const d=new Date();d.setDate(d.getDate()+n);return d.toISOString().split('T')[0];}
function fmtDur(min:number){return`${Math.floor(min/60)}h ${min%60}m`;}
function jobCost(g:number,mat:string,fils:any[]){const f=fils.find(x=>x.material===mat.split(' ')[0])||{cost_per_kg:25};return g/1000*(f.cost_per_kg||25);}
function spoolVal(f:any){return(f.weight_g*f.remaining_pct/100)/1000*(f.cost_per_kg||0);}
function timeAgo(iso:string){if(!iso)return'';const s=Math.floor((Date.now()-new Date(iso).getTime())/1000);if(s<60)return'just now';if(s<3600)return`${Math.floor(s/60)}m ago`;if(s<86400)return`${Math.floor(s/3600)}h ago`;return`${Math.floor(s/86400)}d ago`;}
function useIsMobile(){const[m,setM]=useState(window.innerWidth<768);useEffect(()=>{const h=()=>setM(window.innerWidth<768);window.addEventListener('resize',h);return()=>window.removeEventListener('resize',h);},[]);return m;}


async function scanWithCamera(onResult:(c:string)=>void,onError:(m:string)=>void){
  try{
    // Load html5-qrcode
    await new Promise<void>((res,rej)=>{
      if((window as any).Html5Qrcode){res();return;}
      const s=document.createElement('script');
      s.src='https://unpkg.com/html5-qrcode@2.3.8/html5-qrcode.min.js';
      s.onload=()=>res();
      s.onerror=()=>rej(new Error('Failed to load scanner'));
      document.head.appendChild(s);
    });

    // Full screen overlay
    const overlay=document.createElement('div');
    overlay.style.cssText='position:fixed;inset:0;z-index:10000;background:#000;display:flex;flex-direction:column;';
    overlay.innerHTML=`
      <div style="background:rgba(0,0,0,0.9);padding:14px 16px;text-align:center;flex-shrink:0;padding-top:max(14px,env(safe-area-inset-top));">
        <div style="color:white;font-size:16px;font-weight:700;">Scan Barcode</div>
        <div style="color:rgba(255,255,255,0.6);font-size:12px;margin-top:3px;">Keep entire barcode inside the box</div>
      </div>
      <div id="scan-reader" style="flex:1;width:100%;background:#000;"></div>
      <div style="background:rgba(0,0,0,0.9);padding:16px;flex-shrink:0;padding-bottom:max(16px,env(safe-area-inset-bottom));">
        <div style="color:rgba(255,255,255,0.5);font-size:11px;text-align:center;margin-bottom:10px;">Barcode: 735810243179 will be scanned automatically</div>
        <button id="sc-cancel" style="width:100%;padding:15px;background:white;border:none;border-radius:14px;font-size:17px;font-weight:700;cursor:pointer;color:#333;">Cancel</button>
      </div>`;
    document.body.appendChild(overlay);

    const Html5Qrcode=(window as any).Html5Qrcode;
    const Html5QrcodeSupportedFormats=(window as any).Html5QrcodeSupportedFormats;
    const scanner=new Html5Qrcode('scan-reader',{verbose:false});
    let active=true;

    const cleanup=async()=>{
      active=false;
      try{if(scanner.isScanning){await scanner.stop();}}catch{}
      overlay.remove();
    };
    document.getElementById('sc-cancel')!.onclick=()=>cleanup();

    // Scan box: wide and tall enough to capture full barcode
    const qrbox=(viewfinderWidth:number,viewfinderHeight:number)=>{
      const w=Math.floor(viewfinderWidth*0.9);
      const h=Math.floor(Math.min(viewfinderHeight*0.35,220));
      return{width:w,height:h};
    };

    // Support every barcode format — filament spools, nozzle boxes, QR codes, all of it
    const SF=Html5QrcodeSupportedFormats;
    const formats=SF?[
      SF.CODE_128,    // Most filament spools
      SF.EAN_13,      // Retail products, nozzles (like Diamondback 5063384002997)
      SF.EAN_8,       // Smaller retail barcodes
      SF.UPC_A,       // US retail products
      SF.UPC_E,       // Compressed UPC
      SF.CODE_39,     // Industrial/equipment
      SF.CODE_93,     // Higher density industrial
      SF.QR_CODE,     // QR codes
      SF.DATA_MATRIX, // Small 2D codes on electronics
      SF.ITF,         // Interleaved barcodes
      SF.CODABAR,     // Some medical/library
      SF.PDF_417,     // Large 2D codes
      SF.AZTEC,       // Some shipping labels
    ].filter(Boolean):undefined;

    await scanner.start(
      {facingMode:'environment'},
      {
        fps:20,
        qrbox,
        aspectRatio:window.innerHeight/window.innerWidth,
        formatsToSupport:formats,
        rememberLastUsedCamera:true,
        showTorchButtonIfSupported:true,
        disableFlip:false,
      },
      (decodedText:string)=>{
        if(active){
          // Vibrate on success if supported
          if(navigator.vibrate)navigator.vibrate(100);
          cleanup();
          onResult(decodedText);
        }
      },
      ()=>{/* keep scanning */}
    );

  }catch(e:any){
    const el=document.getElementById('scan-reader');
    if(el)el.closest('div[style*="z-index:10000"]')?.remove();
    if(e.name==='NotAllowedError'||String(e).toLowerCase().includes('permission')){
      onError('Camera permission denied. In Safari/Chrome go to Settings → allow camera for this site.');
    }else if(String(e).toLowerCase().includes('insecure')){
      onError('Camera requires HTTPS. The site is already secure — try refreshing.');
    }else{
      onError('Could not start camera: '+String(e).substring(0,80)+'. Enter barcode manually below.');
    }
  }
}


const I:Record<string,React.ReactNode>={
  dashboard:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>,
  printers:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>,
  filament:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/></svg>,
  scan:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2"/><line x1="3" y1="12" x2="21" y2="12"/></svg>,
  queue:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>,
  maintenance:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>,
  equipment:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  costs:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  history:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
  activity:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
  add:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  more:<svg viewBox="0 0 24 24" fill="currentColor"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></svg>,
  workorders:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
  purchases:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>,
  approvals:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
    itsupport:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  records:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
    customers:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
    team:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
    settings:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
  bell:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
  check:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>,
  trash:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>,
  play:<svg viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg>,
  signout:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
};

// Bottom nav — your 5 most used pages
const BOTTOM_NAV=[
  {id:'dashboard',label:'Dashboard'},
  {id:'scan',label:'Scan In'},
  {id:'filament',label:'Filament'},
  {id:'queue',label:'Queue'},
  {id:'more',label:'More'},
];

const ALL_NAV=[
  {id:'dashboard',label:'Dashboard',section:'Overview'},
  {id:'printers',label:'Printers',section:'Overview'},
  {id:'filament',label:'Filament',section:'Inventory'},
  {id:'equipment',label:'Equipment',section:'Inventory'},
  {id:'costs',label:'Cost Tracking',section:'Inventory'},
  {id:'scan',label:'Scan In',section:'Inventory'},
  {id:'queue',label:'Print Queue',section:'Operations'},
  {id:'history',label:'Job History',section:'Operations'},
  {id:'maintenance',label:'Maintenance',section:'Operations'},
  {id:'activity',label:'Activity Log',section:'Operations'},
  {id:'customers',label:'Customers',section:'Operations'},
  {id:'workorders',label:'Work Orders',section:'Operations'},
  {id:'purchases',label:'Purchase Requests',section:'Operations'},
  {id:'approvals',label:'Approvals',section:'Operations'},
  {id:'itsupport',label:'IT Support',section:'Account'},
  {id:'team',label:'Team',section:'Account'},
  {id:'records',label:'Records & History',section:'Account'},
  {id:'settings',label:'Settings',section:'Account'},
];

function PrinterCard({p,onDelete,onEdit}:{p:any,onDelete?:(id:string)=>void,onEdit?:(p:any)=>void}){
  const C={bg:'#fff',border:'rgba(0,0,0,0.08)',stat:'#f5f6f8',text:'#1a1a1a',sub:'#444',muted:'#888'};
  const statusConfig:{[k:string]:{color:string,bg:string,dot:string,label:string}}={
    printing:{color:'#059669',bg:'#D1FAE5',dot:'#059669',label:'Printing'},
    idle:{color:'#6B7280',bg:'#F3F4F6',dot:'#9CA3AF',label:'Idle'},
    error:{color:'#DC2626',bg:'#FEE2E2',dot:'#DC2626',label:'Error'},
    paused:{color:'#D97706',bg:'#FEF3C7',dot:'#D97706',label:'Paused'},
    offline:{color:'#9CA3AF',bg:'#F9FAFB',dot:'#D1D5DB',label:'Offline'},
  };
  const s=statusConfig[p.status]||statusConfig.offline;
  const pf=p.status==='error'?'#DC2626':p.status==='paused'?'#D97706':'#059669';

  const[countdown,setCountdown]=React.useState(p.eta||'—');
  React.useEffect(()=>{
    if(p.status!=='printing'||!p.eta||p.eta==='—'){setCountdown(p.eta||'—');return;}
    const parse=(str:string)=>{const hm=str.match(/(\d+)h\s*(\d+)m/);const m=str.match(/^(\d+)m/);if(hm)return+hm[1]*3600+ +hm[2]*60;if(m)return+m[1]*60;return 0;};
    let secs=parse(p.eta);
    if(!secs){setCountdown(p.eta);return;}
    const iv=setInterval(()=>{secs=Math.max(0,secs-1);const h=Math.floor(secs/3600);const m=Math.floor((secs%3600)/60);const s2=secs%60;setCountdown(h>0?`${h}h ${m}m`:`${m}m ${s2}s`);if(!secs)clearInterval(iv);},1000);
    return()=>clearInterval(iv);
  },[p.eta,p.status]);

  return(
    <div onClick={()=>{if(onEdit)onEdit(p);}}
      style={{background:C.bg,borderRadius:16,marginBottom:10,cursor:onEdit?'pointer':'default',
        boxShadow:'0 1px 3px rgba(0,0,0,0.06),0 1px 2px rgba(0,0,0,0.04)',
        border:`1px solid ${C.border}`,overflow:'hidden',transition:'box-shadow 0.15s'}}
      onMouseEnter={e=>{if(onEdit)(e.currentTarget as HTMLElement).style.boxShadow='0 4px 16px rgba(0,0,0,0.10)';}}
      onMouseLeave={e=>{(e.currentTarget as HTMLElement).style.boxShadow='0 1px 3px rgba(0,0,0,0.06),0 1px 2px rgba(0,0,0,0.04)';}}>

      {/* Status bar across top */}
      <div style={{height:3,background:p.status==='printing'?`linear-gradient(90deg,#185FA5 ${p.progress_pct||0}%,#e5e7eb ${p.progress_pct||0}%)`:p.status==='error'?'#DC2626':p.status==='paused'?'#D97706':'#e5e7eb',transition:'background 1s'}}/>

      <div style={{padding:'14px 16px'}}>
        {/* Header row */}
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:12}}>
          <div style={{flex:1,minWidth:0}}>
            <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:3}}>
              <div style={{fontSize:15,fontWeight:700,color:C.text,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{p.name}</div>
              {p.api_type&&p.api_type!=='manual'&&(
                <span style={{fontSize:9,fontWeight:800,padding:'2px 6px',borderRadius:4,background:p.api_type==='prusa'?'#FF6900':p.api_type==='bambu'?'#1DB954':'#185FA5',color:'#fff',letterSpacing:'0.5px',textTransform:'uppercase',flexShrink:0}}>{p.api_type}</span>
              )}
            </div>
            <div style={{fontSize:11,color:C.muted}}>{p.model} · {p.location}</div>
          </div>
          <div style={{display:'flex',alignItems:'center',gap:8,flexShrink:0}}>
            <span style={{fontSize:11,fontWeight:600,padding:'3px 10px',borderRadius:20,background:s.bg,color:s.color}}>{s.label}</span>
            {onDelete&&<button onClick={(e)=>{e.stopPropagation();if(window.confirm(`Remove ${p.name}?`))onDelete(p.id);}} style={{width:26,height:26,background:'transparent',border:`1px solid ${C.border}`,borderRadius:8,cursor:'pointer',color:C.muted,display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,flexShrink:0}}>✕</button>}
          </div>
        </div>

        {/* Job info */}
        {p.status==='printing'?(
          <div style={{marginBottom:12}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:6}}>
              <div style={{fontSize:12,fontWeight:600,color:C.sub,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',maxWidth:'70%'}}>{p.current_job||'Unknown job'}</div>
              <span style={{fontSize:13,fontWeight:800,color:'#059669'}}>{Math.round(p.progress_pct||0)}%</span>
            </div>
            <div style={{height:6,background:'#E5E7EB',borderRadius:999,overflow:'hidden'}}>
              <div style={{width:`${p.progress_pct||0}%`,height:'100%',background:'linear-gradient(90deg,#185FA5,#059669)',borderRadius:999,transition:'width 1s ease'}}/>
            </div>
          </div>
        ):p.status==='error'&&p.last_error?(
          <div style={{marginBottom:12,padding:'6px 10px',background:'#FEE2E2',borderRadius:8}}>
            <div style={{fontSize:10,color:'#DC2626',fontWeight:600}}>Error: {p.last_error}</div>
          </div>
        ):(
          <div style={{marginBottom:12,height:6}}/>
        )}

        {/* Stats grid */}
        <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:8}}>
          {[
            {label:'ETA',value:p.status==='printing'?countdown:'—',highlight:p.status==='printing'},
            {label:'Nozzle',value:p.nozzle_temp>0?`${p.nozzle_temp}°`:'—',highlight:p.nozzle_temp>180,color:p.nozzle_temp>200?'#DC2626':p.nozzle_temp>100?'#D97706':'#6B7280'},
            {label:'Bed',value:p.bed_temp>0?`${p.bed_temp}°`:'—',highlight:p.bed_temp>40,color:p.bed_temp>50?'#D97706':'#6B7280'},
            {label:'Material',value:p.current_filament||'—',highlight:false},
          ].map(stat=>(
            <div key={stat.label} style={{background:C.stat,borderRadius:10,padding:'8px 6px',textAlign:'center'}}>
              <div style={{fontSize:9,color:C.muted,fontWeight:600,letterSpacing:'0.3px',textTransform:'uppercase',marginBottom:3}}>{stat.label}</div>
              <div style={{fontSize:stat.label==='Material'?10:12,fontWeight:700,color:(stat as any).color||(stat.highlight?'#185FA5':C.sub),overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{stat.value}</div>
            </div>
          ))}
        </div>
        {/* Last sync + debug */}
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:8,paddingTop:8,borderTop:'0.5px solid rgba(0,0,0,0.06)'}}>
          <span style={{fontSize:9,color:C.muted}}>{p.updated_at?`Synced ${new Date(p.updated_at).toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'})}`:'Not synced'}{p.raw_state?` · ${p.raw_state}`:''}</span>
          {p.api_type&&p.api_type!=='manual'&&<span style={{fontSize:9,color:C.muted}}>🔄 live</span>}
        </div>
      </div>
    </div>
  );
}

function StatCard({label,value,sub,accent}:{label:string,value:string,sub?:string,accent?:string}){
  return(
    <div style={{background:'#f8f8f7',borderRadius:12,padding:'14px 14px'}}>
      <div style={{fontSize:11,color:'#888',marginBottom:4}}>{label}</div>
      <div style={{fontSize:26,fontWeight:700,color:accent||'#1a1a1a',lineHeight:1}}>{value}</div>
      {sub&&<div style={{fontSize:11,color:'#aaa',marginTop:4}}>{sub}</div>}
    </div>
  );
}

export default function App(){
  const isMobile=useIsMobile();
  const[user,setUser]=useState<User|null>(null);
  const[authLoading,setAuthLoading]=useState(true);
  const[email,setEmail]=useState('');
  const[password,setPassword]=useState('');
  const[authError,setAuthError]=useState('');
  const[signingIn,setSigningIn]=useState(false);
  const[page,setPage]=useState('dashboard');
  const[drawer,setDrawer]=useState(false);
  const[printers,setPrinters]=useState<any[]>([]);
  const[filaments,setFilaments]=useState<any[]>([]);
  const[equipment,setEquipment]=useState<any[]>([]);
  const[queue,setQueue]=useState<any[]>([]);
  const[history,setHistory]=useState<any[]>([]);
  const[maintenance,setMaintenance]=useState<any[]>([]);
  const[activity,setActivity]=useState<any[]>([]);
  const[dataLoading,setDataLoading]=useState(true);
  const[filSearch,setFilSearch]=useState('');
  const[filFilter,setFilFilter]=useState('All');
  const[eqSearch,setEqSearch]=useState('');
  const[eqFilter,setEqFilter]=useState('All');
  const[histTab,setHistTab]=useState('all');
  const[maintTab,setMaintTab]=useState('upcoming');
  const[bcInput,setBcInput]=useState('');
  const[bcResult,setBcResult]=useState<any>(null);
  const[modal,setModal]=useState<string|null>(null);
  const[form,setForm]=useState<any>({});
  const[toast,setToast]=useState('');
  // Theme tokens (light mode only — dark mode coming in iOS app)
  const T={
    bg:'#f5f5f3', surface:'#ffffff', surfaceAlt:'#f8f8f7',
    border:'rgba(0,0,0,0.08)', borderStrong:'rgba(0,0,0,0.15)',
    text:'#1a1a1a', textSub:'#555555', textMuted:'#888888',
    input:'#ffffff', inputBorder:'#e0e0e0',
    sidebar:'#ffffff', sidebarBorder:'rgba(0,0,0,0.1)',
    navActive:'#EBF4FF', navHover:'#f5f5f3',
    topbar:'#ffffff', topbarBorder:'rgba(0,0,0,0.1)',
    statBg:'#f8f8f7',
    blue:'#185FA5', green:'#1D9E75', red:'#E24B4A', amber:'#EF9F27',
  };
  // Role system — stored per user email in Firebase
  const[userRole,setUserRole]=useState<'admin'|'management'|'it'|'lead'|'tech'>('admin');
  const[userProfile,setUserProfile]=useState<any>(null);
  // Role permissions
  const canApprove=userRole==='admin'||userRole==='management'||userRole==='lead';
  const canCreatePO=userRole==='admin'||userRole==='management'||userRole==='lead';
  const isAdmin=userRole==='admin';
  const isManagement=userRole==='admin'||userRole==='management';
  const isIT=userRole==='admin'||userRole==='it';
  const[workOrders,setWorkOrders]=useState<any[]>([]);
  const[purchases,setPurchases]=useState<any[]>([]);
  const[woTab,setWoTab]=useState('open');
  const[prTab,setPrTab]=useState('pending');
  const[appTab,setAppTab]=useState('pending');
  const[partSearch,setPartSearch]=useState('');
  const[histMaint,setHistMaint]=useState<any[]>([]);
  const[recordsTab,setRecordsTab]=useState<'maintenance'|'workorders'|'purchases'>('workorders');
  const[recordsSearch,setRecordsSearch]=useState('');
  const[customers,setCustomers]=useState<any[]>([]);
  const[cusTab,setCusTab]=useState('active');
  const[cusSearch,setCusSearch]=useState('');
  const[tickets,setTickets]=useState<any[]>([]);
  const[ticketTab,setTicketTab]=useState('open');
  const[showProfile,setShowProfile]=useState(false);
  const[teamMembers,setTeamMembers]=useState<any[]>([]);
  const[notifSettings,setNotifSettings]=useState({
    printerError:true,printerComplete:true,
    lowFilament:true,maintenanceDue:true,
    queueEmpty:false,printerOffline:true,
    soundEnabled:false,vibrate:true,
  });
  const[hasAlerts,setHasAlerts]=useState(false);

  useEffect(()=>{
    const u=onAuthStateChanged(auth,async(u)=>{
      setUser(u);
      setAuthLoading(false);
      if(u){
        // Load user role from Firestore
        try{
          const userRef=doc(db,'users',u.uid);
          // getDoc/setDoc from static import
          const snap=await getDoc(userRef);
          if(snap.exists()){
            const data=snap.data() as any;
            setUserRole(data.role||'tech');
            setUserProfile(data);
          } else {
            const profile={email:u.email,role:'admin',name:u.email?.split('@')[0]||'Owner',created_at:new Date().toISOString()};
            await setDoc(userRef,profile);
            setUserRole('admin');
            setUserProfile(profile);
          }
          // Owner always admin
          if(u.email==='damon.pope@forgebytetechnologies.com'){
            setUserRole('admin' as any);
            await updateDoc(doc(db,'users',u.uid),{role:'admin',name:'damon.pope'}).catch(()=>{});
          }
        }catch(e){setUserRole('admin');}
      }
    });
    return u;
  },[]);
  useEffect(()=>{
    if(!user)return;setDataLoading(true);const uns:any[]=[];
    uns.push(onSnapshot(query(collection(db,'printers'),orderBy('name')),s=>{setPrinters(s.docs.map(d=>({id:d.id,...d.data()})));setDataLoading(false);}));
    uns.push(onSnapshot(query(collection(db,'filaments'),orderBy('brand')),s=>setFilaments(s.docs.map(d=>({id:d.id,...d.data()})))));
    uns.push(onSnapshot(query(collection(db,'equipment'),orderBy('name')),s=>setEquipment(s.docs.map(d=>({id:d.id,...d.data()})))));
    uns.push(onSnapshot(query(collection(db,'print_queue'),orderBy('created_at','desc')),s=>setQueue(s.docs.map(d=>({id:d.id,...d.data()})))));
    uns.push(onSnapshot(query(collection(db,'job_history'),orderBy('completed_at','desc')),s=>setHistory(s.docs.map(d=>({id:d.id,...d.data()})))));
    uns.push(onSnapshot(query(collection(db,'maintenance'),orderBy('due_date')),s=>setMaintenance(s.docs.map(d=>({id:d.id,...d.data()})))));
    uns.push(onSnapshot(query(collection(db,'activity'),orderBy('created_at','desc')),s=>setActivity(s.docs.map(d=>({id:d.id,...d.data()})))));
    uns.push(onSnapshot(query(collection(db,'work_orders'),orderBy('created_at','desc')),s=>setWorkOrders(s.docs.map(d=>({id:d.id,...d.data()})))));
    uns.push(onSnapshot(query(collection(db,'purchase_requests'),orderBy('created_at','desc')),s=>setPurchases(s.docs.map(d=>({id:d.id,...d.data()})))));
    uns.push(onSnapshot(collection(db,'history_maintenance'),s=>{const docs=s.docs.map(d=>({id:d.id,...d.data()}));docs.sort((a,b)=>{const ta=a.archived_at||a.submitted_at||a.created_at||'';const tb=b.archived_at||b.submitted_at||b.created_at||'';return tb>ta?1:-1;});setHistMaint(docs);}));
    uns.push(onSnapshot(collection(db,'users'),s=>setTeamMembers(s.docs.map(d=>({uid:d.id,...d.data()})))));
    uns.push(onSnapshot(query(collection(db,'it_tickets'),orderBy('created_at','desc')),s=>setTickets(s.docs.map(d=>({id:d.id,...d.data()})))));
    uns.push(onSnapshot(query(collection(db,'customers'),orderBy('name')),s=>setCustomers(s.docs.map(d=>({id:d.id,...d.data()})))));
    return()=>uns.forEach(u=>u());
  },[user]);

  const showToast=(msg:string)=>{setToast(msg);setTimeout(()=>setToast(''),2500);};

  // ── LIVE PRINTER SYNC ──────────────────────────────────────
  // Polls all connected printers every 15s and updates Firebase
  useEffect(()=>{
    if(!user||printers.length===0)return;
    const connected=printers.filter(p=>p.api_type!=='manual');
    if(connected.length===0)return;

    const fmtEta=(secs:number)=>{
      if(!secs||secs<=0)return'—';
      const h=Math.floor(secs/3600);
      const m=Math.floor((secs%3600)/60);
      return h>0?`${h}h ${m}m`:`${m}m`;
    };

    const syncAll=async()=>{
      for(const p of connected){

        // ── PRUSA LINK — direct local call from browser ────────────────
        // PrusaLink is on the local LAN — browser can reach it directly.
        // API key stays in browser memory only, never sent to a third party.
        if(p.api_type==='prusa'&&p.prusa_api_key){
          try{
            const base=p.prusa_local_ip?`http://${p.prusa_local_ip.replace(/^https?:\/\//,'')}`.replace(/\/$/,''):'';
            if(!base){
              if(p.prusa_printer_uuid){
                // No local IP — try cloud proxy as fallback
                const r=await fetch(`/api/prusa-proxy?uuid=${encodeURIComponent(p.prusa_printer_uuid)}`,{
                  headers:{'X-Prusa-Key':p.prusa_api_key},
                });
                const d=await r.json();
                if(r.ok&&!d.error){
                  await updateDoc(doc(db,'printers',p.id),{
                    status:d.status||'offline',current_job:d.job_name||null,
                    progress_pct:Math.round(d.progress||0),eta:fmtEta(d.time_remaining),
                    nozzle_temp:Math.round(d.temp_nozzle||0),bed_temp:Math.round(d.temp_bed||0),
                    current_filament:d.filament||null,updated_at:new Date().toISOString(),
                    last_error:null,raw_state:d.state||null,
                  });
                } else {
                  await updateDoc(doc(db,'printers',p.id),{status:'offline',last_error:'No local IP set — add it in Edit Printer',updated_at:new Date().toISOString()});
                }
              } else {
                await updateDoc(doc(db,'printers',p.id),{status:'offline',last_error:'No local IP or UUID configured',updated_at:new Date().toISOString()});
              }
              continue;
            }
            // Direct local call — browser → printer on LAN
            const [sr,jr]=await Promise.all([
              fetch(`${base}/api/v1/status`,{headers:{'X-Api-Key':p.prusa_api_key}}),
              fetch(`${base}/api/v1/job`,{headers:{'X-Api-Key':p.prusa_api_key}}),
            ]);
            if(sr.ok){
              const sd=await sr.json();
              const jd=jr.ok?await jr.json():{};
              const printer=sd.printer||{};
              const stMap:Record<string,string>={PRINTING:'printing',BUSY:'printing',PAUSED:'paused',PAUSE:'paused',IDLE:'idle',READY:'idle',FINISHED:'idle',OPERATIONAL:'idle',STOPPED:'idle',ATTENTION:'error',ERROR:'error',OFFLINE:'offline'};
              const rawSt=String(printer.state||'OFFLINE').toUpperCase();
              await updateDoc(doc(db,'printers',p.id),{
                status:stMap[rawSt]||'offline',raw_state:rawSt,
                current_job:jd.file?.name||null,
                progress_pct:Math.round(Number(jd.progress||printer.progress||0)*100)/100,
                eta:fmtEta(jd.time_remaining||0),
                nozzle_temp:Math.round(Number(printer.temp_nozzle||printer.tool_temp||0)),
                bed_temp:Math.round(Number(printer.temp_bed||0)),
                current_filament:printer.filament||null,
                updated_at:new Date().toISOString(),last_error:null,
              });
            } else if(sr.status===401){
              await updateDoc(doc(db,'printers',p.id),{status:'offline',last_error:'PrusaLink: wrong API key (401)',updated_at:new Date().toISOString()});
            } else {
              // Try v0 API (older firmware)
              const [pr0,jr0]=await Promise.all([
                fetch(`${base}/api/printer`,{headers:{'X-Api-Key':p.prusa_api_key}}),
                fetch(`${base}/api/job`,{headers:{'X-Api-Key':p.prusa_api_key}}),
              ]);
              if(pr0.ok){
                const pd=await pr0.json();const jd0=jr0.ok?await jr0.json():{};
                const flags=pd.state?.flags||{};
                let st='idle';
                if(flags.printing)st='printing';else if(flags.paused)st='paused';else if(flags.error)st='error';else if(!flags.operational)st='offline';
                await updateDoc(doc(db,'printers',p.id),{
                  status:st,current_job:jd0.job?.file?.name||null,
                  progress_pct:Math.round(Number(jd0.progress?.completion||0)),
                  eta:fmtEta(jd0.progress?.printTimeLeft||0),
                  nozzle_temp:Math.round(Number(pd.temperature?.tool0?.actual||0)),
                  bed_temp:Math.round(Number(pd.temperature?.bed?.actual||0)),
                  updated_at:new Date().toISOString(),last_error:null,raw_state:st.toUpperCase(),
                });
              } else {
                await updateDoc(doc(db,'printers',p.id),{status:'offline',last_error:`PrusaLink unreachable at ${base} (HTTP ${pr0.status})`,updated_at:new Date().toISOString()});
              }
            }
          }catch(e:any){
            await updateDoc(doc(db,'printers',p.id),{status:'offline',last_error:String(e?.message||'Connection failed').slice(0,100),updated_at:new Date().toISOString()}).catch(()=>{});
          }
          continue;
        }

        // ── BAMBU LABS — via secure server proxy ───────────────────────
        if(p.api_type==='bambu'&&p.bambu_device_id){
          try{
            const res=await fetch(`/api/bambu-proxy?device_id=${encodeURIComponent(p.bambu_device_id)}`,{
              headers:{'X-Bambu-Token':p.bambu_token||'','X-Bambu-Access-Code':p.bambu_access_code||''},
            });
            const result=await res.json();
            if(!res.ok||result.error){
              await updateDoc(doc(db,'printers',p.id),{status:'offline',last_error:result.error||`HTTP ${res.status}`,updated_at:new Date().toISOString()});
              continue;
            }
            await updateDoc(doc(db,'printers',p.id),{
              status:result.status||'offline',current_job:result.job_name||null,
              progress_pct:Math.round(result.progress||0),eta:fmtEta(result.time_remaining),
              nozzle_temp:Math.round(result.temp_nozzle||0),bed_temp:Math.round(result.temp_bed||0),
              current_filament:result.filament||null,updated_at:new Date().toISOString(),
              last_error:null,raw_state:result.state||null,
            });
          }catch(e:any){
            await updateDoc(doc(db,'printers',p.id),{status:'offline',last_error:String(e?.message||'').slice(0,100),updated_at:new Date().toISOString()}).catch(()=>{});
          }
          continue;
        }

        // ── OCTOPRINT / KLIPPER — direct local call from browser ────────
        // Same principle as PrusaLink — local LAN, browser calls directly
        if((p.api_type==='octoprint'||p.api_type==='klipper')&&p.octoprint_url){
          try{
            const base=p.octoprint_url.replace(/\/$/,'');
            const okHeaders={'X-Api-Key':p.octoprint_api_key||'','Accept':'application/json'};
            if(p.api_type==='klipper'){
              // Moonraker direct call
              const mr=await fetch(`${base}/printer/objects/query?print_stats&extruder&heater_bed&display_status`,{headers:okHeaders});
              if(mr.ok){
                const md=await mr.json();
                const st=md.result?.status||{};
                const ps=st.print_stats||{};
                const ext=st.extruder||{};const bed=st.heater_bed||{};const disp=st.display_status||{};
                const rs=String(ps.state||'standby').toLowerCase();
                const msMap:Record<string,string>={printing:'printing',pausing:'paused',paused:'paused',standby:'idle',complete:'idle',cancelled:'idle',error:'error'};
                await updateDoc(doc(db,'printers',p.id),{
                  status:msMap[rs]||'offline',raw_state:rs.toUpperCase(),
                  current_job:ps.filename||null,
                  progress_pct:Math.round(Number(disp.progress||0)*100),
                  eta:fmtEta(Math.round(Number(ps.total_duration||0)-Number(ps.print_duration||0))),
                  nozzle_temp:Math.round(Number(ext.temperature||0)),
                  bed_temp:Math.round(Number(bed.temperature||0)),
                  updated_at:new Date().toISOString(),last_error:null,
                });
              } else {
                await updateDoc(doc(db,'printers',p.id),{status:'offline',last_error:`Moonraker unreachable (HTTP ${mr.status})`,updated_at:new Date().toISOString()});
              }
            } else {
              // OctoPrint direct call
              const [pr,jr]=await Promise.all([
                fetch(`${base}/api/printer`,{headers:okHeaders}),
                fetch(`${base}/api/job`,{headers:okHeaders}),
              ]);
              if(pr.ok){
                const pd=await pr.json();const jd=jr.ok?await jr.json():{};
                const flags=pd.state?.flags||{};
                let st='idle';
                if(flags.printing)st='printing';else if(flags.paused)st='paused';else if(flags.error)st='error';else if(!flags.operational)st='offline';
                await updateDoc(doc(db,'printers',p.id),{
                  status:st,current_job:jd.job?.file?.name||null,
                  progress_pct:Math.round(Number(jd.progress?.completion||0)),
                  eta:fmtEta(jd.progress?.printTimeLeft||0),
                  nozzle_temp:Math.round(Number(pd.temperature?.tool0?.actual||0)),
                  bed_temp:Math.round(Number(pd.temperature?.bed?.actual||0)),
                  updated_at:new Date().toISOString(),last_error:null,
                });
              } else {
                await updateDoc(doc(db,'printers',p.id),{status:'offline',last_error:`OctoPrint unreachable (HTTP ${pr.status})`,updated_at:new Date().toISOString()});
              }
            }
          }catch(e:any){
            await updateDoc(doc(db,'printers',p.id),{status:'offline',last_error:String(e?.message||'').slice(0,100),updated_at:new Date().toISOString()}).catch(()=>{});
          }
          continue;
        }

      }
    };

        syncAll();
    const interval=setInterval(syncAll,15000);
    return()=>clearInterval(interval);
  },[user,JSON.stringify(printers.filter(p=>p.api_type!=='manual').map(p=>p.id))]);

  // Auto-reorder: create purchase request when filament hits threshold
  useEffect(()=>{
    if(!user||filaments.length===0)return;
    filaments.forEach(async f=>{
      if(f.remaining_pct<=15&&!f.auto_pr_created){
        // Check if a PR already exists for this spool
        const existingPR=purchases.find(p=>p.filament_id===f.id&&p.status!=='denied');
        if(!existingPR){
          await addDoc(collection(db,'purchase_requests'),{
            po_number:`AUTO-${Date.now().toString().slice(-6)}`,
            title:`Auto-reorder: ${f.material} ${f.color} — ${f.brand}`,
            line_items:[{name:`${f.brand} ${f.material} ${f.color} 1kg`,type:'filament',qty:2,unit_price:f.cost_per_kg||24.99,notes:'Auto-generated reorder'}],
            total_cost:(f.cost_per_kg||24.99)*2,
            vendor:f.supplier||'',urgency:'normal',
            reason:`Auto-reorder triggered: ${f.brand} ${f.material} ${f.color} is at ${f.remaining_pct}% remaining`,
            filament_id:f.id,status:'pending',
            requested_by:'System (auto-reorder)',requested_by_role:'admin',
            created_at:new Date().toISOString(),
          });
          await updateDoc(doc(db,'filaments',f.id),{auto_pr_created:true});
          await addAct(`Auto-reorder created: ${f.brand} ${f.material} ${f.color} (${f.remaining_pct}% remaining)`,'#EF9F27');
          showToast(`Auto-reorder created for ${f.material} ${f.color} ✓`);
        }
      }
      // Reset flag when restocked above 25%
      if(f.remaining_pct>25&&f.auto_pr_created){
        await updateDoc(doc(db,'filaments',f.id),{auto_pr_created:false});
      }
    });
  },[filaments.map(f=>`${f.id}:${f.remaining_pct}`).join(',')]);

  // Notification alerts check
  useEffect(()=>{
    const alerts=[];
    if(notifSettings.printerError&&printers.some(p=>p.status==='error'))alerts.push('printer_error');
    if(notifSettings.lowFilament&&filaments.some(f=>f.remaining_pct<20))alerts.push('low_filament');
    if(notifSettings.maintenanceDue&&maintenance.some(m=>m.status==='overdue'))alerts.push('maintenance_due');
    if(notifSettings.printerOffline&&printers.some(p=>p.status==='offline'&&p.api_type!=='manual'))alerts.push('offline');
    if((isAdmin||isManagement||isIT)&&tickets.filter(t=>t.status==='open'&&t.priority==='critical').length>0)alerts.push('critical_ticket');
    setHasAlerts(alerts.length>0);
  },[printers,filaments,maintenance,notifSettings]);
  const addAct=useCallback(async(msg:string,color='#378ADD')=>{await addDoc(collection(db,'activity'),{message:msg,color,created_at:new Date().toISOString()});},[]);
  const signIn=async()=>{setSigningIn(true);setAuthError('');try{await signInWithEmailAndPassword(auth,email,password);}catch(e:any){setAuthError(e.message.replace('Firebase: ','').replace(/\(auth.*\)/,'').trim());}setSigningIn(false);};
  const nav=(p:string)=>{setPage(p);setDrawer(false);};
  const del=async(col:string,id:string)=>{await deleteDoc(doc(db,col,id));showToast('Deleted');};

  const printing=printers.filter(p=>p.status==='printing').length;
  const lowStock=filaments.filter(f=>f.remaining_pct<20);
  const overdue=maintenance.filter(m=>m.status==='overdue');
  const invVal=filaments.reduce((s,f)=>s+spoolVal(f),0);

  const startJob=async(qid:string)=>{
    const q=queue.find(x=>x.id===qid);const idle=printers.find(p=>p.status==='idle');
    if(!q||!idle){showToast('No idle printer available');return;}
    await updateDoc(doc(db,'printers',idle.id),{status:'printing',current_job:q.job_name,progress_pct:0,eta:fmtDur(q.est_duration_min),current_filament:q.material,nozzle_temp:215,bed_temp:60});
    await del('print_queue',qid);await addAct(`Dispatched ${q.job_name} to ${idle.name}`,'#1D9E75');
    showToast(`Sent to ${idle.name}`);
  };

  const doneMaint=async(id:string)=>{
    const m=maintenance.find((x:any)=>x.id===id);
    if(!m)return;
    // Submit for approval instead of directly completing
    await updateDoc(doc(db,'maintenance',id),{
      status:'pending_approval',
      submitted_at:new Date().toISOString(),
      submitted_by:user?.email||'',
      submitted_by_role:userRole,
    });
    // Archive snapshot - use original_id to link back to maintenance doc
    try{
      const gd2=getDocs,wh2=where;
      const existing=await gd2(query(collection(db,'history_maintenance'),wh2('original_id','==',id)));
      if(existing.empty){
        await addDoc(collection(db,'history_maintenance'),{
          ...m,original_id:id,
          status:'pending_approval',
          submitted_at:new Date().toISOString(),
          submitted_by:user?.email||'',
          archived_at:new Date().toISOString(),
        });
      } else {
        existing.forEach(async(d)=>{
          await updateDoc(d.ref,{
            status:'pending_approval',
            submitted_at:new Date().toISOString(),
            submitted_by:user?.email||'',
          });
        });
      }
    }catch(e){
      await addDoc(collection(db,'history_maintenance'),{
        ...m,original_id:id,status:'pending_approval',
        submitted_at:new Date().toISOString(),
        submitted_by:user?.email||'',archived_at:new Date().toISOString(),
      });
    }
    await addAct(`Maintenance submitted for approval: ${m.task} on ${m.printer_name}`,'#EF9F27');
    showToast('Submitted for approval ✓');
  };

  const approveMaint=async(id:string)=>{
    const m=maintenance.find((x:any)=>x.id===id);
    if(!m){showToast('Task not found');return;}
    if(!canApprove){showToast('Only Leads and Admins can approve');return;}
    const now=new Date().toISOString();
    await updateDoc(doc(db,'maintenance',id),{
      status:'completed',completed_at:now,
      approved_by:user?.email||'Admin',
      approved_by_role:userRole,approved_at:now,
    });
    // Update existing history record OR create one if missing
    try{
      const gd=getDocs,wh=where;
      const q2=query(collection(db,'history_maintenance'),wh('original_id','==',id));
      const snap=await gd(q2);
      if(snap.empty){
        // No history record yet - create it now
        await addDoc(collection(db,'history_maintenance'),{
          ...m,original_id:id,
          status:'completed',completed_at:now,
          approved_by:user?.email||'Admin',
          approved_by_role:userRole,approved_at:now,
          archived_at:now,
        });
      } else {
        snap.forEach(async(d)=>{
          await updateDoc(d.ref,{
            status:'completed',completed_at:now,
            approved_by:user?.email||'Admin',
            approved_by_role:userRole,approved_at:now,
          });
        });
      }
    }catch(e){
      // Fallback - just add a new record
      await addDoc(collection(db,'history_maintenance'),{
        ...m,original_id:id,status:'completed',
        completed_at:now,approved_by:user?.email||'Admin',
        approved_by_role:userRole,approved_at:now,archived_at:now,
      });
    }
    await addAct(`Maintenance approved & closed: ${m.task} on ${m.printer_name}`,'#1D9E75');
    showToast('Maintenance task approved & closed ✓');
  };

  const saveModal=async()=>{
    const now=new Date().toISOString();
    if(modal==='filament'){
      const filData={
        material:form.material||'PLA',brand:form.brand||'Unknown',
        color:form.color||'Natural',diameter:form.diameter||'1.75mm',
        weight_g:parseInt(form.weight)||1000,
        cost_per_kg:parseFloat(form.cost)||24.99,
        purchase_price:parseFloat(form.purchase_price)||0,
        supplier:form.supplier||'',
        location:form.location||'Unassigned',
        notes:form.notes||'',
      };
      if(form.editing&&form.id){
        await updateDoc(doc(db,'filaments',form.id),{...filData,updated_at:now});
        await addAct(`Updated: ${form.material} ${form.color} spool (${form.brand})`,'#378ADD');
        showToast('Spool updated ✓');
      } else {
        await addDoc(collection(db,'filaments'),{...filData,remaining_pct:100,barcode:form.barcode||`MANUAL-${Date.now()}`,added_at:now});
        await addAct(`Added: ${form.material} ${form.color} spool (${form.brand})`,'#378ADD');
        showToast('Spool added ✓');
      }
    }else if(modal==='equipment'){
      if(form.editing&&form.id){
        await updateDoc(doc(db,'equipment',form.id),{
          name:form.name||'New Item',type:form.type||'Tool',
          serial_number:form.serial||'N/A',
          quantity:parseInt(form.qty)||1,
          unit_cost:parseFloat(form.unit_cost)||0,
          total_value:(parseFloat(form.unit_cost)||0)*(parseInt(form.qty)||1),
          supplier:form.supplier||'',
          purchase_date:form.purchase_date||'',
          notes:form.notes||'',
          location:form.location||'Unassigned',
        });
        await addAct(`Updated equipment: ${form.name}`,'#378ADD');showToast('Equipment updated ✓');
      }else{
        await addDoc(collection(db,'equipment'),{
          name:form.name||'New Item',type:form.type||'Tool',
          serial_number:form.serial||'N/A',
          quantity:parseInt(form.qty)||1,
          unit_cost:parseFloat(form.unit_cost)||0,
          total_value:(parseFloat(form.unit_cost)||0)*(parseInt(form.qty)||1),
          supplier:form.supplier||'',
          purchase_date:form.purchase_date||now.split('T')[0],
          notes:form.notes||'',
          location:form.location||'Unassigned',
          barcode:form.barcode||`EQ-${Date.now()}`,
          added_at:now
        });
        await addAct(`Added equipment: ${form.name} ($${((parseFloat(form.unit_cost)||0)*(parseInt(form.qty)||1)).toFixed(2)})`,'#378ADD');showToast('Equipment added ✓');
      }
    }else if(modal==='printer'){
      await addDoc(collection(db,'printers'),{
        name:form.name||'New Printer',model:form.model||'Unknown',
        location:form.location||'Unassigned',status:'idle',progress_pct:0,
        current_job:'—',eta:'—',nozzle_temp:0,bed_temp:0,current_filament:'—',
        api_type:form.api_type||'manual',
        prusa_api_key:form.prusa_api_key||'',
        prusa_printer_uuid:form.prusa_uuid||'',
        prusa_local_ip:form.prusa_local_ip||'',
        bambu_device_id:form.bambu_device_id||'',
        bambu_access_code:form.bambu_access_code||'',
        octoprint_url:form.octoprint_url||'',
        octoprint_api_key:form.octoprint_api_key||'',
        purchase_price:parseFloat(form.purchase_price)||0,
        supplier:form.supplier||'',
        purchase_date:form.purchase_date||'',
        added_at:now
      });
      await addAct(`Added printer: ${form.name}`,'#1D9E75');showToast('Printer added ✓');
    }else if(modal==='queue'){
      const cus=customers.find(c=>c.id===form.customer_id);
      await addDoc(collection(db,'print_queue'),{
        job_name:form.job_name||'unnamed.gcode',
        material:form.material||'PLA',
        est_duration_min:parseInt(form.duration)||60,
        est_filament_g:parseInt(form.filament_g)||50,
        priority:form.priority||'normal',
        notes:form.notes||'',
        customer_id:form.customer_id||'',
        customer_name:cus?.name||'',
        customer_price:parseFloat(form.customer_price)||0,
        tags:form.tags||'',
        status:'queued',created_at:now,
      });
      await addAct(`Job queued: ${form.job_name}${cus?` for ${cus.name}`:''}${form.customer_price>0?` — $${parseFloat(form.customer_price).toFixed(2)}`:''}`,'#7F77DD');
      showToast('Added to queue ✓');
    }else if(modal==='newTicket'){
      const ticketNum=`TKT-${Date.now().toString().slice(-6)}`;
      const priorityColors:{[k:string]:string}={critical:'#E24B4A',high:'#EF9F27',medium:'#185FA5',low:'#888'};
      await addDoc(collection(db,'it_tickets'),{
        ticket_number:ticketNum,
        category:form.category||'General IT Help',
        subject:form.subject||'IT Support Request',
        priority:form.priority||'medium',
        location:form.location||'',
        description:form.description||'',
        steps:form.steps||'',
        status:'open',
        submitted_by:user?.email||'',
        submitted_by_role:userRole,
        created_at:now,
        updated_at:now,
      });
      await addAct(`IT Ticket submitted: ${form.subject} (${ticketNum}) — Priority: ${form.priority||'medium'}`,'#7F77DD');
      showToast(`Ticket ${ticketNum} submitted — IT team notified ✓`);
    }else if(modal==='newCustomer'||modal==='editCustomer'){
      const cusData={
        name:form.name||'',contact:form.contact||'',
        email:form.email||'',phone:form.phone||'',
        address:form.address||'',
        default_material:form.default_material||'PLA',
        default_color:form.default_color||'Black',
        hourly_rate:parseFloat(form.hourly_rate)||65,
        markup:parseFloat(form.markup)||20,
        notes:form.notes||'',
        updated_at:now,
      };
      if(modal==='editCustomer'&&form.id){
        await updateDoc(doc(db,'customers',form.id),cusData);
        showToast('Customer updated ✓');
      } else {
        await addDoc(collection(db,'customers'),{...cusData,created_at:now,total_jobs:0,total_revenue:0});
        await addAct(`New customer added: ${form.name}`,'#7F77DD');
        showToast('Customer added ✓');
      }
    }else if(modal==='maintenance'){
      if(form.editing&&form.id){
        await updateDoc(doc(db,'maintenance',form.id),{
          printer_name:form.printer_name||printers[0]?.name,
          task:form.task||'Inspection',
          due_date:form.due_date||dFwd(7),
          urgency:form.urgency||'med',
          parts_cost:parseFloat(form.parts_cost)||0,
          labor_min:parseInt(form.labor_min)||0,
          parts_needed:form.parts_needed||'',
          notes:form.notes||'',
        });
        await addAct(`Updated maintenance: ${form.task}`,'#EF9F27');showToast('Maintenance updated ✓');
      }else{
        await addDoc(collection(db,'maintenance'),{
          printer_name:form.printer_name||printers[0]?.name,
          task:form.task||'Inspection',
          due_date:form.due_date||dFwd(7),
          urgency:form.urgency||'med',
          parts_cost:parseFloat(form.parts_cost)||0,
          labor_min:parseInt(form.labor_min)||0,
          parts_needed:form.parts_needed||'',
          notes:form.notes||'',
          status:'upcoming',
          created_at:now
        });
        await addAct(`Maintenance scheduled: ${form.task} on ${form.printer_name} (est. $${parseFloat(form.parts_cost||0).toFixed(2)})`,'#EF9F27');showToast('Scheduled ✓');
      }
    }else if(modal==='adjustFilament'){
      await updateDoc(doc(db,'filaments',form.id),{remaining_pct:parseInt(form.remaining)||0});
      await addAct(`Adjusted ${form.brand} ${form.material} ${form.color} to ${form.remaining}%`,'#185FA5');
      showToast(`Updated to ${form.remaining}% remaining ✓`);
    }else if(modal==='prusaConnect'){
      await addDoc(collection(db,'printers'),{
        name:form.name||'Prusa Printer',model:form.model||'Prusa MK4',
        location:form.location||'Unassigned',status:'idle',progress_pct:0,
        current_job:'—',eta:'—',nozzle_temp:0,bed_temp:0,current_filament:'—',
        api_type:'prusa',prusa_api_key:form.prusa_api_key||'',
        prusa_printer_uuid:form.prusa_uuid||'',
        prusa_local_ip:form.prusa_local_ip||'',added_at:now
      });
      await addAct(`Connected Prusa: ${form.name}`,'#1D9E75');
      showToast('Prusa printer added ✓');
    }else if(modal==='newWorkOrder'){
      const woNum=`WO-${Date.now().toString().slice(-6)}`;
      const woRef=await addDoc(collection(db,'work_orders'),{
        wo_number:woNum,title:form.title||'Work Order',
        printer_name:form.printer_name||printers[0]?.name,
        urgency:form.urgency||'medium',status:'open',
        due_date:form.due_date||dFwd(3),
        assigned_to:form.assigned_to||'',
        parts_cost:parseFloat(form.parts_cost)||0,
        labor_min:parseInt(form.labor_min)||0,
        parts_used:form.parts_used||[],
        description:form.description||'',
        created_at:now,created_by:user?.email||'',
      });
      // Smart parts checkout: deduct qty, log cost, flag last unit
      const checkoutLog=[];
      for(const part of (form.parts_used||[])){
        const eq=equipment.find((e:any)=>e.id===part.id);
        if(eq){
          const newQty=Math.max(0,(eq.quantity||0)-part.qty);
          const partCost=(eq.unit_cost||0)*part.qty;
          await updateDoc(doc(db,'equipment',part.id),{
            quantity:newQty,
            last_checkout_at:now,
            last_checkout_wo:woNum,
          });
          checkoutLog.push({name:eq.name,qty:part.qty,cost:partCost,remaining:newQty});
          await addAct(`Parts checkout: ${part.qty}x ${eq.name} → ${woNum} ($${partCost.toFixed(2)})`,'#EF9F27');
          // Auto-create purchase request if last unit or zero
          if(newQty===0){
            await addDoc(collection(db,'purchase_requests'),{
              item_name:eq.name,item_type:'equipment',eq_type:eq.type||'Spare Part',
              quantity:Math.max(1,eq.quantity||1),unit_price:eq.unit_cost||0,
              total_cost:(eq.unit_cost||0)*Math.max(1,eq.quantity||1),
              vendor:eq.supplier||'',
              urgency:'urgent',
              reason:`Auto-generated: Last unit used on work order ${woNum}. Stock is now 0.`,
              status:'pending',requested_by:'System (auto)',
              created_at:now,
            });
            await addAct(`⚠ Last unit used: ${eq.name} — purchase request auto-created`,'#E24B4A');
          } else if(newQty===1){
            await addAct(`⚠ Low stock warning: Only 1x ${eq.name} remaining`,'#EF9F27');
          }
        }
      }
      // Add checkout log to WO
      if(checkoutLog.length>0){
        const totalPartsCost=checkoutLog.reduce((s,p)=>s+p.cost,0);
        await updateDoc(doc(db,'work_orders',woRef.id),{parts_cost:totalPartsCost,checkout_log:checkoutLog});
      }
      await addAct(`Work order created: ${form.title} (${woNum})`,'#185FA5');
      showToast(`Work order ${woNum} created ✓`);
    }else if(modal==='newPurchase'){
      const lineItems=form.line_items||[{name:form.item_name||'Item',type:'equipment',qty:1,unit_price:0}];
      const poTotal=lineItems.reduce((s:number,i:any)=>s+((i.qty||1)*(i.unit_price||0)),0);
      const poNum=`PO-${Date.now().toString().slice(-6)}`;
      await addDoc(collection(db,'purchase_requests'),{
        po_number:poNum,
        title:form.title||lineItems[0]?.name||'Purchase Order',
        line_items:lineItems,
        total_cost:poTotal,
        vendor:form.vendor||'',
        vendor_contact:form.vendor_contact||'',
        ship_to:form.ship_to||'Main Shop',
        needed_by:form.needed_by||'',
        urgency:form.urgency||'normal',
        reason:form.reason||'',
        status:canCreatePO?'pending':'draft',
        requested_by:user?.email||'',
        requested_by_role:userRole,
        created_at:now,
      });
      await addAct(`PO created: ${form.title||lineItems[0]?.name} — ${lineItems.length} item(s) — $${poTotal.toFixed(2)} (${poNum})`,'#7F77DD');
      showToast(`${poNum} submitted — $${poTotal.toFixed(2)} ✓`);
    }else if(modal==='editPrinter'&&form.id){
      await updateDoc(doc(db,'printers',form.id),{
        name:form.name||'Printer',
        model:form.model||'Unknown',
        location:form.location||'Unassigned',
        api_type:form.api_type||'manual',
        prusa_api_key:form.prusa_api_key||'',
        prusa_printer_uuid:form.prusa_uuid||'',
        prusa_local_ip:form.prusa_local_ip||'',
        bambu_device_id:form.bambu_device_id||'',
        bambu_access_code:form.bambu_access_code||'',
        octoprint_url:form.octoprint_url||'',
        octoprint_api_key:form.octoprint_api_key||'',
        updated_at:now,
      });
      await addAct(`Updated printer: ${form.name}`,'#1D9E75');
      showToast('Printer settings saved ✓');
    }
    setModal(null);setForm({});
  };

  const matBadge:Record<string,{bg:string,color:string}>={
    PLA:{bg:'#E1F5EE',color:'#085041'},'PLA+':{bg:'#D4F1E6',color:'#085041'},'PLA-CF':{bg:'#C8EDE0',color:'#085041'},
    PETG:{bg:'#E6F1FB',color:'#185FA5'},'PETG-CF':{bg:'#CCE3F7',color:'#0C447C'},
    ABS:{bg:'#FAECE7',color:'#993C1D'},ASA:{bg:'#FAEEDA',color:'#854F0B'},
    TPU:{bg:'#FFF3CD',color:'#856404'},TPE:{bg:'#FFF3CD',color:'#856404'},
    Nylon:{bg:'#F3E8FF',color:'#6B21A8'},'Nylon-CF':{bg:'#EDE0FF',color:'#6B21A8'},
    PC:{bg:'#FBEAF0',color:'#993556'},'PC-ABS':{bg:'#F5D6E3',color:'#993556'},
    HIPS:{bg:'#F1EFE8',color:'#5F5E5A'},PVA:{bg:'#E0F7FF',color:'#0369A1'},
    PEEK:{bg:'#FEF3C7',color:'#92400E'},PEKK:{bg:'#FDE68A',color:'#92400E'},
    'Wood Fill':{bg:'#FEF3C7',color:'#92400E'},'Metal Fill':{bg:'#F1EFE8',color:'#374151'},
    'Silk PLA':{bg:'#FCE7F3',color:'#9D174D'},'Matte PLA':{bg:'#F3F4F6',color:'#374151'},
  };

  // ── AUTH ──────────────────────────────────────────────────
  if(authLoading)return(<div style={{height:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#0C1929',flexDirection:'column',gap:16}}><img src={LOGO} alt="" style={{width:64,borderRadius:12}}/><div style={{width:28,height:28,border:'2px solid rgba(255,255,255,0.2)',borderTopColor:'#fff',borderRadius:'50%',animation:'spin 0.7s linear infinite'}}/><div style={{color:'rgba(255,255,255,0.6)',fontSize:13}}>Loading ForgeOS…</div><style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style></div>);

  if(!user)return(
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#0C1929',padding:20}}>
      <div style={{background:'#fff',borderRadius:20,padding:'32px 24px',width:'100%',maxWidth:380,textAlign:'center'}}>
        <img src={LOGO} alt="" style={{width:64,borderRadius:12,marginBottom:12}}/>
        <div style={{fontSize:24,fontWeight:700,marginBottom:4}}>ForgeOS</div>
        <div style={{fontSize:13,color:T.textMuted,marginBottom:28,lineHeight:1.5}}>ForgeByte Technologies LLC</div>
        {authError&&<div style={{background:'#FCEBEB',color:'#A32D2D',padding:'10px 14px',borderRadius:10,fontSize:13,marginBottom:14}}>{authError}</div>}
        <div style={{textAlign:'left',marginBottom:14}}>
          <label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:6}}>Email</label>
          <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="your@email.com" autoComplete="email" style={{width:'100%',padding:'12px 14px',fontSize:15,border:'1.5px solid #e0e0e0',borderRadius:10,outline:'none',fontFamily:'inherit'}}/>
        </div>
        <div style={{textAlign:'left',marginBottom:20}}>
          <label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:6}}>Password</label>
          <input type="password" value={password} onChange={e=>setPassword(e.target.value)} onKeyDown={e=>e.key==='Enter'&&signIn()} placeholder="••••••••" autoComplete="current-password" style={{width:'100%',padding:'12px 14px',fontSize:15,border:'1.5px solid #e0e0e0',borderRadius:10,outline:'none',fontFamily:'inherit'}}/>
        </div>
        <button onClick={signIn} disabled={signingIn} style={{width:'100%',padding:'14px',background:'#185FA5',color:'#fff',border:'none',borderRadius:12,fontSize:16,fontWeight:600,cursor:'pointer',opacity:signingIn?0.7:1}}>{signingIn?'Signing in…':'Sign In'}</button>
      </div>
    </div>
  );

  if(dataLoading)return(<div style={{height:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#0C1929',flexDirection:'column',gap:16}}><img src={LOGO} alt="" style={{width:64,borderRadius:12}}/><div style={{width:28,height:28,border:'2px solid rgba(255,255,255,0.2)',borderTopColor:'#fff',borderRadius:'50%',animation:'spin 0.7s linear infinite'}}/><div style={{color:'rgba(255,255,255,0.6)',fontSize:13}}>Loading farm data…</div><style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style></div>);

  const pageTitle=ALL_NAV.find(n=>n.id===page)?.label||'ForgeOS';

  // ── PAGES ────────────────────────────────────────────────
  const S={card:{background:T.surface,border:`0.5px solid ${T.border}`,borderRadius:14,padding:'14px 16px',marginBottom:10,color:T.text} as any};

  const pages:Record<string,React.ReactNode>={
    dashboard:(
      <div>
        {/* Alert bar */}
        {(overdue.length>0||printers.some(p=>p.status==='error')||lowStock.length>0)&&(
          <div style={{marginBottom:14}}>
            {printers.filter(p=>p.status==='error').map(p=>(
              <div key={p.id} style={{display:'flex',alignItems:'center',gap:10,background:'#FCEBEB',border:'1px solid #F09595',borderRadius:12,padding:'10px 14px',marginBottom:6}}>
                <div style={{width:8,height:8,borderRadius:'50%',background:'#E24B4A',flexShrink:0,boxShadow:'0 0 0 3px rgba(226,75,74,0.2)'}}/>
                <div style={{flex:1,fontSize:13,fontWeight:600,color:'#A32D2D'}}>Error: {p.name}</div>
                <span style={{fontSize:11,color:'#A32D2D'}}>{p.current_job||'—'}</span>
              </div>
            ))}
            {overdue.length>0&&(
              <div style={{display:'flex',alignItems:'center',gap:10,background:'#FAEEDA',border:'1px solid #FAC775',borderRadius:12,padding:'10px 14px',marginBottom:6}}>
                <div style={{width:8,height:8,borderRadius:'50%',background:'#EF9F27',flexShrink:0}}/>
                <div style={{flex:1,fontSize:13,fontWeight:600,color:'#854F0B'}}>{overdue.length} overdue maintenance task{overdue.length>1?'s':''}</div>
                <button onClick={()=>nav('maintenance')} style={{fontSize:12,fontWeight:700,color:'#854F0B',background:'none',border:'none',cursor:'pointer'}}>View →</button>
              </div>
            )}
            {lowStock.length>0&&(
              <div style={{display:'flex',alignItems:'center',gap:10,background:'#FFF3CD',border:'1px solid #FFDF7E',borderRadius:12,padding:'10px 14px',marginBottom:6}}>
                <div style={{width:8,height:8,borderRadius:'50%',background:'#EF9F27',flexShrink:0}}/>
                <div style={{flex:1,fontSize:13,fontWeight:600,color:'#856404'}}>{lowStock.length} spool{lowStock.length>1?'s':''} running low</div>
                <button onClick={()=>nav('filament')} style={{fontSize:12,fontWeight:700,color:'#856404',background:'none',border:'none',cursor:'pointer'}}>View →</button>
              </div>
            )}
          </div>
        )}

        {(maintenance.filter(m=>m.status==='pending_approval').length>0||workOrders.filter(w=>w.status==='pending_approval').length>0||purchases.filter(p=>p.status==='pending').length>0)&&(
          <div style={{display:'flex',alignItems:'center',gap:10,background:'#E6F1FB',border:'1px solid #85B7EB',borderRadius:12,padding:'10px 14px',marginBottom:6}}>
            <div style={{width:8,height:8,borderRadius:'50%',background:'#185FA5',flexShrink:0}}/>
            <div style={{flex:1,fontSize:13,fontWeight:600,color:'#185FA5'}}>
              {[maintenance.filter(m=>m.status==='pending_approval').length>0&&`${maintenance.filter(m=>m.status==='pending_approval').length} maintenance task(s)`,workOrders.filter(w=>w.status==='pending_approval').length>0&&`${workOrders.filter(w=>w.status==='pending_approval').length} work order(s)`,purchases.filter(p=>p.status==='pending').length>0&&`${purchases.filter(p=>p.status==='pending').length} purchase request(s)`].filter(Boolean).join(' · ')} need approval
            </div>
            <button onClick={()=>nav('approvals')} style={{fontSize:12,fontWeight:700,color:'#185FA5',background:'none',border:'none',cursor:'pointer'}}>Review →</button>
          </div>
        )}
        {(isAdmin||isManagement||isIT)&&tickets.filter(t=>t.status==='open'&&t.priority==='critical').length>0&&(
          <div style={{display:'flex',alignItems:'center',gap:10,background:'#FCEBEB',border:'1px solid #F09595',borderRadius:12,padding:'10px 14px',marginBottom:6}}>
            <div style={{width:8,height:8,borderRadius:'50%',background:'#E24B4A',flexShrink:0}}/>
            <div style={{flex:1,fontSize:13,fontWeight:600,color:'#A32D2D'}}>🚨 {tickets.filter(t=>t.status==='open'&&t.priority==='critical').length} critical IT ticket(s) open</div>
            <button onClick={()=>nav('itsupport')} style={{fontSize:12,fontWeight:700,color:'#A32D2D',background:'none',border:'none',cursor:'pointer'}}>View →</button>
          </div>
        )}
        {printers.length===0&&(
          <div style={{background:'linear-gradient(135deg,#185FA5,#0C447C)',borderRadius:16,padding:'20px',marginBottom:14,color:'white',textAlign:'center'}}>
            <div style={{fontSize:28,marginBottom:8}}>🏭</div>
            <div style={{fontSize:16,fontWeight:700,marginBottom:4}}>Welcome to ForgeOS</div>
            <div style={{fontSize:13,opacity:0.8,marginBottom:16}}>ForgeByte Technologies LLC — Print Farm Command</div>
            <button onClick={()=>{setModal('printer');setForm({});}} style={{padding:'10px 24px',background:'white',color:'#185FA5',border:'none',borderRadius:10,fontSize:14,fontWeight:700,cursor:'pointer'}}>Add Your First Printer</button>
          </div>
        )}

        {/* Stats row */}
        <div style={{display:'grid',gridTemplateColumns:'repeat(2,1fr)',gap:8,marginBottom:14}}>
          <div style={{background:'linear-gradient(135deg,#1565C0,#1D9E75)',borderRadius:14,padding:'14px',position:'relative',overflow:'hidden'}}>
            <div style={{fontSize:11,color:'rgba(255,255,255,0.75)',marginBottom:4,fontWeight:500}}>Active Printers</div>
            <div style={{fontSize:28,fontWeight:700,color:'#fff',lineHeight:1}}>{printing}</div>
            <div style={{fontSize:11,color:'rgba(255,255,255,0.7)',marginTop:4}}>of {printers.length} · {printers.length?Math.round(printing/printers.length*100):0}% util</div>
            <div style={{position:'absolute',right:-10,top:-10,width:60,height:60,borderRadius:'50%',background:'rgba(255,255,255,0.1)'}}/>
          </div>
          <div style={{background:'linear-gradient(135deg,#F57C00,#E24B4A)',borderRadius:14,padding:'14px',position:'relative',overflow:'hidden'}}>
            <div style={{fontSize:11,color:'rgba(255,255,255,0.75)',marginBottom:4,fontWeight:500}}>Inventory Value</div>
            <div style={{fontSize:28,fontWeight:700,color:'#fff',lineHeight:1}}>${invVal.toFixed(0)}</div>
            <div style={{fontSize:11,color:'rgba(255,255,255,0.7)',marginTop:4}}>{filaments.length} spools{lowStock.length>0?` · ${lowStock.length} low`:' · all stocked'}</div>
            <div style={{position:'absolute',right:-10,top:-10,width:60,height:60,borderRadius:'50%',background:'rgba(255,255,255,0.1)'}}/>
          </div>
          <div style={{background:'linear-gradient(135deg,#6A1B9A,#185FA5)',borderRadius:14,padding:'14px',position:'relative',overflow:'hidden'}}>
            <div style={{fontSize:11,color:'rgba(255,255,255,0.75)',marginBottom:4,fontWeight:500}}>Print Queue</div>
            <div style={{fontSize:28,fontWeight:700,color:'#fff',lineHeight:1}}>{queue.length}</div>
            <div style={{fontSize:11,color:'rgba(255,255,255,0.7)',marginTop:4}}>jobs pending dispatch</div>
            <div style={{position:'absolute',right:-10,top:-10,width:60,height:60,borderRadius:'50%',background:'rgba(255,255,255,0.1)'}}/>
          </div>
          <div style={{background:overdue.length>0?'linear-gradient(135deg,#C62828,#E24B4A)':'linear-gradient(135deg,#00695C,#1D9E75)',borderRadius:14,padding:'14px',position:'relative',overflow:'hidden'}}>
            <div style={{fontSize:11,color:'rgba(255,255,255,0.75)',marginBottom:4,fontWeight:500}}>Maintenance</div>
            <div style={{fontSize:28,fontWeight:700,color:'#fff',lineHeight:1}}>{overdue.length>0?overdue.length:maintenance.filter(m=>m.status==='upcoming').length}</div>
            <div style={{fontSize:11,color:'rgba(255,255,255,0.7)',marginTop:4}}>{overdue.length>0?`${overdue.length} overdue`:'upcoming tasks'}</div>
            <div style={{position:'absolute',right:-10,top:-10,width:60,height:60,borderRadius:'50%',background:'rgba(255,255,255,0.1)'}}/>
          </div>
        </div>
        {/* Live Farm */}
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
          <div style={{fontSize:15,fontWeight:700}}>Live Print Farm</div>
          <div style={{display:'flex',alignItems:'center',gap:6}}>
            <div style={{width:6,height:6,borderRadius:'50%',background:'#1D9E75',boxShadow:'0 0 0 2px rgba(29,158,117,0.3)',animation:'pulse 2s infinite'}}/>
            <span style={{fontSize:11,color:'#1D9E75',fontWeight:600}}>real-time</span>
          </div>
        </div>
        <style>{`@keyframes pulse{0%,100%{box-shadow:0 0 0 2px rgba(29,158,117,0.3)}50%{box-shadow:0 0 0 5px rgba(29,158,117,0.1)}}`}</style>

        {printers.length===0
          ?<div style={{background:'#fff',borderRadius:14,padding:28,textAlign:'center',color:'#aaa',border:'0.5px solid rgba(0,0,0,0.08)',marginBottom:14}}>No printers yet. Tap + Printer to get started.</div>
          :<div style={{marginBottom:14}}>{printers.slice(0,isMobile?4:8).map(p=><PrinterCard key={p.id} p={p}
              onDelete={(id)=>{if(window.confirm(`Remove ${p.name}?`))del('printers',id);}}
              onEdit={(p)=>{setModal('editPrinter');setForm({id:p.id,name:p.name,model:p.model,location:p.location,api_type:p.api_type||'manual',prusa_api_key:p.prusa_api_key||'',prusa_uuid:p.prusa_printer_uuid||'',prusa_local_ip:p.prusa_local_ip||'',bambu_device_id:p.bambu_device_id||'',bambu_access_code:p.bambu_access_code||'',octoprint_url:p.octoprint_url||'',octoprint_api_key:p.octoprint_api_key||'',});}}
            />)}
          </div>
        }
        {isMobile&&printers.length>4&&<button onClick={()=>nav('printers')} style={{width:'100%',padding:'12px',background:'#f0f0f0',border:'none',borderRadius:10,fontSize:13,fontWeight:600,cursor:'pointer',marginBottom:14}}>View all {printers.length} printers →</button>}

        {/* Recent Activity */}
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
          <div style={{fontSize:15,fontWeight:700}}>Recent Activity</div>
          <button onClick={()=>nav('activity')} style={{fontSize:12,color:'#185FA5',fontWeight:600,background:'none',border:'none',cursor:'pointer'}}>View all →</button>
        </div>
        <div style={{background:'#fff',borderRadius:14,padding:'4px 14px',border:'0.5px solid rgba(0,0,0,0.08)',marginBottom:14}}>
          {activity.length===0
            ?<div style={{color:'#aaa',fontSize:13,textAlign:'center',padding:'16px 0'}}>No activity yet</div>
            :activity.slice(0,5).map(a=>(
              <div key={a.id} style={{display:'flex',gap:10,padding:'10px 0',borderBottom:`0.5px solid ${T.border}`}}>
                <div style={{width:7,height:7,borderRadius:'50%',background:a.color,marginTop:4,flexShrink:0}}/>
                <div style={{flex:1,fontSize:12,color:T.textSub,lineHeight:1.5}}>{a.message}</div>
                <div style={{fontSize:11,color:'#aaa',whiteSpace:'nowrap'}}>{timeAgo(a.created_at)}</div>
              </div>
            ))
          }
        </div>

        {/* Quick actions */}
        <div style={{fontSize:15,fontWeight:700,marginBottom:10}}>Quick Actions</div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:4}}>
          {[
            {label:'Scan In',sub:'Add new filament',icon:'📷',page:'scan',bg:'linear-gradient(135deg,#185FA5,#1D9E75)'},
            {label:'Print Queue',sub:`${queue.length} jobs waiting`,icon:'▶',page:'queue',bg:'linear-gradient(135deg,#6A1B9A,#185FA5)'},
            {label:'Maintenance',sub:overdue.length>0?`${overdue.length} overdue`:'Schedule task',icon:'🔧',page:'maintenance',bg:overdue.length>0?'linear-gradient(135deg,#C62828,#E24B4A)':'linear-gradient(135deg,#E65100,#EF9F27)'},
            {label:'Approvals',sub:`${workOrders.filter(w=>w.status==='pending_approval').length+purchases.filter(p=>p.status==='pending').length} pending`,icon:'✓',page:'approvals',bg:'linear-gradient(135deg,#00695C,#1D9E75)'},
            {label:'Cost Report',sub:`$${invVal.toFixed(0)} inventory`,icon:'$',page:'costs',color:'#7F77DD'},
          ].map(a=>(
            <button key={a.page} onClick={()=>nav(a.page)} style={{background:'#fff',border:'0.5px solid rgba(0,0,0,0.08)',borderRadius:14,padding:'14px',cursor:'pointer',textAlign:'left',transition:'all 0.15s'}}>
              <div style={{fontSize:20,marginBottom:6}}>{a.icon}</div>
              <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:2}}>{a.label}</div>
              <div style={{fontSize:11,color:T.textMuted}}>{a.sub}</div>
            </button>
          ))}
        </div>
      </div>
    ),


    printers:(
      <div>
        {/* Farm overview header */}
        <div style={{background:'linear-gradient(135deg,#0F2D5E 0%,#185FA5 50%,#1D9E75 100%)',borderRadius:18,padding:'18px 20px',marginBottom:16,color:'white',position:'relative',overflow:'hidden'}}>
          <div style={{position:'absolute',right:-20,top:-20,width:100,height:100,borderRadius:'50%',background:'rgba(255,255,255,0.06)'}}/>
          <div style={{position:'absolute',right:30,bottom:-30,width:70,height:70,borderRadius:'50%',background:'rgba(255,255,255,0.04)'}}/>
          <div style={{fontSize:11,color:'rgba(255,255,255,0.6)',fontWeight:600,letterSpacing:'1px',textTransform:'uppercase',marginBottom:10}}>Print Farm Overview</div>
          <div style={{display:'flex',gap:20,flexWrap:'wrap'}}>
            {[
              {n:printers.length,label:'Total',color:'rgba(255,255,255,0.9)'},
              {n:printing,label:'Printing',color:'#6EE7B7'},
              {n:printers.filter(p=>p.status==='idle').length,label:'Idle',color:'rgba(255,255,255,0.6)'},
              {n:printers.filter(p=>p.status==='error').length,label:'Error',color:'#FCA5A5'},
              {n:printers.filter(p=>p.status==='paused').length,label:'Paused',color:'#FDE68A'},
            ].map(s=>(
              <div key={s.label} style={{textAlign:'center'}}>
                <div style={{fontSize:s.label==='Total'?30:22,fontWeight:800,color:s.color,lineHeight:1}}>{s.n}</div>
                <div style={{fontSize:10,color:'rgba(255,255,255,0.5)',marginTop:2}}>{s.label}</div>
              </div>
            ))}
            <div style={{flex:1,display:'flex',alignItems:'flex-end',justifyContent:'flex-end'}}>
              <div style={{textAlign:'right'}}>
                <div style={{fontSize:18,fontWeight:700,color:'rgba(255,255,255,0.9)'}}>{printers.length?Math.round(printing/printers.length*100):0}%</div>
                <div style={{fontSize:10,color:'rgba(255,255,255,0.5)'}}>Utilization</div>
              </div>
            </div>
          </div>
          {/* Utilization bar */}
          {printers.length>0&&(
            <div style={{marginTop:12,height:4,background:'rgba(255,255,255,0.15)',borderRadius:999,overflow:'hidden'}}>
              <div style={{height:'100%',borderRadius:999,background:'linear-gradient(90deg,#6EE7B7,#34D399)',width:`${Math.round(printing/printers.length*100)}%`,transition:'width 1s'}}/>
            </div>
          )}
        </div>

        {/* Action buttons */}
        <div style={{display:'flex',gap:8,marginBottom:16}}>
          <button onClick={()=>{setModal('prusaConnect');setForm({});}} style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',gap:6,padding:'11px',background:'#FFF3E0',color:'#E65100',border:'1.5px solid #FFB74D',borderRadius:12,fontSize:13,fontWeight:700,cursor:'pointer'}}>
            <span style={{fontSize:16}}>🟠</span> + Prusa Connect
          </button>
          <button onClick={()=>{setModal('printer');setForm({});}} style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',gap:6,padding:'11px',background:'#185FA5',color:'#fff',border:'none',borderRadius:12,fontSize:13,fontWeight:700,cursor:'pointer'}}>
            {I.add} Add Printer
          </button>
        </div>

        {/* Printer cards */}
        {printers.length===0?(
          <div style={{background:T.surface,borderRadius:16,padding:48,textAlign:'center',border:`1px dashed ${T.border}`}}>
            <div style={{fontSize:40,marginBottom:12}}>🖨</div>
            <div style={{fontSize:16,fontWeight:700,color:T.text,marginBottom:6}}>No printers added yet</div>
            <div style={{fontSize:13,color:T.textMuted,marginBottom:20}}>Add your Prusa, Bambu, or any printer to start monitoring your farm in real time</div>
            <button onClick={()=>{setModal('printer');setForm({});}} style={{padding:'12px 24px',background:'#185FA5',color:'#fff',border:'none',borderRadius:12,fontSize:14,fontWeight:700,cursor:'pointer'}}>Add First Printer</button>
          </div>
        ):(
          <div>
            {/* Errors first */}
            {printers.filter(p=>p.status==='error').map(p=>(
              <PrinterCard key={p.id} p={p}
                onDelete={(id)=>del('printers',id)}
                onEdit={(p)=>{setModal('editPrinter');setForm({id:p.id,name:p.name,model:p.model,location:p.location,api_type:p.api_type||'manual',prusa_api_key:p.prusa_api_key||'',prusa_uuid:p.prusa_printer_uuid||'',prusa_local_ip:p.prusa_local_ip||'',bambu_device_id:p.bambu_device_id||'',bambu_access_code:p.bambu_access_code||'',octoprint_url:p.octoprint_url||'',octoprint_api_key:p.octoprint_api_key||'',});}}
              />
            ))}
            {/* Printing */}
            {printers.filter(p=>p.status==='printing').map(p=>(
              <PrinterCard key={p.id} p={p}
                onDelete={(id)=>del('printers',id)}
                onEdit={(p)=>{setModal('editPrinter');setForm({id:p.id,name:p.name,model:p.model,location:p.location,api_type:p.api_type||'manual',prusa_api_key:p.prusa_api_key||'',prusa_uuid:p.prusa_printer_uuid||'',prusa_local_ip:p.prusa_local_ip||'',bambu_device_id:p.bambu_device_id||'',bambu_access_code:p.bambu_access_code||'',octoprint_url:p.octoprint_url||'',octoprint_api_key:p.octoprint_api_key||'',});}}
              />
            ))}
            {/* Paused */}
            {printers.filter(p=>p.status==='paused').map(p=>(
              <PrinterCard key={p.id} p={p}
                onDelete={(id)=>del('printers',id)}
                onEdit={(p)=>{setModal('editPrinter');setForm({id:p.id,name:p.name,model:p.model,location:p.location,api_type:p.api_type||'manual',prusa_api_key:p.prusa_api_key||'',prusa_uuid:p.prusa_printer_uuid||'',prusa_local_ip:p.prusa_local_ip||'',bambu_device_id:p.bambu_device_id||'',bambu_access_code:p.bambu_access_code||'',octoprint_url:p.octoprint_url||'',octoprint_api_key:p.octoprint_api_key||'',});}}
              />
            ))}
            {/* Idle & offline */}
            {printers.filter(p=>p.status==='idle'||p.status==='offline').map(p=>(
              <PrinterCard key={p.id} p={p}
                onDelete={(id)=>del('printers',id)}
                onEdit={(p)=>{setModal('editPrinter');setForm({id:p.id,name:p.name,model:p.model,location:p.location,api_type:p.api_type||'manual',prusa_api_key:p.prusa_api_key||'',prusa_uuid:p.prusa_printer_uuid||'',prusa_local_ip:p.prusa_local_ip||'',bambu_device_id:p.bambu_device_id||'',bambu_access_code:p.bambu_access_code||'',octoprint_url:p.octoprint_url||'',octoprint_api_key:p.octoprint_api_key||'',});}}
              />
            ))}
          </div>
        )}
      </div>
    ),



    filament:(
      <div>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
          <div style={{fontSize:18,fontWeight:700}}>Filament</div>
          <button onClick={()=>{setModal('filament');setForm({});}} style={{display:'flex',alignItems:'center',gap:6,padding:'8px 14px',background:'#185FA5',color:'#fff',border:'none',borderRadius:10,fontSize:13,fontWeight:600,cursor:'pointer'}}>{I.add}Add Spool</button>
        </div>
        <input value={filSearch} onChange={e=>setFilSearch(e.target.value)} placeholder="Search filament…" style={{width:'100%',padding:'11px 14px',fontSize:14,border:'1px solid #e0e0e0',borderRadius:10,marginBottom:10,outline:'none',fontFamily:'inherit'}}/>
        <div style={{display:'flex',gap:6,overflowX:'auto',paddingBottom:8,marginBottom:12}}>
          {['All',...new Set(filaments.map(f=>f.material))].map(m=>(
            <button key={m} onClick={()=>setFilFilter(m)} style={{padding:'6px 14px',borderRadius:20,border:'none',background:filFilter===m?T.blue:T.statBg,color:filFilter===m?'#fff':T.text,fontSize:12,fontWeight:600,cursor:'pointer',whiteSpace:'nowrap'}}>{m}</button>
          ))}
        </div>
        {filaments.length===0?<div style={{...S.card,textAlign:'center',color:'#aaa',padding:40}}>No filament added yet.</div>:
          filaments.filter(f=>(filFilter==='All'||f.material===filFilter)&&(!filSearch||`${f.material}${f.brand}${f.color}${f.location}`.toLowerCase().includes(filSearch.toLowerCase()))).map(f=>{
            const mb=matBadge[f.material]||{bg:'#f0f0f0',color:T.textSub};
            return(
              <div key={f.id} style={{...S.card}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:10}}>
                  <div style={{flex:1}}>
                    <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:6}}>
                      <span style={{background:mb.bg,color:mb.color,padding:'3px 8px',borderRadius:20,fontSize:11,fontWeight:700}}>{f.material}</span>
                      <div style={{width:10,height:10,borderRadius:'50%',background:COLORS[f.color]||'#888',border:'0.5px solid rgba(0,0,0,0.1)'}}/>
                      <span style={{fontSize:13,fontWeight:600}}>{f.brand} · {f.color}</span>
                    </div>
                    <div style={{display:'flex',alignItems:'center',gap:8}}>
                      <div style={{flex:1,height:8,background:'#f0f0f0',borderRadius:4,overflow:'hidden'}}>
                        <div style={{height:'100%',borderRadius:4,background:f.remaining_pct<20?'#E24B4A':'#185FA5',width:`${f.remaining_pct}%`}}/>
                      </div>
                      <span style={{fontSize:13,fontWeight:700,color:f.remaining_pct<20?'#E24B4A':'#333',minWidth:36}}>{f.remaining_pct}%</span>
                    </div>
                  </div>
                  <div style={{display:'flex',gap:6,flexShrink:0,marginLeft:8}}>
                    <button onClick={()=>{setModal('filament');setForm({id:f.id,editing:true,material:f.material,brand:f.brand,color:f.color,weight:f.weight_g,diameter:f.diameter||'1.75mm',cost:f.cost_per_kg,purchase_price:f.purchase_price||0,supplier:f.supplier||'',location:f.location,notes:f.notes||'',barcode:f.barcode});}} style={{background:'#E6F1FB',border:'none',borderRadius:8,width:32,height:32,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}} title="Edit spool">
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#185FA5" strokeWidth="2.5" strokeLinecap="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                    </button>
                    <button onClick={()=>{setModal('adjustFilament');setForm({id:f.id,remaining:f.remaining_pct,weight:f.weight_g,brand:f.brand,material:f.material,color:f.color});}} style={{background:'#f0f7ff',border:'none',borderRadius:8,width:32,height:32,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}} title="Adjust remaining">
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#185FA5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/></svg>
                    </button>
                    <button onClick={()=>del('filaments',f.id)} style={{background:'#f8f8f7',border:'none',borderRadius:8,width:32,height:32,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>
                    </button>
                  </div>
                </div>
                <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:6}}>
                  {[
                    ['Weight',`${f.weight_g}g`],
                    ['Diameter',f.diameter||'1.75mm'],
                    ['Cost/kg',`$${(f.cost_per_kg||0).toFixed(2)}`],
                    ['Purchase',f.purchase_price>0?`$${parseFloat(f.purchase_price).toFixed(2)}`:'—'],
                    ['Location',f.location||'—'],
                    ['Supplier',f.supplier||'—'],
                  ].map(([l,v])=>(
                    <div key={l} style={{background:T.statBg,borderRadius:8,padding:'6px 8px'}}>
                      <div style={{fontSize:10,color:'#aaa',marginBottom:2}}>{l}</div>
                      <div style={{fontSize:12,fontWeight:600,color:T.textSub,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{v}</div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })
        }
      </div>
    ),

    scan:(
      <div>
        <div style={{fontSize:18,fontWeight:700,marginBottom:16}}>Scan In</div>
        <button onClick={()=>{setBcResult({type:'scanning'});scanWithCamera(c=>{
  const code=c.trim().replace(/\s+/g,'');
  setBcInput(code);
  if(navigator.vibrate)navigator.vibrate(100);
  // Normalize stored barcodes too when searching
  const norm=(s:string)=>(s||'').trim().replace(/\s+/g,'');
  const f=filaments.find(x=>norm(x.barcode)===code);
  const e=equipment.find(x=>norm(x.barcode)===code);
  if(f){
    setBcResult({type:'filament',data:f,barcode:code});
  } else if(e){
    setBcResult({type:'equipment',data:e,barcode:code});
  } else {
    setBcResult({type:'notfound'});
    setForm({barcode:code,material:'PLA',weight:1000,cost:24.99});
    if(navigator.vibrate)navigator.vibrate([100,50,100]);
  }
},m=>setBcResult({type:'error',msg:m}));}}
          style={{width:'100%',background:'#185FA5',color:'#fff',border:'none',borderRadius:14,padding:'20px',marginBottom:14,cursor:'pointer',display:'flex',flexDirection:'column',alignItems:'center',gap:10}}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round"><path d="M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2"/><line x1="3" y1="12" x2="21" y2="12"/></svg>
          <div style={{fontSize:16,fontWeight:700}}>Tap to Scan Barcode</div>
          <div style={{fontSize:12,opacity:0.8}}>Uses your device camera</div>
        </button>
        {bcResult?.type==='scanning'&&<div style={{background:'#E6F1FB',color:'#185FA5',padding:'12px 14px',borderRadius:10,marginBottom:12,fontSize:13,fontWeight:500,textAlign:'center'}}>📷 Camera active — point at barcode…</div>}
        {bcResult?.type==='error'&&<div style={{background:'#FAEEDA',color:'#854F0B',padding:'12px 14px',borderRadius:10,marginBottom:12,fontSize:13}}>{bcResult.msg}</div>}
        {bcResult?.type==='filament'&&<div style={{background:'#E1F5EE',color:'#085041',padding:'14px',borderRadius:12,marginBottom:12}}>
          <div style={{fontWeight:700,fontSize:14,marginBottom:4}}>✓ Found in inventory</div>
          <div style={{fontSize:13,marginBottom:10}}>{bcResult.data.brand} {bcResult.data.material} {bcResult.data.color} · {bcResult.data.remaining_pct}% remaining · {bcResult.data.location}</div>
          <div style={{fontSize:12,color:'#0F6E56',marginBottom:8}}>Have another spool with this same barcode?</div>
          <button onClick={()=>{
            setForm({barcode:bcResult.barcode,material:bcResult.data.material,brand:bcResult.data.brand,color:bcResult.data.color,weight:bcResult.data.weight_g,cost:bcResult.data.cost_per_kg,location:bcResult.data.location});
            setBcResult({type:'addanother',data:bcResult.data});
          }} style={{width:'100%',padding:'10px',background:'#085041',color:'#fff',border:'none',borderRadius:10,fontSize:13,fontWeight:700,cursor:'pointer'}}>+ Add Another Spool of This</button>
        </div>}
        {bcResult?.type==='addanother'&&<div style={{background:'#E6F1FB',color:'#185FA5',padding:'12px 14px',borderRadius:10,marginBottom:12,fontSize:13}}>
          Form pre-filled with {bcResult.data.brand} {bcResult.data.material} {bcResult.data.color} — update any details below and tap Add.
        </div>}
        {bcResult?.type==='equipment'&&<div style={{background:'#E1F5EE',color:'#085041',padding:'14px',borderRadius:12,marginBottom:12}}>
          <div style={{fontWeight:700,fontSize:14,marginBottom:4}}>✓ Found in inventory</div>
          <div style={{fontSize:13,marginBottom:10}}>{bcResult.data.name} · Qty: {bcResult.data.quantity} · {bcResult.data.location}</div>
          <div style={{fontSize:12,color:'#0F6E56',marginBottom:8}}>Have more of the same item?</div>
          <button onClick={()=>{setForm({barcode:bcInput,name:bcResult.data.name,type:bcResult.data.type,serial:bcResult.data.serial_number,qty:1,location:bcResult.data.location});setModal('equipment');}} style={{width:'100%',padding:'10px',background:'#085041',color:'#fff',border:'none',borderRadius:10,fontSize:13,fontWeight:700,cursor:'pointer'}}>+ Add Another of This Item</button>
        </div>}
        {bcResult?.type==='notfound'&&<div style={{background:'#FAEEDA',color:'#854F0B',padding:'14px',borderRadius:12,marginBottom:12}}>
          <div style={{fontWeight:700,fontSize:14,marginBottom:6}}>New barcode — {bcInput}</div>
          <div style={{fontSize:12,marginBottom:10}}>Not in inventory yet. Fill in details below and tap Add to save it.</div>
          <button onClick={()=>{setModal('filament');setForm({barcode:bcInput});}} style={{width:'100%',padding:'12px',background:'#854F0B',color:'#fff',border:'none',borderRadius:10,fontSize:14,fontWeight:700,cursor:'pointer'}}>+ Add This Item to Inventory</button>
        </div>}
        <div style={{...S.card}}>
          <div style={{fontSize:15,fontWeight:700,marginBottom:4}}>Quick Add — New Spool</div>
          {bcInput&&<div style={{fontSize:11,color:T.textMuted,marginBottom:12,fontFamily:'monospace',background:T.surfaceAlt,padding:'6px 10px',borderRadius:6}}>Barcode: {bcInput}</div>}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:10}}>
            <div><label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Material</label><select value={form.material||'PLA'} onChange={e=>setForm((f:any)=>({...f,material:e.target.value}))} style={{width:'100%',padding:'10px 12px',fontSize:14,border:'1px solid #e0e0e0',borderRadius:10,fontFamily:'inherit',outline:'none'}}><option>PLA</option><option>ABS</option><option>PETG</option><option>TPU</option><option>ASA</option><option>Nylon</option></select></div>
            <div><label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Brand</label><input type="text" value={form.brand||''} onChange={e=>setForm((f:any)=>({...f,brand:e.target.value}))} placeholder="Hatchbox" style={{width:'100%',padding:'10px 12px',fontSize:14,border:'1px solid #e0e0e0',borderRadius:10,fontFamily:'inherit',outline:'none'}}/></div>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:10}}>
            <div><label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Color</label><input type="text" value={form.color||''} onChange={e=>setForm((f:any)=>({...f,color:e.target.value}))} placeholder="Black" style={{width:'100%',padding:'10px 12px',fontSize:14,border:'1px solid #e0e0e0',borderRadius:10,fontFamily:'inherit',outline:'none'}}/></div>
            <div><label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Weight (g)</label><input type="number" value={form.weight||1000} onChange={e=>setForm((f:any)=>({...f,weight:e.target.value}))} style={{width:'100%',padding:'10px 12px',fontSize:14,border:'1px solid #e0e0e0',borderRadius:10,fontFamily:'inherit',outline:'none'}}/></div>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:14}}>
            <div><label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Cost/kg ($)</label><input type="number" value={form.cost||24.99} onChange={e=>setForm((f:any)=>({...f,cost:e.target.value}))} style={{width:'100%',padding:'10px 12px',fontSize:14,border:'1px solid #e0e0e0',borderRadius:10,fontFamily:'inherit',outline:'none'}}/></div>
            <div><label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Location</label><input type="text" value={form.location||''} onChange={e=>setForm((f:any)=>({...f,location:e.target.value}))} placeholder="Shelf A" style={{width:'100%',padding:'10px 12px',fontSize:14,border:'1px solid #e0e0e0',borderRadius:10,fontFamily:'inherit',outline:'none'}}/></div>
          </div>
          <button onClick={async()=>{
            const now=new Date().toISOString();
            const mat=form.material||'PLA';
            const brand=form.brand||'Unknown';
            const color=form.color||'Natural';
            if(!brand||brand==='Unknown'){showToast('Please enter a brand name');return;}
            await addDoc(collection(db,'filaments'),{
              material:mat,brand,color,
              weight_g:parseInt(form.weight)||1000,
              remaining_pct:100,
              cost_per_kg:parseFloat(form.cost)||24.99,
              location:form.location||'Unassigned',
              barcode:form.barcode||bcInput||`SCAN-${Date.now()}`,
              added_at:now
            });
            await addAct(`Scanned & added: ${mat} ${color} spool (${brand})`,'#378ADD');
            showToast(`✓ ${brand} ${mat} ${color} added to inventory!`);
            setBcInput('');setBcResult(null);setForm({material:'PLA',weight:1000,cost:24.99});
          }} style={{width:'100%',padding:'14px',background:'#1D9E75',color:'#fff',border:'none',borderRadius:12,fontSize:15,fontWeight:700,cursor:'pointer'}}>Add Spool to Inventory</button>
        </div>
      </div>
    ),

    queue:(
      <div>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14}}>
          <div style={{fontSize:18,fontWeight:700}}>Print Queue</div>
          <button onClick={()=>{setModal('queue');setForm({});}} style={{display:'flex',alignItems:'center',gap:6,padding:'8px 14px',background:'#185FA5',color:'#fff',border:'none',borderRadius:10,fontSize:13,fontWeight:600,cursor:'pointer'}}>{I.add}Add Job</button>
        </div>
        <div style={{background:'#E6F1FB',color:'#185FA5',padding:'10px 14px',borderRadius:10,marginBottom:12,fontSize:13}}>Tap ▶ to dispatch a job to the next idle printer.</div>
        {queue.length===0?<div style={{...S.card,textAlign:'center',color:'#aaa',padding:40}}>Queue is empty. Add jobs to get started.</div>:queue.map(q=>(
          <div key={q.id} style={{...S.card,display:'flex',alignItems:'center',gap:12}}>
            <div style={{width:10,height:10,borderRadius:'50%',background:q.priority==='high'?'#E24B4A':q.priority==='normal'?'#185FA5':'#888',flexShrink:0}}/>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:13,fontWeight:700,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{q.job_name}</div>
              <div style={{fontSize:11,color:T.textMuted,marginTop:2}}>{q.material} · {fmtDur(q.est_duration_min)} · {q.est_filament_g}g{q.notes?' · '+q.notes:''}</div>
            </div>
            <div style={{display:'flex',gap:6,flexShrink:0}}>
              <button onClick={()=>startJob(q.id)} style={{width:36,height:36,background:'#1D9E75',color:'#fff',border:'none',borderRadius:10,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="white"><polygon points="5 3 19 12 5 21 5 3"/></svg>
              </button>
              <button onClick={()=>del('print_queue',q.id)} style={{width:36,height:36,background:'#f8f8f7',border:'none',borderRadius:10,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
          </div>
        ))}
      </div>
    ),

    maintenance:(
      <div>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14}}>
          <div style={{fontSize:18,fontWeight:700}}>Maintenance</div>
          <button onClick={()=>{setModal('maintenance');setForm({});}} style={{display:'flex',alignItems:'center',gap:6,padding:'8px 14px',background:'#185FA5',color:'#fff',border:'none',borderRadius:10,fontSize:13,fontWeight:600,cursor:'pointer'}}>{I.add}Schedule</button>
        </div>
        <div style={{display:'flex',gap:6,marginBottom:14,overflowX:'auto',paddingBottom:2}}>
          {['upcoming','overdue','pending_approval','completed'].map(t=>(
            <button key={t} onClick={()=>setMaintTab(t)} style={{flexShrink:0,padding:'9px 10px',borderRadius:10,border:'none',background:maintTab===t?T.blue:T.statBg,color:maintTab===t?'#fff':T.text,fontSize:11,fontWeight:600,cursor:'pointer',whiteSpace:'nowrap',position:'relative'}}>
              {t==='pending_approval'?'Pending Approval':t.charAt(0).toUpperCase()+t.slice(1)}
              {t==='pending_approval'&&maintenance.filter(m=>m.status==='pending_approval').length>0&&<span style={{marginLeft:4,background:'#EF9F27',color:'#fff',borderRadius:10,padding:'0 5px',fontSize:10}}>{maintenance.filter(m=>m.status==='pending_approval').length}</span>}
              {t!=='pending_approval'&&<span style={{marginLeft:4,opacity:0.7}}>({maintenance.filter(m=>m.status===t).length})</span>}
            </button>
          ))}
        </div>
        {maintenance.filter(m=>m.status===maintTab).length===0
          ?<div style={{...S.card,textAlign:'center',color:'#aaa',padding:40}}>No {maintTab} tasks.</div>
          :maintenance.filter(m=>m.status===maintTab).map(m=>{
            const uc:{[k:string]:string}={high:'#E24B4A',med:'#EF9F27',low:'#1D9E75'};
            return(
              <div key={m.id} style={{background:'#fff',borderLeft:`4px solid ${uc[m.urgency]||'#888'}`,borderRadius:'0 14px 14px 0',border:'0.5px solid rgba(0,0,0,0.08)',borderLeftWidth:4,borderLeftColor:uc[m.urgency]||'#888',padding:14,marginBottom:8}}>
                <div style={{display:'flex',alignItems:'flex-start',gap:12}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:14,fontWeight:700}}>{m.task}</div>
                    <div style={{fontSize:12,color:T.textMuted,marginTop:3}}>{m.printer_name}{m.notes?' · '+m.notes:''}</div>
                    <div style={{display:'flex',gap:8,marginTop:6,alignItems:'center'}}>
                      <span style={{fontSize:11,fontWeight:600,padding:'2px 8px',borderRadius:20,background:uc[m.urgency]+'20',color:uc[m.urgency]}}>{m.urgency==='high'?'High':m.urgency==='med'?'Medium':'Low'} Priority</span>
                      <span style={{fontSize:11,color:m.status==='overdue'?'#E24B4A':'#aaa',fontWeight:500}}>Due: {m.due_date}</span>
                    </div>
                  </div>
                  <div style={{display:'flex',flexDirection:'column',gap:6,alignItems:'flex-end',flexShrink:0}}>
                    {(m.status==='upcoming'||m.status==='overdue')&&<button onClick={()=>doneMaint(m.id)} style={{padding:'7px 14px',background:'#1D9E75',color:'#fff',border:'none',borderRadius:8,fontSize:12,fontWeight:700,cursor:'pointer'}}>✓ Submit</button>}
                    {m.status==='pending_approval'&&canApprove&&<button onClick={()=>approveMaint(m.id)} style={{padding:'7px 14px',background:'#185FA5',color:'#fff',border:'none',borderRadius:8,fontSize:12,fontWeight:700,cursor:'pointer'}}>✓ Approve</button>}
                    {m.status==='pending_approval'&&!canApprove&&<span style={{fontSize:11,color:'#EF9F27',fontWeight:600}}>Awaiting approval</span>}
                    <div style={{display:'flex',gap:6}}>
                      <button onClick={()=>{setModal('maintenance');setForm({id:m.id,printer_name:m.printer_name,task:m.task,due_date:m.due_date,urgency:m.urgency,notes:m.notes||'',editing:true});}} style={{width:30,height:30,background:'#E6F1FB',border:'none',borderRadius:8,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#185FA5" strokeWidth="2.5" strokeLinecap="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                      </button>
                      <button onClick={()=>del('maintenance',m.id)} style={{width:30,height:30,background:'#f8f8f7',border:'none',borderRadius:8,cursor:'pointer',fontSize:13,color:'#aaa'}}>✕</button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        }
      </div>
    ),

    equipment:(
      <div>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
          <div style={{fontSize:18,fontWeight:700}}>Equipment</div>
          <button onClick={()=>{setModal('equipment');setForm({});}} style={{display:'flex',alignItems:'center',gap:6,padding:'8px 14px',background:'#185FA5',color:'#fff',border:'none',borderRadius:10,fontSize:13,fontWeight:600,cursor:'pointer'}}>{I.add}Add</button>
        </div>
        <input value={eqSearch} onChange={e=>setEqSearch(e.target.value)} placeholder="Search equipment…" style={{width:'100%',padding:'11px 14px',fontSize:14,border:`1px solid ${T.inputBorder}`,borderRadius:10,marginBottom:12,outline:'none',fontFamily:'inherit',background:T.input,color:T.text}}/>
        <div style={{display:'flex',gap:6,overflowX:'auto',paddingBottom:4,marginBottom:12}}>
          {['All',...new Set(equipment.map(e=>e.type))].map(t=>(
            <button key={t} onClick={()=>setEqFilter&&setEqFilter(t)} style={{padding:'5px 12px',borderRadius:20,border:'none',background:eqFilter===t?'#185FA5':'#f0f0f0',color:eqFilter===t?'#fff':'#555',fontSize:12,fontWeight:600,cursor:'pointer',whiteSpace:'nowrap'}}>{t}</button>
          ))}
        </div>
        {equipment.length===0?<div style={{...S.card,textAlign:'center',color:'#aaa',padding:40}}>No equipment added yet.</div>:
          equipment.filter(e=>{
            const matchSearch=!eqSearch||`${e.name}${e.type}${e.serial_number}${e.location}`.toLowerCase().includes(eqSearch.toLowerCase());
            const matchFilter=!eqFilter||eqFilter==='All'||(e.type===eqFilter);
            return matchSearch&&matchFilter;
          }).map(e=>(
            <div key={e.id} style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,padding:14,marginBottom:8}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:10}}>
                <div style={{flex:1}}>
                  <div style={{fontSize:14,fontWeight:700}}>{e.name}</div>
                  <span style={{background:'#E6F1FB',color:'#185FA5',padding:'2px 8px',borderRadius:20,fontSize:11,fontWeight:600,marginTop:4,display:'inline-block'}}>{e.type}</span>
                </div>
                <div style={{display:'flex',gap:6,flexShrink:0}}>
                  <button onClick={()=>{setModal('equipment');setForm({id:e.id,name:e.name,type:e.type,serial:e.serial_number,qty:e.quantity,location:e.location,barcode:e.barcode,editing:true});}} style={{width:30,height:30,background:'#E6F1FB',border:'none',borderRadius:8,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#185FA5" strokeWidth="2.5" strokeLinecap="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                  </button>
                  <button onClick={()=>del('equipment',e.id)} style={{width:30,height:30,background:'#f8f8f7',border:'none',borderRadius:8,cursor:'pointer',fontSize:13,color:'#aaa'}}>✕</button>
                </div>
              </div>
              <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:6,marginBottom:4}}>
                {[
                    ['Serial',e.serial_number||'—'],
                    ['Qty',String(e.quantity||0)],
                    ['Unit Cost',e.unit_cost>0?`$${parseFloat(e.unit_cost).toFixed(2)}`:'—'],
                    ['Total Value',e.total_value>0?`$${parseFloat(e.total_value).toFixed(2)}`:e.unit_cost>0?`$${(parseFloat(e.unit_cost)*(e.quantity||1)).toFixed(2)}`:'—'],
                    ['Location',e.location||'—'],
                    ['Supplier',e.supplier||'—'],
                  ].map(([l,v])=>(
                  <div key={l} style={{background:'#f8f8f7',borderRadius:8,padding:'7px 10px'}}>
                    <div style={{fontSize:10,color:'#aaa',marginBottom:2}}>{l}</div>
                    <div style={{fontSize:12,fontWeight:600,color:T.textSub,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{v}</div>
                  </div>
                ))}
                {e.purchase_date&&<div style={{gridColumn:'1/-1',fontSize:11,color:T.textMuted,marginTop:2}}>📅 Purchased: {e.purchase_date}{e.notes?<span style={{marginLeft:8,color:T.textMuted}}>· {e.notes}</span>:null}</div>}
              </div>
            </div>
          ))
        }
      </div>
    ),

    costs:(()=>{
      const completedJobs=history.filter(j=>j.status==='completed');
      const totalMatCost=completedJobs.reduce((s,j)=>s+jobCost(j.filament_used_g||0,j.material,filaments),0);
      const totalGrams=completedJobs.reduce((s,j)=>s+(j.filament_used_g||0),0);
      const avgJobCost=completedJobs.length?totalMatCost/completedJobs.length:0;
      const eqTotalValue=equipment.reduce((s,e)=>s+(e.total_value||e.unit_cost*e.quantity||0),0);
      const maintTotalCost=maintenance.filter(m=>m.status==='completed').reduce((s,m)=>s+(m.parts_cost||0),0);
      const maintPending=maintenance.filter(m=>m.status!=='completed').reduce((s,m)=>s+(m.parts_cost||0),0);
      const printersTotalValue=printers.reduce((s,p)=>s+(p.purchase_price||0),0);
      const grandTotal=invVal+eqTotalValue+totalMatCost+maintTotalCost+printersTotalValue;

      // By material usage
      const byMat:Record<string,number>={};
      completedJobs.forEach(j=>{const m=j.material||'Unknown';byMat[m]=(byMat[m]||0)+(j.filament_used_g||0);});
      const matEntries=Object.entries(byMat).sort((a,b)=>b[1]-a[1]);
      const matClrs:Record<string,string>={PLA:'#185FA5','PLA+':'#378ADD',PETG:'#1D9E75','PETG-CF':'#0F6E56',ABS:'#E24B4A',ASA:'#D85A30',TPU:'#EF9F27',TPE:'#FAC775',Nylon:'#7F77DD','Nylon-CF':'#5A53C4',PC:'#D4537E','Wood Fill':'#A67C52','Metal Fill':'#888780',Unknown:'#aaa'};
      const getClr=(m:string)=>matClrs[m]||'#'+((parseInt(m.charCodeAt(0).toString())*1234567)%0xFFFFFF).toString(16).padStart(6,'0');

      // Monthly trend
      const now2=new Date();
      const months=Array.from({length:6},(_,i)=>{const d=new Date(now2.getFullYear(),now2.getMonth()-5+i,1);return{label:d.toLocaleString('default',{month:'short'}),yr:d.getFullYear(),mo:d.getMonth()};});
      const monthly=months.map(m=>({
        ...m,
        filCost:completedJobs.filter(j=>{const d=new Date(j.completed_at||'');return d.getFullYear()===m.yr&&d.getMonth()===m.mo;}).reduce((s,j)=>s+jobCost(j.filament_used_g||0,j.material,filaments),0),
        maintCost:maintenance.filter(mnt=>{if(!mnt.completed_at)return false;const d=new Date(mnt.completed_at);return d.getFullYear()===m.yr&&d.getMonth()===m.mo;}).reduce((s,mnt)=>s+(mnt.parts_cost||0),0),
      }));
      const maxBar=Math.max(...monthly.map(m=>m.filCost+m.maintCost),1);

      // Runout predictions
      const preds=filaments.map(f=>{
        const days2=history.length>1?(()=>{const oldest=history[history.length-1]?.completed_at;if(!oldest)return 0;const dys=Math.max(1,(Date.now()-new Date(oldest).getTime())/86400000);const used=completedJobs.filter(j=>j.material===f.material).reduce((s,j)=>s+(j.filament_used_g||0),0);return used/dys;})():0;
        const left=f.weight_g*(f.remaining_pct/100);
        return{...f,left:Math.round(left),gpd:Math.round(days2*10)/10,days:days2>0?Math.floor(left/days2):null};
      }).sort((a,b)=>(a.days||9999)-(b.days||9999));

      // Pie chart
      const Pie=({data,size=120}:{data:{l:string,v:number,c:string}[],size?:number})=>{
        const tot=data.reduce((s,d)=>s+d.v,0);
        if(tot===0)return<div style={{width:size,height:size,borderRadius:'50%',background:'#f0f0f0',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,color:'#aaa'}}>No data</div>;
        let ang=-90;
        return<svg width={size} height={size}>{data.map((d,i)=>{const pct=d.v/tot;const sa=ang;ang+=pct*360;const r=size/2-4;const cx=size/2;const cy=size/2;const x1=cx+r*Math.cos(sa*Math.PI/180);const y1=cy+r*Math.sin(sa*Math.PI/180);const x2=cx+r*Math.cos(ang*Math.PI/180);const y2=cy+r*Math.sin(ang*Math.PI/180);return<path key={i} d={`M${cx},${cy} L${x1},${y1} A${r},${r} 0 ${pct>0.5?1:0},1 ${x2},${y2} Z`} fill={d.c} stroke="#fff" strokeWidth="1.5"/>;})}<circle cx={size/2} cy={size/2} r={size/4} fill="white"/></svg>;
      };

      return(
        <div>
          <div style={{fontSize:18,fontWeight:700,marginBottom:14,color:T.text}}>Cost Tracking</div>

          {/* Grand total banner */}
          <div style={{background:'linear-gradient(135deg,#185FA5,#0C447C)',borderRadius:16,padding:'16px 20px',marginBottom:14,color:'white'}}>
            <div style={{fontSize:12,opacity:0.7,marginBottom:4}}>Total Farm Investment</div>
            <div style={{fontSize:32,fontWeight:800,marginBottom:4}}>${grandTotal.toFixed(2)}</div>
            <div style={{display:'flex',gap:12,fontSize:11,opacity:0.8,flexWrap:'wrap'}}>
              <span>Filament: ${invVal.toFixed(0)}</span>
              <span>Equipment: ${eqTotalValue.toFixed(0)}</span>
              <span>Printers: ${printersTotalValue.toFixed(0)}</span>
              <span>Maintenance: ${maintTotalCost.toFixed(0)}</span>
            </div>
          </div>

          {/* Stats grid */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:14}}>
            <div style={{background:'#fff',borderRadius:14,padding:14,border:'0.5px solid rgba(0,0,0,0.08)'}}>
              <div style={{fontSize:10,color:'#aaa',marginBottom:3,fontWeight:600,textTransform:'uppercase'}}>Filament Stock</div>
              <div style={{fontSize:22,fontWeight:700,color:'#185FA5'}}>${invVal.toFixed(0)}</div>
              <div style={{fontSize:11,color:T.textMuted,marginTop:2}}>{filaments.length} spools · {filaments.reduce((s,f)=>s+Math.round(f.weight_g*f.remaining_pct/100),0)}g total</div>
            </div>
            <div style={{background:'#fff',borderRadius:14,padding:14,border:'0.5px solid rgba(0,0,0,0.08)'}}>
              <div style={{fontSize:10,color:'#aaa',marginBottom:3,fontWeight:600,textTransform:'uppercase'}}>Equipment Value</div>
              <div style={{fontSize:22,fontWeight:700,color:'#1D9E75'}}>${eqTotalValue.toFixed(0)}</div>
              <div style={{fontSize:11,color:T.textMuted,marginTop:2}}>{equipment.length} items tracked</div>
            </div>
            <div style={{background:'#fff',borderRadius:14,padding:14,border:'0.5px solid rgba(0,0,0,0.08)'}}>
              <div style={{fontSize:10,color:'#aaa',marginBottom:3,fontWeight:600,textTransform:'uppercase'}}>Material Used</div>
              <div style={{fontSize:22,fontWeight:700,color:'#E24B4A'}}>${totalMatCost.toFixed(0)}</div>
              <div style={{fontSize:11,color:T.textMuted,marginTop:2}}>{totalGrams}g across {completedJobs.length} jobs</div>
            </div>
            <div style={{background:'#fff',borderRadius:14,padding:14,border:'0.5px solid rgba(0,0,0,0.08)'}}>
              <div style={{fontSize:10,color:'#aaa',marginBottom:3,fontWeight:600,textTransform:'uppercase'}}>Maintenance</div>
              <div style={{fontSize:22,fontWeight:700,color:'#EF9F27'}}>${(maintTotalCost+maintPending).toFixed(0)}</div>
              <div style={{fontSize:11,color:T.textMuted,marginTop:2}}>${maintTotalCost.toFixed(0)} spent · ${maintPending.toFixed(0)} pending</div>
            </div>
          </div>

          {/* Monthly bar chart */}
          <div style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,padding:16,marginBottom:14}}>
            <div style={{fontSize:14,fontWeight:700,marginBottom:4,color:T.text}}>Monthly Spend (6 months)</div>
            <div style={{fontSize:11,color:T.textMuted,marginBottom:12,display:'flex',gap:14}}>
              <span style={{display:'flex',alignItems:'center',gap:4}}><div style={{width:10,height:10,borderRadius:2,background:'#185FA5'}}/> Filament</span>
              <span style={{display:'flex',alignItems:'center',gap:4}}><div style={{width:10,height:10,borderRadius:2,background:'#EF9F27'}}/> Maintenance</span>
            </div>
            <div style={{display:'flex',alignItems:'flex-end',gap:5,height:90}}>
              {monthly.map(m=>(
                <div key={m.label+m.yr} style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',gap:3}}>
                  <div style={{fontSize:9,color:T.textMuted}}>{(m.filCost+m.maintCost)>0?`$${(m.filCost+m.maintCost).toFixed(0)}`:''}</div>
                  <div style={{width:'100%',display:'flex',flexDirection:'column',borderRadius:'4px 4px 0 0',overflow:'hidden',minHeight:2}}>
                    <div style={{background:'#EF9F27',height:`${m.maintCost/maxBar*60}px`,minHeight:m.maintCost>0?2:0}}/>
                    <div style={{background:'#185FA5',height:`${m.filCost/maxBar*60}px`,minHeight:m.filCost>0?2:0}}/>
                  </div>
                  <div style={{fontSize:10,color:T.textMuted,fontWeight:500}}>{m.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Material usage pie */}
          {matEntries.length>0&&(
            <div style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,padding:16,marginBottom:14}}>
              <div style={{fontSize:14,fontWeight:700,marginBottom:12,color:T.text}}>Filament Usage by Material</div>
              <div style={{display:'flex',alignItems:'center',gap:16}}>
                <Pie data={matEntries.map(([l,v])=>({l,v,c:getClr(l)}))} size={100}/>
                <div style={{flex:1}}>
                  {matEntries.map(([l,g])=>{const tot=Object.values(byMat).reduce((a,b)=>a+b,0);return(
                    <div key={l} style={{display:'flex',alignItems:'center',gap:8,marginBottom:7}}>
                      <div style={{width:10,height:10,borderRadius:3,background:getClr(l),flexShrink:0}}/>
                      <div style={{flex:1,fontSize:12,fontWeight:600}}>{l}</div>
                      <div style={{fontSize:11,color:T.textMuted}}>{g}g</div>
                      <div style={{fontSize:12,fontWeight:700,minWidth:32,textAlign:'right'}}>{Math.round(g/tot*100)}%</div>
                    </div>
                  );})}
                </div>
              </div>
            </div>
          )}

          {/* Runout predictions */}
          <div style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,padding:16,marginBottom:14}}>
            <div style={{fontSize:14,fontWeight:700,marginBottom:2}}>Filament Runout Predictions</div>
            <div style={{fontSize:11,color:T.textMuted,marginBottom:12}}>Based on actual usage from job history</div>
            {preds.length===0?<div style={{color:'#aaa',fontSize:13,padding:'12px 0'}}>Complete jobs to see predictions</div>:preds.map(f=>(
              <div key={f.id} style={{display:'flex',alignItems:'center',gap:10,padding:'10px 0',borderBottom:`0.5px solid ${T.border}`}}>
                <div style={{width:10,height:10,borderRadius:'50%',background:COLORS[f.color]||'#888',flexShrink:0,border:'0.5px solid rgba(0,0,0,0.1)'}}/>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:12,fontWeight:600}}>{f.brand} {f.material} {f.color}</div>
                  <div style={{fontSize:10,color:T.textMuted,marginTop:1}}>{f.left}g left{f.gpd>0?` · ${f.gpd}g/day`:' · no recent usage'}</div>
                </div>
                <div style={{textAlign:'right',flexShrink:0}}>
                  {f.days!==null?(
                    <div style={{fontSize:13,fontWeight:700,color:f.days<=3?'#E24B4A':f.days<=10?'#EF9F27':'#1D9E75'}}>{f.days===0?'Today!':f.days===1?'Tomorrow':`~${f.days}d`}</div>
                  ):<div style={{fontSize:12,color:'#aaa'}}>—</div>}
                  <div style={{fontSize:10,color:'#aaa'}}>{f.remaining_pct}%</div>
                </div>
              </div>
            ))}
          </div>

          {/* Equipment breakdown */}
          <div style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,padding:16,marginBottom:14}}>
            <div style={{fontSize:14,fontWeight:700,marginBottom:12,color:T.text}}>Equipment Value Breakdown</div>
            {equipment.length===0?<div style={{color:'#aaa',fontSize:13}}>No equipment tracked yet</div>:
              Object.entries(equipment.reduce((acc:any,e)=>{const t=e.type||'Other';acc[t]=(acc[t]||0)+(e.total_value||e.unit_cost*e.quantity||0);return acc;},{})).sort((a:any,b:any)=>b[1]-a[1]).map(([type,val]:any)=>(
                <div key={type} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 0',borderBottom:`0.5px solid ${T.border}`}}>
                  <div style={{flex:1,fontSize:13,fontWeight:500}}>{type}</div>
                  <div style={{fontSize:13,fontWeight:700,color:'#1D9E75'}}>${val.toFixed(2)}</div>
                </div>
              ))
            }
            <div style={{display:'flex',justifyContent:'space-between',padding:'10px 0',fontWeight:700,fontSize:13,borderTop:'1px solid rgba(0,0,0,0.1)',marginTop:2}}>
              <span>Total Equipment Value</span><span style={{color:'#1D9E75'}}>${eqTotalValue.toFixed(2)}</span>
            </div>
          </div>

          {/* Maintenance cost breakdown */}
          <div style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,padding:16,marginBottom:14}}>
            <div style={{fontSize:14,fontWeight:700,marginBottom:12,color:T.text}}>Maintenance Cost Breakdown</div>
            {maintenance.length===0?<div style={{color:'#aaa',fontSize:13}}>No maintenance tracked yet</div>:
              maintenance.filter(m=>m.parts_cost>0||m.labor_min>0).slice(0,8).map(m=>(
                <div key={m.id} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 0',borderBottom:`0.5px solid ${T.border}`}}>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:12,fontWeight:600,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{m.task}</div>
                    <div style={{fontSize:10,color:T.textMuted}}>{m.printer_name} · {m.due_date}{m.labor_min>0?` · ${m.labor_min}min`:''}</div>
                  </div>
                  <div style={{textAlign:'right',flexShrink:0}}>
                    <div style={{fontSize:13,fontWeight:700,color:m.status==='completed'?'#E24B4A':'#EF9F27'}}>${(m.parts_cost||0).toFixed(2)}</div>
                    <div style={{fontSize:10,color:'#aaa'}}>{m.status}</div>
                  </div>
                </div>
              ))
            }
            <div style={{display:'flex',justifyContent:'space-between',padding:'10px 0',fontWeight:700,fontSize:13,borderTop:'1px solid rgba(0,0,0,0.1)',marginTop:2}}>
              <span>Total Maintenance Spent</span><span style={{color:'#E24B4A'}}>${maintTotalCost.toFixed(2)}</span>
            </div>
          </div>

          {/* Per spool */}
          <div style={{fontSize:14,fontWeight:700,marginBottom:10,color:T.text}}>Per Spool Breakdown</div>
          {filaments.length===0?<div style={{background:'#fff',borderRadius:14,padding:28,textAlign:'center',color:'#aaa',border:'0.5px solid rgba(0,0,0,0.08)'}}>Add filament to see breakdown</div>:filaments.map(f=>{
            const mb=matBadge[f.material]||{bg:'#f0f0f0',color:T.textSub};
            const used=f.weight_g*(100-f.remaining_pct)/100;
            return(
              <div key={f.id} style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,padding:14,marginBottom:8}}>
                <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:10}}>
                  <span style={{background:mb.bg,color:mb.color,padding:'3px 8px',borderRadius:20,fontSize:11,fontWeight:700}}>{f.material}</span>
                  <div style={{width:10,height:10,borderRadius:'50%',background:COLORS[f.color]||'#888',border:'0.5px solid rgba(0,0,0,0.1)'}}/>
                  <span style={{fontSize:13,fontWeight:600,flex:1}}>{f.brand} · {f.color}</span>
                  <span style={{fontSize:11,color:T.textMuted}}>{f.diameter||'1.75mm'}</span>
                </div>
                <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:6,marginBottom:6}}>
                  {[['Full Value',`$${(f.weight_g/1000*(f.cost_per_kg||0)).toFixed(2)}`],['Used',`$${(used/1000*(f.cost_per_kg||0)).toFixed(2)}`],['Remaining',`$${spoolVal(f).toFixed(2)}`],['$/kg',`$${(f.cost_per_kg||0).toFixed(2)}`]].map(([l,v])=>(
                    <div key={l} style={{background:T.statBg,borderRadius:8,padding:'7px 8px'}}>
                      <div style={{fontSize:9,color:'#aaa',marginBottom:2}}>{l}</div>
                      <div style={{fontSize:12,fontWeight:700}}>{v}</div>
                    </div>
                  ))}
                </div>
                {f.supplier&&<div style={{fontSize:11,color:T.textMuted}}>Supplier: {f.supplier}{f.purchase_price>0?` · Paid: $${f.purchase_price.toFixed(2)}`:''}</div>}
              </div>
            );
          })}
        </div>
      );
    })(),

    history:(
      <div>
        <div style={{fontSize:18,fontWeight:700,marginBottom:4,color:T.text}}>Job History</div>
        <div style={{fontSize:12,color:T.textMuted,marginBottom:14}}>Complete record of all print jobs</div>

        {/* Summary stats */}
        <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:8,marginBottom:14}}>
          <div style={{background:'linear-gradient(135deg,#1D9E75,#185FA5)',borderRadius:12,padding:'12px',textAlign:'center'}}>
            <div style={{fontSize:22,fontWeight:700,color:'#fff'}}>{history.filter(j=>j.status==='completed').length}</div>
            <div style={{fontSize:10,color:'rgba(255,255,255,0.8)'}}>Completed</div>
          </div>
          <div style={{background:'linear-gradient(135deg,#E24B4A,#D85A30)',borderRadius:12,padding:'12px',textAlign:'center'}}>
            <div style={{fontSize:22,fontWeight:700,color:'#fff'}}>{history.filter(j=>j.status==='failed').length}</div>
            <div style={{fontSize:10,color:'rgba(255,255,255,0.8)'}}>Failed</div>
          </div>
          <div style={{background:'linear-gradient(135deg,#6A1B9A,#185FA5)',borderRadius:12,padding:'12px',textAlign:'center'}}>
            <div style={{fontSize:22,fontWeight:700,color:'#fff'}}>${history.filter(j=>j.status==='completed').reduce((s,j)=>s+jobCost(j.filament_used_g||0,j.material,filaments),0).toFixed(0)}</div>
            <div style={{fontSize:10,color:'rgba(255,255,255,0.8)'}}>Total Cost</div>
          </div>
        </div>

        {/* Filter tabs */}
        <div style={{display:'flex',gap:6,marginBottom:14}}>
          {['all','completed','failed','cancelled'].map(t=>(
            <button key={t} onClick={()=>setHistTab(t)} style={{flex:1,padding:'9px 4px',borderRadius:10,border:'none',background:histTab===t?'#185FA5':T.statBg,color:histTab===t?'#fff':T.textSub,fontSize:11,fontWeight:600,cursor:'pointer'}}>
              {t.charAt(0).toUpperCase()+t.slice(1)}
            </button>
          ))}
        </div>

        {history.length===0
          ?<div style={{background:T.surface,borderRadius:14,padding:40,textAlign:'center',border:`0.5px solid ${T.border}`}}>
            <div style={{fontSize:28,marginBottom:8}}>📋</div>
            <div style={{fontSize:14,fontWeight:600,color:T.text,marginBottom:4}}>No job history yet</div>
            <div style={{fontSize:12,color:T.textMuted}}>Completed jobs will appear here</div>
          </div>
          :history.filter(j=>histTab==='all'||j.status===histTab).map(j=>{
            const stClr:{[k:string]:string}={completed:'#1D9E75',failed:'#E24B4A',cancelled:'#888'};
            const stBg:{[k:string]:string}={completed:'#E1F5EE',failed:'#FCEBEB',cancelled:'#f5f5f3'};
            return(
              <div key={j.id} style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,padding:14,marginBottom:8}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:10}}>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:14,fontWeight:700,color:T.text,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',marginBottom:2}}>{j.job_name}</div>
                    <div style={{display:'flex',alignItems:'center',gap:8}}>
                      <span style={{fontSize:11,color:T.textMuted}}>{j.printer_name}</span>
                      {j.customer_name&&<span style={{fontSize:11,padding:'1px 6px',borderRadius:10,background:'#E6F1FB',color:'#185FA5',fontWeight:600}}>{j.customer_name}</span>}
                    </div>
                  </div>
                  <span style={{fontSize:11,fontWeight:700,padding:'3px 9px',borderRadius:20,background:stBg[j.status]||'#f5f5f3',color:stClr[j.status]||'#888',flexShrink:0,marginLeft:8}}>{j.status}</span>
                </div>
                <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:6}}>
                  {[
                    ['Material',j.material||'—'],
                    ['Duration',`${Math.floor((j.duration_min||0)/60)}h ${(j.duration_min||0)%60}m`],
                    ['Cost',`$${jobCost(j.filament_used_g||0,j.material,filaments).toFixed(2)}`],
                    ['Date',j.completed_at?.split('T')[0]||'—'],
                  ].map(([l,v])=>(
                    <div key={l} style={{background:T.statBg,borderRadius:8,padding:'6px 8px'}}>
                      <div style={{fontSize:9,color:T.textMuted,marginBottom:1}}>{l}</div>
                      <div style={{fontSize:11,fontWeight:600,color:T.textSub,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{v}</div>
                    </div>
                  ))}
                </div>
                {j.customer_price>0&&<div style={{fontSize:11,color:'#1D9E75',fontWeight:600,marginTop:6}}>💰 Customer Price: ${parseFloat(j.customer_price).toFixed(2)} · Profit: ${(parseFloat(j.customer_price)-jobCost(j.filament_used_g||0,j.material,filaments)).toFixed(2)}</div>}
                {j.tags&&<div style={{fontSize:10,color:T.textMuted,marginTop:4}}>🏷 {j.tags}</div>}
              </div>
            );
          })
        }
      </div>
    ),

    activity:(
      <div>
        <div style={{fontSize:18,fontWeight:700,marginBottom:14,color:T.text}}>Activity Log</div>
        <div style={{...S.card,padding:'6px 14px'}}>
          {activity.length===0?<div style={{textAlign:'center',color:'#aaa',padding:24}}>No activity yet.</div>:activity.map(a=>(
            <div key={a.id} style={{display:'flex',gap:10,padding:'10px 0',borderBottom:`0.5px solid ${T.border}`}}>
              <div style={{width:8,height:8,borderRadius:'50%',background:a.color,marginTop:4,flexShrink:0}}/>
              <div style={{flex:1,fontSize:13,color:T.textSub,lineHeight:1.4}}>{a.message}</div>
              <div style={{fontSize:11,color:'#aaa',whiteSpace:'nowrap'}}>{timeAgo(a.created_at)}</div>
            </div>
          ))}
        </div>
      </div>
    ),
    customers:(
      <div>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14}}>
          <div style={{fontSize:18,fontWeight:700}}>Customers</div>
          <button onClick={()=>{setModal('newCustomer');setForm({});}} style={{display:'flex',alignItems:'center',gap:6,padding:'8px 14px',background:'#185FA5',color:'#fff',border:'none',borderRadius:10,fontSize:13,fontWeight:600,cursor:'pointer'}}>{I.add}Add Customer</button>
        </div>
        <input value={cusSearch} onChange={e=>setCusSearch(e.target.value)} placeholder="Search customers…" style={{width:'100%',padding:'11px 14px',fontSize:14,border:`1px solid ${T.inputBorder}`,borderRadius:10,marginBottom:14,outline:'none',fontFamily:'inherit',background:T.input,color:T.text}}/>

        {customers.length===0?(
          <div style={{background:T.surface,borderRadius:14,padding:40,textAlign:'center',border:`0.5px solid ${T.border}`}}>
            <div style={{fontSize:28,marginBottom:8}}>🏢</div>
            <div style={{fontSize:15,fontWeight:600,color:T.textSub,marginBottom:4}}>No customers yet</div>
            <div style={{fontSize:13,color:T.textMuted,marginBottom:16}}>Add clients to track jobs, pricing, and revenue per customer</div>
            <button onClick={()=>{setModal('newCustomer');setForm({});}} style={{padding:'10px 20px',background:'#185FA5',color:'#fff',border:'none',borderRadius:10,fontSize:13,fontWeight:600,cursor:'pointer'}}>Add First Customer</button>
          </div>
        ):(
          <div>
            {/* Summary stats */}
            <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:8,marginBottom:14}}>
              <div style={{background:'#fff',borderRadius:12,padding:12,border:'0.5px solid rgba(0,0,0,0.08)',textAlign:'center'}}>
                <div style={{fontSize:22,fontWeight:700,color:'#185FA5'}}>{customers.length}</div>
                <div style={{fontSize:11,color:T.textMuted}}>Total Clients</div>
              </div>
              <div style={{background:'#fff',borderRadius:12,padding:12,border:'0.5px solid rgba(0,0,0,0.08)',textAlign:'center'}}>
                <div style={{fontSize:22,fontWeight:700,color:'#1D9E75'}}>${customers.reduce((s,c)=>s+(c.total_revenue||0),0).toFixed(0)}</div>
                <div style={{fontSize:11,color:T.textMuted}}>Total Revenue</div>
              </div>
              <div style={{background:'#fff',borderRadius:12,padding:12,border:'0.5px solid rgba(0,0,0,0.08)',textAlign:'center'}}>
                <div style={{fontSize:22,fontWeight:700,color:'#EF9F27'}}>{customers.reduce((s,c)=>s+(c.total_jobs||0),0)}</div>
                <div style={{fontSize:11,color:T.textMuted}}>Total Jobs</div>
              </div>
            </div>

            {customers.filter(c=>!cusSearch||`${c.name}${c.contact}${c.email}`.toLowerCase().includes(cusSearch.toLowerCase())).map(c=>(
              <div key={c.id} style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,padding:16,marginBottom:8}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:10}}>
                  <div style={{flex:1}}>
                    <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
                      <div style={{width:36,height:36,borderRadius:10,background:'#185FA5',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontSize:14,fontWeight:700,flexShrink:0}}>
                        {c.name.charAt(0).toUpperCase()}
                      </div>
                      <div>
                        <div style={{fontSize:14,fontWeight:700}}>{c.name}</div>
                        <div style={{fontSize:11,color:T.textMuted}}>{c.contact}{c.email?` · ${c.email}`:''}</div>
                      </div>
                    </div>
                  </div>
                  <div style={{display:'flex',gap:6,flexShrink:0}}>
                    <button onClick={()=>{setModal('editCustomer');setForm({id:c.id,name:c.name,contact:c.contact,email:c.email,phone:c.phone,address:c.address,default_material:c.default_material,default_color:c.default_color,hourly_rate:c.hourly_rate,markup:c.markup,notes:c.notes});}} style={{width:30,height:30,background:'#E6F1FB',border:'none',borderRadius:8,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#185FA5" strokeWidth="2.5" strokeLinecap="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                    </button>
                    <button onClick={()=>del('customers',c.id)} style={{width:30,height:30,background:'#f8f8f7',border:'none',borderRadius:8,cursor:'pointer',fontSize:13,color:'#aaa'}}>✕</button>
                  </div>
                </div>
                <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:6,marginBottom:c.notes?8:0}}>
                  {[
                    ['Jobs',c.total_jobs||0],
                    ['Revenue',`$${(c.total_revenue||0).toFixed(0)}`],
                    ['Rate',`$${c.hourly_rate||65}/hr`],
                    ['Markup',`${c.markup||20}%`],
                  ].map(([l,v])=>(
                    <div key={l} style={{background:T.statBg,borderRadius:8,padding:'7px 8px'}}>
                      <div style={{fontSize:9,color:'#aaa',marginBottom:2}}>{l}</div>
                      <div style={{fontSize:12,fontWeight:700,color:T.textSub}}>{v}</div>
                    </div>
                  ))}
                </div>
                {c.notes&&<div style={{fontSize:11,color:T.textMuted,marginTop:6}}>{c.notes}</div>}
                {/* Jobs for this customer */}
                {history.filter(j=>j.customer_id===c.id).length>0&&(
                  <div style={{marginTop:10,padding:'8px 10px',background:T.surfaceAlt,borderRadius:8}}>
                    <div style={{fontSize:11,fontWeight:600,color:T.textSub,marginBottom:4}}>Recent Jobs</div>
                    {history.filter(j=>j.customer_id===c.id).slice(0,3).map(j=>(
                      <div key={j.id} style={{display:'flex',justifyContent:'space-between',fontSize:11,padding:'3px 0',borderBottom:`0.5px solid ${T.border}`}}>
                        <span>{j.job_name}</span>
                        <span style={{fontWeight:600,color:'#1D9E75'}}>${(j.customer_price||0).toFixed(2)}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    ),

    workorders:(
      <div>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14}}>
          <div style={{fontSize:18,fontWeight:700}}>Work Orders</div>
          <button onClick={()=>{setModal('newWorkOrder');setForm({});}} style={{display:'flex',alignItems:'center',gap:6,padding:'8px 14px',background:'#185FA5',color:'#fff',border:'none',borderRadius:10,fontSize:13,fontWeight:600,cursor:'pointer'}}>{I.add}New WO</button>
        </div>
        <div style={{display:'flex',gap:6,marginBottom:14}}>
          {['open','in_progress','pending_approval','completed','cancelled'].map(t=>(
            <button key={t} onClick={()=>setWoTab(t)} style={{flexShrink:0,padding:'7px 10px',borderRadius:10,border:'none',background:woTab===t?T.blue:T.statBg,color:woTab===t?'#fff':T.text,fontSize:11,fontWeight:600,cursor:'pointer',whiteSpace:'nowrap'}}>
              {t.replace('_',' ').replace(/\b\w/g,l=>l.toUpperCase())} ({workOrders.filter(w=>w.status===t).length})
            </button>
          ))}
        </div>
        {workOrders.filter(w=>w.status===woTab).length===0
          ?<div style={{background:T.surface,borderRadius:14,padding:32,textAlign:'center',color:T.textMuted,border:`0.5px solid ${T.border}`}}>No {woTab.replace('_',' ')} work orders.</div>
          :workOrders.filter(w=>w.status===woTab).map(wo=>{
            const urgClr:{[k:string]:string}={high:'#E24B4A',medium:'#EF9F27',low:'#1D9E75'};
            const stClr:{[k:string]:string}={open:'#185FA5',in_progress:'#1D9E75',pending_approval:'#EF9F27',completed:'#888',cancelled:'#E24B4A'};
            return(
              <div key={wo.id} style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,borderLeft:`4px solid ${urgClr[wo.urgency]||'#888'}`,padding:14,marginBottom:8}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:8}}>
                  <div style={{flex:1}}>
                    <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
                      <span style={{fontSize:11,fontWeight:700,color:'#aaa'}}>#{wo.wo_number||wo.id.slice(-6).toUpperCase()}</span>
                      <span style={{fontSize:12,padding:'2px 8px',borderRadius:20,background:stClr[wo.status]+'20',color:stClr[wo.status],fontWeight:600}}>{wo.status.replace('_',' ')}</span>
                    </div>
                    <div style={{fontSize:14,fontWeight:700}}>{wo.title}</div>
                    <div style={{fontSize:12,color:T.textMuted,marginTop:2}}>{wo.printer_name} · {wo.assigned_to||'Unassigned'}</div>
                  </div>
                  <div style={{display:'flex',gap:6,flexShrink:0}}>
                    {wo.status==='open'&&<button onClick={async()=>{await updateDoc(doc(db,'work_orders',wo.id),{status:'in_progress',started_at:new Date().toISOString()});showToast('Work order started');}} style={{padding:'6px 10px',background:'#1D9E75',color:'#fff',border:'none',borderRadius:8,fontSize:12,fontWeight:600,cursor:'pointer'}}>Start</button>}
                    {wo.status==='in_progress'&&<button onClick={async()=>{await updateDoc(doc(db,'work_orders',wo.id),{status:'pending_approval',completed_at:new Date().toISOString()});showToast('Submitted for approval');}} style={{padding:'6px 10px',background:'#EF9F27',color:'#fff',border:'none',borderRadius:8,fontSize:12,fontWeight:600,cursor:'pointer'}}>Submit</button>}
                    {wo.status==='pending_approval'&&<button onClick={async()=>{await updateDoc(doc(db,'work_orders',wo.id),{status:'completed',approved_by:'Owner',approved_at:new Date().toISOString()});await addAct(`Work order approved: ${wo.title}`,'#1D9E75');showToast('Work order approved & closed');}} style={{padding:'6px 10px',background:'#185FA5',color:'#fff',border:'none',borderRadius:8,fontSize:12,fontWeight:600,cursor:'pointer'}}>Approve</button>}
                    <button onClick={()=>del('work_orders',wo.id)} style={{width:30,height:30,background:'#f8f8f7',border:'none',borderRadius:8,cursor:'pointer',fontSize:13,color:'#aaa'}}>✕</button>
                  </div>
                </div>
                {wo.description&&<div style={{fontSize:12,color:T.textSub,marginBottom:8,lineHeight:1.4}}>{wo.description}</div>}
                <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:6,marginBottom:wo.parts_used?.length?8:0}}>
                  {[['Due',wo.due_date||'—'],['Parts Cost',`$${(wo.parts_cost||0).toFixed(2)}`],['Labor',`${wo.labor_min||0}min`]].map(([l,v])=>(
                    <div key={l} style={{background:T.statBg,borderRadius:8,padding:'6px 8px'}}>
                      <div style={{fontSize:9,color:'#aaa',marginBottom:1}}>{l}</div>
                      <div style={{fontSize:12,fontWeight:600}}>{v}</div>
                    </div>
                  ))}
                </div>
                {wo.parts_used?.length>0&&(
                  <div style={{marginTop:8,padding:'8px 10px',background:T.surfaceAlt,borderRadius:8}}>
                    <div style={{fontSize:11,fontWeight:600,color:T.textSub,marginBottom:4}}>Parts Used:</div>
                    {wo.parts_used.map((p:any,i:number)=>(
                      <div key={i} style={{fontSize:11,color:T.textSub,display:'flex',justifyContent:'space-between'}}>
                        <span>{p.name}</span><span style={{color:'#E24B4A',fontWeight:600}}>-{p.qty} units</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })
        }
      </div>
    ),

    purchases:(
      <div>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14}}>
          <div style={{fontSize:18,fontWeight:700}}>Purchase Requests</div>
          <button onClick={()=>{setModal('newPurchase');setForm({});}} style={{display:'flex',alignItems:'center',gap:6,padding:'8px 14px',background:'#185FA5',color:'#fff',border:'none',borderRadius:10,fontSize:13,fontWeight:600,cursor:'pointer'}}>{I.add}Request</button>
        </div>
        <div style={{display:'flex',gap:6,marginBottom:14}}>
          {['pending','approved','ordered','received','denied'].map(t=>(
            <button key={t} onClick={()=>setPrTab(t)} style={{flexShrink:0,padding:'7px 10px',borderRadius:10,border:'none',background:prTab===t?T.blue:T.statBg,color:prTab===t?'#fff':T.text,fontSize:11,fontWeight:600,cursor:'pointer',whiteSpace:'nowrap'}}>
              {t.charAt(0).toUpperCase()+t.slice(1)} ({purchases.filter(p=>p.status===t).length})
            </button>
          ))}
        </div>
        {purchases.filter(p=>p.status===prTab).length===0
          ?<div style={{background:T.surface,borderRadius:14,padding:32,textAlign:'center',color:T.textMuted,border:`0.5px solid ${T.border}`}}>No {prTab} purchase requests.</div>
          :purchases.filter(p=>p.status===prTab).map(pr=>{
            const stClr:{[k:string]:string}={pending:'#EF9F27',approved:'#1D9E75',ordered:'#185FA5',received:'#888',denied:'#E24B4A'};
            const totalCost=(pr.line_items||[{qty:pr.quantity||1,unit_price:pr.unit_price||0}]).reduce((s:number,i:any)=>s+((i.qty||1)*(i.unit_price||0)),0);
            return(
              <div key={pr.id} style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,padding:14,marginBottom:8}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:8}}>
                  <div style={{flex:1}}>
                    <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
                      <span style={{fontSize:11,fontWeight:700,color:'#aaa'}}>PR-{pr.id.slice(-6).toUpperCase()}</span>
                      <span style={{fontSize:12,padding:'2px 8px',borderRadius:20,background:stClr[pr.status]+'20',color:stClr[pr.status],fontWeight:600}}>{pr.status}</span>
                      {pr.urgency==='urgent'&&<span style={{fontSize:11,fontWeight:700,color:'#E24B4A'}}>URGENT</span>}
                    </div>
                    <div style={{fontSize:14,fontWeight:700}}>{pr.item_name}</div>
                    <div style={{fontSize:12,color:T.textMuted,marginTop:2}}>{pr.vendor||'Vendor TBD'} · {(pr.line_items||[]).length||1} item(s) · <strong style={{color:'#185FA5'}}>${totalCost.toFixed(2)}</strong></div>
                    {pr.needed_by&&<div style={{fontSize:11,color:T.textMuted,marginTop:2}}>Needed by: {pr.needed_by} · Requested by: {pr.requested_by_role||'admin'}</div>}
                    {pr.reason&&<div style={{fontSize:11,color:T.textSub,marginTop:4,padding:'6px 8px',background:'#f8f8f7',borderRadius:6}}>{pr.reason}</div>}
                    {pr.line_items?.length>0&&(
                      <div style={{marginTop:8,padding:'8px 10px',background:T.surfaceAlt,borderRadius:8}}>
                        {pr.line_items.map((li:any,i:number)=>(
                          <div key={i} style={{display:'flex',justifyContent:'space-between',fontSize:11,padding:'3px 0',borderBottom:`0.5px solid ${T.border}`}}>
                            <span>{li.qty}x {li.name}</span><span style={{fontWeight:600}}>${((li.qty||1)*(li.unit_price||0)).toFixed(2)}</span>
                          </div>
                        ))}
                        <div style={{display:'flex',justifyContent:'space-between',fontSize:12,fontWeight:700,marginTop:4,color:'#185FA5'}}>
                          <span>PO Total</span><span>${totalCost.toFixed(2)}</span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div style={{display:'flex',flexDirection:'column',gap:6,flexShrink:0,marginLeft:8}}>
                    {pr.status==='pending'&&<button onClick={async()=>{if(!canApprove){showToast('Only Leads and Admins can approve purchases');return;}await updateDoc(doc(db,'purchase_requests',pr.id),{status:'approved',approved_at:new Date().toISOString(),approved_by:user?.email||'Admin',approved_by_role:userRole});await addAct(`Purchase approved by ${userRole}: ${pr.title||pr.item_name} ($${totalCost.toFixed(2)})`,'#1D9E75');showToast('Purchase approved ✓');}} style={{padding:'6px 10px',background:'#1D9E75',color:'#fff',border:'none',borderRadius:8,fontSize:12,fontWeight:600,cursor:'pointer'}}>Approve</button>}
                    {pr.status==='pending'&&<button onClick={async()=>{await updateDoc(doc(db,'purchase_requests',pr.id),{status:'denied',denied_at:new Date().toISOString()});showToast('Request denied');}} style={{padding:'6px 10px',background:'#FCEBEB',color:'#E24B4A',border:'none',borderRadius:8,fontSize:12,fontWeight:600,cursor:'pointer'}}>Deny</button>}
                    {pr.status==='approved'&&<button onClick={async()=>{await updateDoc(doc(db,'purchase_requests',pr.id),{status:'ordered',ordered_at:new Date().toISOString()});showToast('Marked as ordered');}} style={{padding:'6px 10px',background:'#185FA5',color:'#fff',border:'none',borderRadius:8,fontSize:12,fontWeight:600,cursor:'pointer'}}>Mark Ordered</button>}
                    {pr.status==='ordered'&&<button onClick={async()=>{
                      await updateDoc(doc(db,'purchase_requests',pr.id),{status:'received',received_at:new Date().toISOString(),received_by:user?.email||''});
                      // Auto-add each line item to inventory
                      const lineItems=pr.line_items||[{name:pr.item_name||'Item',type:pr.item_type||'equipment',qty:pr.quantity||1,unit_price:pr.unit_price||0}];
                      let added=0;
                      for(const li of lineItems){
                        if(li.type==='filament'){
                          await addDoc(collection(db,'filaments'),{material:li.material||pr.material||'PLA',brand:li.name,color:li.color||pr.color||'Unknown',weight_g:parseInt(li.weight_g)||1000,remaining_pct:100,cost_per_kg:parseFloat(li.unit_price)||24.99,location:'Incoming — PO '+pr.po_number,barcode:`PO-${Date.now()}-${added}`,added_at:new Date().toISOString()});
                        } else {
                          const existing=equipment.find((e:any)=>e.name.toLowerCase()===li.name.toLowerCase());
                          if(existing){
                            await updateDoc(doc(db,'equipment',existing.id),{quantity:(existing.quantity||0)+(li.qty||1),last_restocked:new Date().toISOString()});
                          } else {
                            await addDoc(collection(db,'equipment'),{name:li.name,type:li.type||'Spare Part',serial_number:'PO-'+pr.po_number,quantity:li.qty||1,unit_cost:parseFloat(li.unit_price)||0,total_value:(parseFloat(li.unit_price)||0)*(li.qty||1),supplier:pr.vendor||'',notes:li.notes||'',location:'Incoming',barcode:`PO-${Date.now()}-${added}`,added_at:new Date().toISOString()});
                          }
                        }
                        added++;
                      }
                      await addAct(`PO Received: ${pr.title||pr.item_name} — ${added} item(s) added to inventory (${pr.po_number})`,'#1D9E75');
                      showToast(`PO received — ${added} item(s) added to inventory ✓`);
                    }} style={{padding:'6px 10px',background:'#1D9E75',color:'#fff',border:'none',borderRadius:8,fontSize:12,fontWeight:600,cursor:'pointer'}}>Mark Received</button>}
                    <button onClick={()=>del('purchase_requests',pr.id)} style={{width:30,height:30,background:'#f8f8f7',border:'none',borderRadius:8,cursor:'pointer',fontSize:13,color:'#aaa'}}>✕</button>
                  </div>
                </div>
                <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:6}}>
                  {[['Unit Price',`$${(pr.unit_price||0).toFixed(2)}`],['Total',`$${totalCost.toFixed(2)}`],['Needed By',pr.needed_by||'—']].map(([l,v])=>(
                    <div key={l} style={{background:T.statBg,borderRadius:8,padding:'6px 8px'}}><div style={{fontSize:9,color:'#aaa',marginBottom:1}}>{l}</div><div style={{fontSize:12,fontWeight:600}}>{v}</div></div>
                  ))}
                </div>
              </div>
            );
          })
        }
      </div>
    ),

    approvals:(
      <div>
        <div style={{fontSize:18,fontWeight:700,marginBottom:4,color:T.text}}>Approvals</div>
        <div style={{fontSize:12,color:T.textMuted,marginBottom:14}}>Review and approve work orders and purchase requests</div>
        <div style={{display:'flex',gap:6,marginBottom:14}}>
          {['pending','approved','denied'].map(t=>(
            <button key={t} onClick={()=>setAppTab(t)} style={{flex:1,padding:'9px 4px',borderRadius:10,border:'none',background:appTab===t?T.blue:T.statBg,color:appTab===t?'#fff':T.text,fontSize:12,fontWeight:600,cursor:'pointer'}}>
              {t.charAt(0).toUpperCase()+t.slice(1)}
            </button>
          ))}
        </div>

        {/* Pending WOs needing approval */}
        {appTab==='pending'&&(
          <>
            {maintenance.filter(m=>m.status==='pending_approval').length>0&&(
          <>
            <div style={{fontSize:13,fontWeight:700,color:'#1D9E75',marginBottom:8}}>🔧 Maintenance Tasks Pending ({maintenance.filter(m=>m.status==='pending_approval').length})</div>
            {maintenance.filter(m=>m.status==='pending_approval').map(m=>(
              <div key={m.id} style={{background:'#fff',borderRadius:14,border:'1px solid #9FE1CB',padding:14,marginBottom:8}}>
                <div style={{fontSize:14,fontWeight:700,marginBottom:4,color:T.text}}>{m.task}</div>
                <div style={{fontSize:12,color:T.textMuted,marginBottom:4}}>{m.printer_name} · Submitted by: {m.submitted_by||'Tech'} ({m.submitted_by_role||'tech'})</div>
                {m.parts_needed&&<div style={{fontSize:12,color:T.textSub,marginBottom:6,padding:'6px 8px',background:'#f8f8f7',borderRadius:6}}>Parts used: {m.parts_needed}</div>}
                {m.notes&&<div style={{fontSize:12,color:T.textSub,marginBottom:8,padding:'6px 8px',background:'#f8f8f7',borderRadius:6}}>{m.notes}</div>}
                <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:6,marginBottom:10}}>
                  {[['Parts Cost',`$${(m.parts_cost||0).toFixed(2)}`],['Labor',`${m.labor_min||0}min`],['Due',m.due_date||'—']].map(([l,v])=>(
                    <div key={l} style={{background:T.statBg,borderRadius:8,padding:'6px 8px'}}><div style={{fontSize:9,color:'#aaa',marginBottom:1}}>{l}</div><div style={{fontSize:12,fontWeight:600}}>{v}</div></div>
                  ))}
                </div>
                <div style={{display:'flex',gap:8}}>
                  <button onClick={()=>approveMaint(m.id)} style={{flex:1,padding:'10px',background:'#1D9E75',color:'#fff',border:'none',borderRadius:10,fontSize:13,fontWeight:700,cursor:'pointer'}}>✓ Approve & Close</button>
                  <button onClick={async()=>{await updateDoc(doc(db,'maintenance',m.id),{status:'upcoming',rejected_at:new Date().toISOString()});showToast('Sent back for rework');}} style={{flex:1,padding:'10px',background:'#FCEBEB',color:'#E24B4A',border:'none',borderRadius:10,fontSize:13,fontWeight:700,cursor:'pointer'}}>↩ Send Back</button>
                </div>
              </div>
            ))}
          </>
        )}
        {workOrders.filter(w=>w.status==='pending_approval').length>0&&(
              <>
                <div style={{fontSize:13,fontWeight:700,color:'#EF9F27',marginBottom:8}}>⏳ Work Orders Pending Approval ({workOrders.filter(w=>w.status==='pending_approval').length})</div>
                {workOrders.filter(w=>w.status==='pending_approval').map(wo=>(
                  <div key={wo.id} style={{background:'#fff',borderRadius:14,border:'1px solid #FAC775',padding:14,marginBottom:8}}>
                    <div style={{fontSize:14,fontWeight:700,marginBottom:4,color:T.text}}>{wo.title}</div>
                    <div style={{fontSize:12,color:T.textMuted,marginBottom:8}}>{wo.printer_name} · Parts: ${(wo.parts_cost||0).toFixed(2)} · Labor: {wo.labor_min||0}min</div>
                    {wo.description&&<div style={{fontSize:12,color:T.textSub,marginBottom:10,padding:'8px',background:'#f8f8f7',borderRadius:8}}>{wo.description}</div>}
                    {wo.parts_used?.length>0&&<div style={{fontSize:11,color:T.textMuted,marginBottom:10}}>Parts used: {wo.parts_used.map((p:any)=>`${p.name} (×${p.qty})`).join(', ')}</div>}
                    <div style={{display:'flex',gap:8}}>
                      <button onClick={async()=>{const aNow=new Date().toISOString();await updateDoc(doc(db,'work_orders',wo.id),{status:'completed',approved_by:user?.email||'Admin',approved_by_role:userRole,approved_at:aNow});await addAct(`WO Approved & Closed: ${wo.title} (${wo.wo_number||wo.id.slice(-6)})`,'#1D9E75');showToast('Work order approved & closed ✓');}} style={{flex:1,padding:'10px',background:'#1D9E75',color:'#fff',border:'none',borderRadius:10,fontSize:13,fontWeight:700,cursor:'pointer'}}>✓ Approve & Close</button>
                      <button onClick={async()=>{await updateDoc(doc(db,'work_orders',wo.id),{status:'open',rejected_at:new Date().toISOString()});showToast('Sent back for rework');}} style={{flex:1,padding:'10px',background:'#FCEBEB',color:'#E24B4A',border:'none',borderRadius:10,fontSize:13,fontWeight:700,cursor:'pointer'}}>↩ Send Back</button>
                    </div>
                  </div>
                ))}
              </>
            )}
            {purchases.filter(p=>p.status==='pending').length>0&&(
              <>
                <div style={{fontSize:13,fontWeight:700,color:'#185FA5',marginBottom:8,marginTop:workOrders.filter(w=>w.status==='pending_approval').length>0?14:0}}>🛒 Purchase Requests Pending ({purchases.filter(p=>p.status==='pending').length})</div>
                {purchases.filter(p=>p.status==='pending').map(pr=>{
                  const total=((pr.quantity||1)*(pr.unit_price||0));
                  return(
                    <div key={pr.id} style={{background:'#fff',borderRadius:14,border:'1px solid #85B7EB',padding:14,marginBottom:8}}>
                      <div style={{fontSize:14,fontWeight:700,marginBottom:4,color:T.text}}>{pr.item_name}</div>
                      <div style={{fontSize:12,color:T.textMuted,marginBottom:4}}>Qty: {pr.quantity||1} × ${(pr.unit_price||0).toFixed(2)} = <strong style={{color:'#185FA5'}}>${total.toFixed(2)}</strong></div>
                      {pr.vendor&&<div style={{fontSize:12,color:T.textMuted,marginBottom:4}}>Vendor: {pr.vendor}</div>}
                      <div style={{fontSize:11,color:T.textMuted,marginBottom:4}}>Requested by: <strong>{pr.requested_by}</strong> ({pr.requested_by_role||'tech'}) · {pr.needed_by?`Needed by: ${pr.needed_by}`:''}</div>
                      {pr.line_items?.length>0&&(
                        <div style={{padding:'8px 10px',background:'#f8f8f7',borderRadius:8,marginBottom:8}}>
                          {pr.line_items.map((li:any,idx:number)=>(
                            <div key={idx} style={{display:'flex',justifyContent:'space-between',fontSize:11,padding:'3px 0',borderBottom:`0.5px solid ${T.border}`}}>
                              <span>{li.qty}x {li.name} <span style={{color:'#aaa'}}>({li.type})</span></span><span style={{fontWeight:600}}>${((li.qty||1)*(li.unit_price||0)).toFixed(2)}</span>
                            </div>
                          ))}
                          <div style={{display:'flex',justifyContent:'space-between',fontWeight:700,fontSize:12,marginTop:4,color:'#185FA5'}}><span>Total</span><span>${total.toFixed(2)}</span></div>
                        </div>
                      )}
                      {pr.reason&&<div style={{fontSize:12,color:T.textSub,marginBottom:10,padding:'8px',background:'#f8f8f7',borderRadius:8}}>Justification: {pr.reason}</div>}
                      <div style={{display:'flex',gap:8}}>
                        <button onClick={async()=>{await updateDoc(doc(db,'purchase_requests',pr.id),{status:'approved',approved_at:new Date().toISOString(),approved_by:'Owner'});await addAct(`Purchase approved: ${pr.item_name} ($${total.toFixed(2)})`,'#1D9E75');showToast('Approved ✓');}} style={{flex:1,padding:'10px',background:'#1D9E75',color:'#fff',border:'none',borderRadius:10,fontSize:13,fontWeight:700,cursor:'pointer'}}>✓ Approve</button>
                        <button onClick={async()=>{await updateDoc(doc(db,'purchase_requests',pr.id),{status:'denied',denied_at:new Date().toISOString()});showToast('Request denied');}} style={{flex:1,padding:'10px',background:'#FCEBEB',color:'#E24B4A',border:'none',borderRadius:10,fontSize:13,fontWeight:700,cursor:'pointer'}}>✕ Deny</button>
                      </div>
                    </div>
                  );
                })}
              </>
            )}
            {maintenance.filter(m=>m.status==='pending_approval').length===0&&workOrders.filter(w=>w.status==='pending_approval').length===0&&purchases.filter(p=>p.status==='pending').length===0&&(
              <div style={{background:'#E1F5EE',borderRadius:14,padding:32,textAlign:'center'}}>
                <div style={{fontSize:24,marginBottom:8}}>✓</div>
                <div style={{fontSize:15,fontWeight:700,color:'#085041'}}>All clear!</div>
                <div style={{fontSize:13,color:'#0F6E56',marginTop:4}}>No pending approvals</div>
              </div>
            )}
          </>
        )}
        {appTab==='approved'&&(
          <div>
            {[...workOrders.filter(w=>w.status==='completed'&&w.approved_by),...purchases.filter(p=>p.status==='approved'||p.status==='ordered'||p.status==='received')].map((item:any,i:number)=>(
              <div key={i} style={{background:'#fff',borderRadius:12,border:'0.5px solid rgba(0,0,0,0.08)',padding:12,marginBottom:6,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <div><div style={{fontSize:13,fontWeight:600}}>{item.title||item.item_name}</div><div style={{fontSize:11,color:T.textMuted}}>{item.approved_at?.split('T')[0]||'—'} · {item.approved_by||'Owner'}</div></div>
                <span style={{fontSize:11,fontWeight:600,color:'#1D9E75',background:'#E1F5EE',padding:'2px 8px',borderRadius:20}}>approved</span>
              </div>
            ))}
          </div>
        )}
        {appTab==='denied'&&(
          <div>
            {purchases.filter(p=>p.status==='denied').map(pr=>(
              <div key={pr.id} style={{background:'#fff',borderRadius:12,border:'0.5px solid rgba(0,0,0,0.08)',padding:12,marginBottom:6,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <div><div style={{fontSize:13,fontWeight:600}}>{pr.item_name}</div><div style={{fontSize:11,color:T.textMuted}}>{pr.denied_at?.split('T')[0]||'—'}</div></div>
                <span style={{fontSize:11,fontWeight:600,color:'#E24B4A',background:'#FCEBEB',padding:'2px 8px',borderRadius:20}}>denied</span>
              </div>
            ))}
            {purchases.filter(p=>p.status==='denied').length===0&&<div style={{color:'#aaa',textAlign:'center',padding:24}}>No denied requests</div>}
          </div>
        )}
      </div>
    ),

    itsupport:(
      <div>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:4}}>
          <div style={{fontSize:18,fontWeight:700,color:T.text}}>IT Support</div>
          <button onClick={()=>{setModal('newTicket');setForm({});}} style={{display:'flex',alignItems:'center',gap:6,padding:'8px 14px',background:'#185FA5',color:'#fff',border:'none',borderRadius:10,fontSize:13,fontWeight:600,cursor:'pointer'}}>{I.add}New Ticket</button>
        </div>
        <div style={{fontSize:12,color:T.textMuted,marginBottom:16}}>Submit issues to IT, Management, and Admins</div>

        {/* Quick stats */}
        <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:8,marginBottom:16}}>
          {([
            ['Open',tickets.filter(t=>t.status==='open').length,'#185FA5'],
            ['In Progress',tickets.filter(t=>t.status==='in_progress').length,'#EF9F27'],
            ['Resolved',tickets.filter(t=>t.status==='resolved').length,'#1D9E75'],
            ['Critical',tickets.filter(t=>t.priority==='critical'&&t.status!=='resolved').length,'#E24B4A'],
          ] as [string,number,string][]).map(([label,count,color])=>(
            <div key={label} style={{background:T.surface,borderRadius:12,padding:'12px 10px',border:`0.5px solid ${T.border}`,textAlign:'center'}}>
              <div style={{fontSize:22,fontWeight:700,color:count>0?color:T.textMuted}}>{count}</div>
              <div style={{fontSize:10,color:T.textMuted,marginTop:2}}>{label}</div>
            </div>
          ))}
        </div>

        {/* Tabs */}
        <div style={{display:'flex',gap:6,marginBottom:14,overflowX:'auto'}}>
          {['open','in_progress','resolved','all'].map(t=>(
            <button key={t} onClick={()=>setTicketTab(t)} style={{flexShrink:0,padding:'7px 12px',borderRadius:10,border:'none',background:ticketTab===t?'#185FA5':T.statBg,color:ticketTab===t?'#fff':T.textSub,fontSize:12,fontWeight:600,cursor:'pointer',whiteSpace:'nowrap'}}>
              {t==='in_progress'?'In Progress':t.charAt(0).toUpperCase()+t.slice(1)}
              <span style={{marginLeft:4,opacity:0.7}}>({t==='all'?tickets.length:tickets.filter(tk=>tk.status===t).length})</span>
            </button>
          ))}
        </div>

        {/* Ticket list */}
        {(ticketTab==='all'?tickets:tickets.filter(t=>t.status===ticketTab)).length===0
          ?<div style={{background:T.surface,borderRadius:14,padding:40,textAlign:'center',border:`0.5px solid ${T.border}`}}>
            <div style={{fontSize:28,marginBottom:8}}>🎉</div>
            <div style={{fontSize:15,fontWeight:600,color:T.text,marginBottom:4}}>No {ticketTab==='all'?'':ticketTab.replace('_',' ')} tickets</div>
            <div style={{fontSize:12,color:T.textMuted}}>Submit a ticket if you're having an IT issue</div>
          </div>
          :(ticketTab==='all'?tickets:tickets.filter(t=>t.status===ticketTab)).map(ticket=>{
            const priClr:{[k:string]:string}={critical:'#E24B4A',high:'#EF9F27',medium:'#185FA5',low:'#888'};
            const stClr:{[k:string]:string}={open:'#185FA5',in_progress:'#EF9F27',resolved:'#1D9E75',closed:'#888'};
            return(
              <div key={ticket.id} style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,borderLeft:`4px solid ${priClr[ticket.priority]||'#888'}`,padding:14,marginBottom:8}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:8}}>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4,flexWrap:'wrap'}}>
                      <span style={{fontSize:11,fontWeight:700,color:T.textMuted,fontFamily:'monospace'}}>{ticket.ticket_number}</span>
                      <span style={{fontSize:11,padding:'2px 8px',borderRadius:20,background:(stClr[ticket.status]||'#888')+'20',color:stClr[ticket.status]||'#888',fontWeight:600}}>{ticket.status.replace('_',' ')}</span>
                      <span style={{fontSize:11,padding:'2px 8px',borderRadius:20,background:(priClr[ticket.priority]||'#888')+'20',color:priClr[ticket.priority]||'#888',fontWeight:700}}>{ticket.priority}</span>
                    </div>
                    <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:2}}>{ticket.subject}</div>
                    <div style={{fontSize:12,color:T.textMuted}}>{ticket.category} · {ticket.submitted_by} · {ticket.created_at?.split('T')[0]}</div>
                  </div>
                  {/* Actions — IT/Admin/Management only */}
                  {(isAdmin||isManagement||isIT)&&ticket.status!=='resolved'&&(
                    <div style={{display:'flex',flexDirection:'column',gap:4,flexShrink:0,marginLeft:8}}>
                      {ticket.status==='open'&&(
                        <button onClick={async()=>{
                          await updateDoc(doc(db,'it_tickets',ticket.id),{status:'in_progress',assigned_to:user?.email,updated_at:new Date().toISOString()});
                          await addAct(`IT Ticket assigned: ${ticket.subject} → ${user?.email}`,'#EF9F27');
                          showToast('Ticket assigned to you');
                        }} style={{padding:'5px 10px',background:'#EF9F27',color:'#fff',border:'none',borderRadius:8,fontSize:11,fontWeight:600,cursor:'pointer',whiteSpace:'nowrap'}}>Assign to Me</button>
                      )}
                      <button onClick={async()=>{
                        const resolution=window.prompt('Resolution notes:');
                        if(!resolution)return;
                        await updateDoc(doc(db,'it_tickets',ticket.id),{status:'resolved',resolved_by:user?.email,resolution,resolved_at:new Date().toISOString(),updated_at:new Date().toISOString()});
                        await addAct(`IT Ticket resolved: ${ticket.subject} (${ticket.ticket_number})`,'#1D9E75');
                        showToast('Ticket resolved ✓');
                      }} style={{padding:'5px 10px',background:'#1D9E75',color:'#fff',border:'none',borderRadius:8,fontSize:11,fontWeight:600,cursor:'pointer'}}>Resolve</button>
                    </div>
                  )}
                </div>
                {ticket.description&&<div style={{fontSize:12,color:T.textSub,marginBottom:8,padding:'8px 10px',background:T.statBg,borderRadius:8,lineHeight:1.5}}>{ticket.description}</div>}
                {ticket.location&&<div style={{fontSize:11,color:T.textMuted,marginBottom:4}}>📍 {ticket.location}</div>}
                {ticket.assigned_to&&<div style={{fontSize:11,color:'#EF9F27',marginBottom:4}}>👤 Assigned to: {ticket.assigned_to}</div>}
                {ticket.resolution&&(
                  <div style={{fontSize:11,color:'#1D9E75',padding:'6px 10px',background:'#E1F5EE',borderRadius:6,marginTop:6}}>
                    ✓ Resolution: {ticket.resolution} — {ticket.resolved_by}
                  </div>
                )}
              </div>
            );
          })
        }
      </div>
    ),

    team:(
      <div>
        <div style={{fontSize:18,fontWeight:700,marginBottom:4,color:T.text}}>Team Management</div>
        <div style={{fontSize:12,color:T.textMuted,marginBottom:16}}>{isAdmin?'Only you can assign and change roles.':'Contact your Admin to update your role.'}</div>

        {/* Your profile card */}
        <div style={{background:'linear-gradient(135deg,#185FA5,#0C447C)',borderRadius:16,padding:16,marginBottom:16,color:'white',display:'flex',alignItems:'center',gap:12}}>
          <div style={{width:48,height:48,borderRadius:'50%',background:'rgba(255,255,255,0.2)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:20,fontWeight:700,flexShrink:0}}>
            {(userProfile?.name||user?.email||'?').charAt(0).toUpperCase()}
          </div>
          <div style={{flex:1}}>
            <div style={{fontSize:15,fontWeight:700}}>{userProfile?.name||user?.email?.split('@')[0]||'You'}</div>
            <div style={{fontSize:11,opacity:0.8}}>{user?.email}</div>
          </div>
          <span style={{fontSize:11,fontWeight:700,padding:'4px 12px',borderRadius:20,background:'rgba(255,255,255,0.2)'}}>
            {isAdmin?'ADMIN':userRole.toUpperCase()}
          </span>
        </div>

        {/* Role legend — all 5 roles */}
        <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:10}}>Available Roles</div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:20}}>
          {[
            {role:'admin',label:'Admin',color:'#185FA5',perms:['Full system access','Approve everything','Manage team','All reports & costs']},
            {role:'management',label:'Management',color:'#7F77DD',perms:['Approve WOs & POs','View all data','Handle IT tickets','No role management']},
            {role:'it',label:'IT',color:'#D4537E',perms:['IT support tickets','Assign & resolve issues','View system data','No approvals']},
            {role:'lead',label:'Lead',color:'#1D9E75',perms:['Approve WOs & POs','View all data','Create WOs','No role management']},
            {role:'tech',label:'Technician',color:'#EF9F27',perms:['Create work orders','Request purchases','Submit IT tickets','No approvals']},
          ].map(r=>(
            <div key={r.role} style={{background:T.surface,borderRadius:12,padding:12,border:`1.5px solid ${userRole===r.role?r.color:T.border}`}}>
              <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:6}}>
                <div style={{width:10,height:10,borderRadius:'50%',background:r.color,flexShrink:0}}/>
                <span style={{fontSize:13,fontWeight:700,color:r.color}}>{r.label}</span>
                {userRole===r.role&&<span style={{fontSize:9,fontWeight:700,color:r.color,background:r.color+'20',padding:'1px 6px',borderRadius:10}}>YOU</span>}
              </div>
              {r.perms.map((p,i)=>(
                <div key={i} style={{fontSize:10,color:p.startsWith('No')?T.textMuted:T.textSub,marginBottom:2,paddingLeft:14,position:'relative'}}>
                  <span style={{position:'absolute',left:0,color:p.startsWith('No')?T.textMuted:'#1D9E75'}}>{p.startsWith('No')?'✗':'✓'}</span>{p}
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* Team Members */}
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
          <div style={{fontSize:13,fontWeight:700,color:T.text}}>Team Members ({teamMembers.length})</div>
          {isAdmin&&<div style={{fontSize:11,color:T.textMuted}}>Tap a role button to reassign</div>}
        </div>

        {teamMembers.length===0?(
          <div style={{background:T.surface,borderRadius:14,padding:32,textAlign:'center',border:`0.5px solid ${T.border}`}}>
            <div style={{fontSize:24,marginBottom:8}}>👥</div>
            <div style={{fontSize:14,fontWeight:600,color:T.text,marginBottom:4}}>No team members yet</div>
            <div style={{fontSize:12,color:T.textMuted}}>Share <strong>forgeos-five.vercel.app</strong> — they appear here after first login</div>
          </div>
        ):(
          <div>
            {(['admin','management','it','lead','tech'] as string[]).map(roleGroup=>{
              const members=teamMembers.filter(m=>{
                const isOwner=m.email==='damon.pope@forgebytetechnologies.com';
                const effectiveRole=isOwner?'admin':m.role||'tech';
                return effectiveRole===roleGroup;
              });
              if(members.length===0)return null;
              const roleClr:{[k:string]:string}={admin:'#185FA5',management:'#7F77DD',it:'#D4537E',lead:'#1D9E75',tech:'#EF9F27'};
              const roleLabel:{[k:string]:string}={admin:'Administrator',management:'Management',it:'IT',lead:'Lead',tech:'Technician'};
              return(
                <div key={roleGroup} style={{marginBottom:16}}>
                  <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:8}}>
                    <div style={{width:8,height:8,borderRadius:'50%',background:roleClr[roleGroup],flexShrink:0}}/>
                    <span style={{fontSize:12,fontWeight:700,color:roleClr[roleGroup],textTransform:'uppercase',letterSpacing:'0.5px'}}>{roleLabel[roleGroup]}</span>
                    <span style={{fontSize:11,color:T.textMuted}}>({members.length})</span>
                  </div>
                  {members.map(member=>{
                    const isOwner=member.email==='damon.pope@forgebytetechnologies.com';
                    const isCurrentUser=member.uid===user?.uid;
                    const effectiveRole=isOwner?'admin':member.role||'tech';
                    return(
                      <div key={member.uid} style={{background:T.surface,borderRadius:12,border:`0.5px solid ${T.border}`,padding:14,marginBottom:6}}>
                        <div style={{display:'flex',alignItems:'center',gap:12}}>
                          {/* Avatar */}
                          <div style={{width:40,height:40,borderRadius:'50%',background:roleClr[effectiveRole]||'#888',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontSize:15,fontWeight:700,flexShrink:0}}>
                            {(member.name||member.email||'?').charAt(0).toUpperCase()}
                          </div>
                          {/* Info */}
                          <div style={{flex:1,minWidth:0}}>
                            <div style={{display:'flex',alignItems:'center',gap:6,flexWrap:'wrap'}}>
                              <span style={{fontSize:13,fontWeight:700,color:T.text}}>{member.name||member.email?.split('@')[0]}</span>
                              {isCurrentUser&&<span style={{fontSize:9,background:T.statBg,color:T.textMuted,padding:'1px 6px',borderRadius:10,fontWeight:600}}>You</span>}
                              {isOwner&&<span style={{fontSize:9,background:'#185FA5',color:'#fff',padding:'1px 6px',borderRadius:10,fontWeight:600}}>Owner</span>}
                            </div>
                            <div style={{fontSize:11,color:T.textMuted,marginTop:2,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{member.email}</div>
                            {member.created_at&&<div style={{fontSize:10,color:T.textMuted,marginTop:3}}>Since: {member.created_at?.split('T')[0]}</div>}
                          </div>
                          {/* Role change — admin only, can't change owner */}
                          {isAdmin&&!isOwner&&(
                            <div style={{display:'flex',flexDirection:'column',gap:3,flexShrink:0}}>
                              {(['admin','management','it','lead','tech'] as string[]).map(r=>(
                                <button key={r} onClick={async()=>{
                                  if(r===effectiveRole)return;
                                  const rNames:{[k:string]:string}={admin:'Admin',management:'Management',it:'IT',lead:'Lead',tech:'Tech'};
                                  const ok=window.confirm(`Change ${member.name||member.email} to ${rNames[r]}?`);
                                  if(!ok)return;
                                  await updateDoc(doc(db,'users',member.uid),{role:r});
                                  await addAct(`Role updated: ${member.email} → ${rNames[r]} (by ${user?.email})`,'#185FA5');
                                  showToast(`${member.name||member.email?.split('@')[0]} → ${rNames[r]} ✓`);
                                }} style={{
                                  padding:'4px 8px',fontSize:10,fontWeight:700,border:'none',
                                  borderRadius:6,cursor:r===effectiveRole?'default':'pointer',
                                  background:r===effectiveRole?roleClr[r]:T.statBg,
                                  color:r===effectiveRole?'#fff':T.textMuted,
                                  opacity:r===effectiveRole?1:0.8,
                                  minWidth:72,
                                }}>
                                  {r==='admin'?'Admin':r==='management'?'Mgmt':r==='it'?'IT':r==='lead'?'Lead':'Tech'}
                                </button>
                              ))}
                            </div>
                          )}
                          {isOwner&&(
                            <span style={{fontSize:11,fontWeight:700,padding:'4px 12px',borderRadius:20,background:'#185FA5',color:'#fff',flexShrink:0}}>ADMIN</span>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        )}

        {/* Invite info */}
        <div style={{background:'#E6F1FB',borderRadius:12,padding:14,marginTop:4}}>
          <div style={{fontSize:12,fontWeight:700,color:'#185FA5',marginBottom:4}}>Adding Team Members</div>
          <div style={{fontSize:11,color:'#185FA5',lineHeight:1.6}}>
            Share <strong>forgeos-five.vercel.app</strong> with your team. They sign in with their own email and appear here automatically. New members default to Technician until you assign a role.
          </div>
        </div>
      </div>
    ),

    records:(
      <div>
        <div style={{fontSize:18,fontWeight:700,marginBottom:4,color:T.text}}>Records & History</div>
        <div style={{fontSize:12,color:T.textMuted,marginBottom:14}}>Full archive of all work orders, purchase orders, and maintenance tasks</div>

        {/* Tab switcher */}
        <div style={{display:'flex',gap:6,marginBottom:14}}>
          {[
            ['workorders','Work Orders',workOrders.length] as [string,string,number],
            ['purchases','Purchase Orders',purchases.length] as [string,string,number],
            ['maintenance','Maintenance',[...histMaint,...maintenance.filter((m:any)=>m.status==='completed'&&!histMaint.some((h:any)=>h.original_id===m.id))].length] as [string,string,number],
          ].map(([t,label,count])=>(
            <button key={t} onClick={()=>setRecordsTab(t as any)} style={{flex:1,padding:'9px 6px',borderRadius:10,border:'none',background:recordsTab===t?T.blue:T.statBg,color:recordsTab===t?'#fff':T.text,fontSize:11,fontWeight:600,cursor:'pointer'}}>
              {label}<br/><span style={{fontSize:10,opacity:0.8}}>{count} records</span>
            </button>
          ))}
        </div>

        {/* Search */}
        <input value={recordsSearch} onChange={e=>setRecordsSearch(e.target.value)} placeholder={`Search ${recordsTab === 'workorders' ? 'work orders' : recordsTab === 'purchases' ? 'purchase orders' : 'maintenance records'}…`} style={{width:'100%',padding:'11px 14px',fontSize:14,border:`1px solid ${T.inputBorder}`,borderRadius:10,marginBottom:12,outline:'none',fontFamily:'inherit',background:T.input,color:T.text}}/>

        {/* Work Orders History */}
        {recordsTab==='workorders'&&(
          <div>
            {workOrders.filter(w=>!recordsSearch||`${w.title}${w.printer_name}${w.wo_number}${w.assigned_to}`.toLowerCase().includes(recordsSearch.toLowerCase())).length===0
              ?<div style={{background:T.surface,borderRadius:14,padding:32,textAlign:'center',color:T.textMuted,border:`0.5px solid ${T.border}`}}>No work orders found.</div>
              :workOrders.filter(w=>!recordsSearch||`${w.title}${w.printer_name}${w.wo_number}${w.assigned_to}`.toLowerCase().includes(recordsSearch.toLowerCase())).map(wo=>{
                const stClr:{[k:string]:string}={open:'#185FA5',in_progress:'#1D9E75',pending_approval:'#EF9F27',completed:'#888',cancelled:'#E24B4A'};
                return(
                  <div key={wo.id} style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,padding:14,marginBottom:8}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:8}}>
                      <div style={{flex:1}}>
                        <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4,flexWrap:'wrap'}}>
                          <span style={{fontSize:11,fontWeight:700,color:'#aaa',fontFamily:'monospace'}}>#{wo.wo_number||wo.id.slice(-6).toUpperCase()}</span>
                          <span style={{fontSize:11,padding:'2px 8px',borderRadius:20,background:(stClr[wo.status]||'#888')+'20',color:stClr[wo.status]||'#888',fontWeight:600}}>{wo.status.replace(/_/g,' ')}</span>
                        </div>
                        <div style={{fontSize:14,fontWeight:700,marginBottom:2}}>{wo.title}</div>
                        <div style={{fontSize:12,color:T.textMuted}}>{wo.printer_name} · {wo.assigned_to||'Unassigned'}</div>
                      </div>
                    </div>
                    <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:6,marginBottom:wo.parts_used?.length?8:0}}>
                      {[
                        ['Created',wo.created_at?.split('T')[0]||'—'],
                        ['Parts Cost',`$${(wo.parts_cost||0).toFixed(2)}`],
                        ['Labor',`${wo.labor_min||0}min`],
                        ['Approved By',wo.approved_by||'—'],
                      ].map(([l,v])=>(
                        <div key={l} style={{background:T.statBg,borderRadius:8,padding:'6px 8px'}}>
                          <div style={{fontSize:9,color:'#aaa',marginBottom:1}}>{l}</div>
                          <div style={{fontSize:11,fontWeight:600,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{v}</div>
                        </div>
                      ))}
                    </div>
                    {wo.parts_used?.length>0&&(
                      <div style={{padding:'8px 10px',background:T.surfaceAlt,borderRadius:8}}>
                        <div style={{fontSize:11,fontWeight:600,color:T.textSub,marginBottom:4}}>Parts Checked Out:</div>
                        {wo.parts_used.map((p:any,i:number)=>(
                          <div key={i} style={{display:'flex',justifyContent:'space-between',fontSize:11,color:T.textSub}}>
                            <span>{p.qty}x {p.name}</span>
                            <span style={{color:'#E24B4A',fontWeight:600}}>-{p.qty} units · ${((p.cost||0)).toFixed(2)}</span>
                          </div>
                        ))}
                      </div>
                    )}
                    {wo.description&&<div style={{fontSize:12,color:T.textSub,marginTop:8,lineHeight:1.4}}>{wo.description}</div>}
                  </div>
                );
              })
            }
          </div>
        )}

        {/* Purchase Orders History */}
        {recordsTab==='purchases'&&(
          <div>
            {purchases.filter(p=>!recordsSearch||`${p.title}${p.po_number}${p.vendor}${(p.line_items||[]).map((l:any)=>l.name).join(' ')}`.toLowerCase().includes(recordsSearch.toLowerCase())).length===0
              ?<div style={{background:T.surface,borderRadius:14,padding:32,textAlign:'center',color:T.textMuted,border:`0.5px solid ${T.border}`}}>No purchase orders found.</div>
              :purchases.filter(p=>!recordsSearch||`${p.title}${p.po_number}${p.vendor}${(p.line_items||[]).map((l:any)=>l.name).join(' ')}`.toLowerCase().includes(recordsSearch.toLowerCase())).map(pr=>{
                const stClr:{[k:string]:string}={pending:'#EF9F27',approved:'#1D9E75',ordered:'#185FA5',received:'#888',denied:'#E24B4A',draft:'#aaa'};
                const total=(pr.line_items||[]).reduce((s:number,i:any)=>s+((i.qty||1)*(i.unit_price||0)),0)||pr.total_cost||0;
                return(
                  <div key={pr.id} style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,padding:14,marginBottom:8}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:8}}>
                      <div style={{flex:1}}>
                        <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4,flexWrap:'wrap'}}>
                          <span style={{fontSize:11,fontWeight:700,color:'#aaa',fontFamily:'monospace'}}>{pr.po_number||'PR-'+pr.id.slice(-6).toUpperCase()}</span>
                          <span style={{fontSize:11,padding:'2px 8px',borderRadius:20,background:(stClr[pr.status]||'#888')+'20',color:stClr[pr.status]||'#888',fontWeight:600}}>{pr.status}</span>
                          {pr.urgency==='urgent'&&<span style={{fontSize:11,fontWeight:700,color:'#E24B4A'}}>URGENT</span>}
                        </div>
                        <div style={{fontSize:14,fontWeight:700,marginBottom:2}}>{pr.title||pr.item_name}</div>
                        <div style={{fontSize:12,color:T.textMuted}}>{pr.vendor||'No vendor'} · Requested by: {pr.requested_by_role||'tech'}</div>
                      </div>
                      <div style={{fontSize:16,fontWeight:800,color:'#185FA5',flexShrink:0,marginLeft:8}}>${total.toFixed(2)}</div>
                    </div>
                    {pr.line_items?.length>0&&(
                      <div style={{padding:'8px 10px',background:'#f8f8f7',borderRadius:8,marginBottom:8}}>
                        {pr.line_items.map((li:any,i:number)=>(
                          <div key={i} style={{display:'flex',justifyContent:'space-between',fontSize:11,padding:'3px 0',borderBottom:`0.5px solid ${T.border}`}}>
                            <span style={{flex:1}}>{li.qty}x {li.name} <span style={{color:'#aaa'}}>({li.type})</span>{li.notes?` — ${li.notes}`:''}</span>
                            <span style={{fontWeight:600,flexShrink:0,marginLeft:8}}>${((li.qty||1)*(li.unit_price||0)).toFixed(2)}</span>
                          </div>
                        ))}
                        <div style={{display:'flex',justifyContent:'space-between',fontWeight:700,fontSize:12,marginTop:4,color:'#185FA5'}}><span>Total</span><span>${total.toFixed(2)}</span></div>
                      </div>
                    )}
                    <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:6}}>
                      {[
                        ['Requested',pr.created_at?.split('T')[0]||'—'],
                        ['Approved By',pr.approved_by||'—'],
                        ['Received',pr.received_at?.split('T')[0]||pr.status==='received'?'Yes':'—'],
                      ].map(([l,v])=>(
                        <div key={l} style={{background:T.statBg,borderRadius:8,padding:'6px 8px'}}>
                          <div style={{fontSize:9,color:'#aaa',marginBottom:1}}>{l}</div>
                          <div style={{fontSize:11,fontWeight:600}}>{v}</div>
                        </div>
                      ))}
                    </div>
                    {pr.reason&&<div style={{fontSize:11,color:T.textMuted,marginTop:8}}>Justification: {pr.reason}</div>}
                  </div>
                );
              })
            }
          </div>
        )}

        {/* Maintenance History */}
        {recordsTab==='maintenance'&&(
          <div>
            {[...histMaint,...maintenance.filter(m=>m.status==='completed'&&!histMaint.some(h=>h.original_id===m.id))].filter(m=>!recordsSearch||`${m.task}${m.printer_name}${m.submitted_by||''}${m.approved_by||''}`.toLowerCase().includes(recordsSearch.toLowerCase())).length===0
              ?<div style={{background:T.surface,borderRadius:14,padding:32,textAlign:'center',color:T.textMuted,border:`0.5px solid ${T.border}`}}>No maintenance history yet. Tasks appear here when submitted for approval.</div>
              :[...histMaint,...maintenance.filter(m=>m.status==='completed'&&!histMaint.some(h=>h.original_id===m.id))].filter(m=>!recordsSearch||`${m.task}${m.printer_name}${m.submitted_by||''}${m.approved_by||''}`.toLowerCase().includes(recordsSearch.toLowerCase())).map(m=>{
                const urgClr:{[k:string]:string}={high:'#E24B4A',med:'#EF9F27',low:'#1D9E75'};
                const stClr:{[k:string]:string}={completed:'#1D9E75',pending_approval:'#EF9F27',upcoming:'#185FA5'};
                return(
                  <div key={m.id} style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,borderLeft:`4px solid ${urgClr[m.urgency]||'#888'}`,padding:14,marginBottom:8}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:8}}>
                      <div style={{flex:1}}>
                        <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
                          <span style={{fontSize:11,padding:'2px 8px',borderRadius:20,background:(stClr[m.status]||'#888')+'20',color:stClr[m.status]||'#888',fontWeight:600}}>{m.status.replace(/_/g,' ')}</span>
                          <span style={{fontSize:11,fontWeight:600,color:urgClr[m.urgency]||'#888'}}>{m.urgency==='med'?'Medium':m.urgency?.charAt(0).toUpperCase()+m.urgency?.slice(1)} Priority</span>
                        </div>
                        <div style={{fontSize:14,fontWeight:700,marginBottom:2}}>{m.task}</div>
                        <div style={{fontSize:12,color:T.textMuted}}>{m.printer_name}</div>
                      </div>
                    </div>
                    <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:6,marginBottom:m.parts_needed?8:0}}>
                      {[
                        ['Due',m.due_date||'—'],
                        ['Parts Cost',`$${(m.parts_cost||0).toFixed(2)}`],
                        ['Labor',`${m.labor_min||0}min`],
                        ['Approved By',m.approved_by||'Pending'],
                      ].map(([l,v])=>(
                        <div key={l} style={{background:T.statBg,borderRadius:8,padding:'6px 8px'}}>
                          <div style={{fontSize:9,color:'#aaa',marginBottom:1}}>{l}</div>
                          <div style={{fontSize:11,fontWeight:600,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{v}</div>
                        </div>
                      ))}
                    </div>
                    {m.parts_needed&&<div style={{fontSize:11,color:T.textSub,padding:'6px 8px',background:T.surfaceAlt,borderRadius:6}}>Parts: {m.parts_needed}</div>}
                    {m.notes&&<div style={{fontSize:11,color:T.textMuted,marginTop:6}}>{m.notes}</div>}
                    <div style={{display:'flex',gap:12,marginTop:8,fontSize:10,color:'#aaa'}}>
                      {m.submitted_by&&<span>Submitted: {m.submitted_by}</span>}
                      {m.submitted_at&&<span>{m.submitted_at.split('T')[0]}</span>}
                      {m.approved_by&&<span>· Approved: {m.approved_by}</span>}
                    </div>
                  </div>
                );
              })
            }
          </div>
        )}
      </div>
    ),

    settings:(
      <div>
        <div style={{fontSize:18,fontWeight:700,marginBottom:4,color:T.text}}>Settings</div>
        <div style={{fontSize:12,color:T.textMuted,marginBottom:16}}>ForgeByte Technologies LLC · ForgeOS</div>

        {/* Security status */}
        <div style={{background:'#E1F5EE',borderRadius:14,border:'1px solid #9FE1CB',padding:'12px 16px',marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:700,color:'#085041',marginBottom:6}}>🔒 Security Status</div>
          <div style={{fontSize:11,color:'#0F6E56',lineHeight:1.7}}>
            ✓ Printer API keys routed through secure server proxy<br/>
            ✓ Prusa Connect, Bambu Labs, OctoPrint & Klipper — all server-side<br/>
            ✓ Firebase Auth — email/password with session tokens<br/>
            ✓ Firestore — per-user data, role-gated access<br/>
            ✓ All data encrypted in transit (HTTPS/TLS)
          </div>
        </div>


        {/* Export Data */}
        <div style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,overflow:'hidden',marginBottom:14}}>
          <div style={{padding:'14px 16px',borderBottom:`0.5px solid ${T.border}`}}>
            <div style={{fontSize:14,fontWeight:700}}>Export Data</div>
            <div style={{fontSize:11,color:T.textMuted,marginTop:1}}>Download your farm data as CSV</div>
          </div>
          <div style={{padding:'10px 16px',display:'flex',flexWrap:'wrap',gap:8}}>
            {[
              {label:'Filament Inventory',data:()=>filaments.map(f=>`${f.material},${f.brand},${f.color},${f.weight_g},${f.remaining_pct}%,$${f.cost_per_kg},${f.location}`),headers:'Material,Brand,Color,Weight,Remaining,Cost/kg,Location'},
              {label:'Equipment',data:()=>equipment.map(e=>`${e.name},${e.type},${e.serial_number},${e.quantity},$${e.unit_cost||0},${e.location}`),headers:'Name,Type,Serial,Qty,Unit Cost,Location'},
              {label:'Job History',data:()=>history.map(j=>`${j.job_name},${j.printer_name},${j.material},${j.status},${j.completed_at?.split('T')[0]||''},${j.filament_used_g||0}g`),headers:'Job,Printer,Material,Status,Date,Filament Used'},
              {label:'Maintenance',data:()=>maintenance.map(m=>`${m.task},${m.printer_name},${m.status},${m.due_date},$${m.parts_cost||0},${m.labor_min||0}min`),headers:'Task,Printer,Status,Due Date,Parts Cost,Labor'},
              {label:'Work Orders',data:()=>workOrders.map(w=>`${w.wo_number||w.id.slice(-6)},${w.title},${w.printer_name},${w.status},$${w.parts_cost||0},${w.created_at?.split('T')[0]||''}`),headers:'WO#,Title,Printer,Status,Cost,Created'},
              {label:'Purchase Orders',data:()=>purchases.map(p=>`${p.po_number||p.id.slice(-6)},${p.title||p.item_name},${p.vendor||''},${p.status},$${p.total_cost||0},${p.created_at?.split('T')[0]||''}`),headers:'PO#,Title,Vendor,Status,Total,Created'},
              {label:'Customers',data:()=>customers.map(c=>`${c.name},${c.contact||''},${c.email||''},${c.total_jobs||0},$${c.total_revenue||0}`),headers:'Name,Contact,Email,Jobs,Revenue'},
            ].map(exp=>(
              <button key={exp.label} onClick={()=>{
                const rows=[exp.headers,...exp.data()];
                const csv=rows.join('\n');
                const blob=new Blob([csv],{type:'text/csv'});
                const url=URL.createObjectURL(blob);
                const a=document.createElement('a');
                a.href=url;a.download=`forgeos-${exp.label.toLowerCase().replace(/ /g,'-')}-${new Date().toISOString().split('T')[0]}.csv`;
                a.click();URL.revokeObjectURL(url);
                showToast(`${exp.label} exported ✓`);
              }} style={{padding:'8px 14px',background:'#f0f0f0',color:T.textSub,border:'none',borderRadius:8,fontSize:12,fontWeight:600,cursor:'pointer'}}>
                ↓ {exp.label}
              </button>
            ))}
          </div>
        </div>

        {/* Notifications */}
        <div style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,overflow:'hidden',marginBottom:14}}>
          <div style={{padding:'14px 16px',borderBottom:`0.5px solid ${T.border}`,display:'flex',alignItems:'center',gap:10}}>
            <div style={{width:32,height:32,borderRadius:10,background:'#E6F1FB',display:'flex',alignItems:'center',justifyContent:'center'}}>{I.bell}</div>
            <div><div style={{fontSize:14,fontWeight:700}}>Notifications & Alerts</div><div style={{fontSize:11,color:T.textMuted,marginTop:1}}>In-app alerts for your print farm</div></div>
          </div>
          {[
            {key:'printerError',label:'Printer Errors',sub:'Alert when a printer reports an error',color:'#E24B4A'},
            {key:'printerComplete',label:'Print Complete',sub:'Alert when a job finishes',color:'#1D9E75'},
            {key:'printerOffline',label:'Printer Offline',sub:'Alert when a connected printer goes offline',color:'#EF9F27'},
            {key:'lowFilament',label:'Low Filament',sub:'Alert when a spool drops below 20%',color:'#185FA5'},
            {key:'maintenanceDue',label:'Maintenance Due',sub:'Alert for overdue maintenance tasks',color:'#EF9F27'},
            {key:'queueEmpty',label:'Queue Empty',sub:'Alert when the print queue runs out',color:'#7F77DD'},
          ].map(item=>(
            <div key={item.key} style={{display:'flex',alignItems:'center',padding:'13px 16px',borderBottom:`0.5px solid ${T.border}`}}>
              <div style={{width:8,height:8,borderRadius:'50%',background:item.color,marginRight:12,flexShrink:0}}/>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:600}}>{item.label}</div>
                <div style={{fontSize:11,color:T.textMuted,marginTop:2}}>{item.sub}</div>
              </div>
              <div onClick={()=>setNotifSettings(n=>({...n,[item.key]:!n[item.key as keyof typeof n]}))}
                style={{width:44,height:26,borderRadius:13,background:notifSettings[item.key as keyof typeof notifSettings]?'#185FA5':'#ddd',cursor:'pointer',transition:'background 0.2s',flexShrink:0,position:'relative'}}>
                <div style={{position:'absolute',top:3,left:notifSettings[item.key as keyof typeof notifSettings]?18:3,width:20,height:20,borderRadius:'50%',background:'#fff',transition:'left 0.2s',boxShadow:'0 1px 3px rgba(0,0,0,0.2)'}}/>
              </div>
            </div>
          ))}
          <div style={{display:'flex',alignItems:'center',padding:'13px 16px',borderBottom:`0.5px solid ${T.border}`}}>
            <div style={{width:8,height:8,borderRadius:'50%',background:'#333',marginRight:12,flexShrink:0}}/>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:600}}>Vibrate on Alert</div>
              <div style={{fontSize:11,color:T.textMuted,marginTop:2}}>Vibrate device when alert triggers</div>
            </div>
            <div onClick={()=>setNotifSettings(n=>({...n,vibrate:!n.vibrate}))}
              style={{width:44,height:26,borderRadius:13,background:notifSettings.vibrate?'#185FA5':'#ddd',cursor:'pointer',transition:'background 0.2s',flexShrink:0,position:'relative'}}>
              <div style={{position:'absolute',top:3,left:notifSettings.vibrate?18:3,width:20,height:20,borderRadius:'50%',background:'#fff',transition:'left 0.2s',boxShadow:'0 1px 3px rgba(0,0,0,0.2)'}}/>
            </div>
          </div>
          <div style={{padding:'12px 16px',background:'#f8f8f7'}}>
            <div style={{fontSize:11,color:T.textMuted}}>Active alerts show as colored banners on the dashboard. Future app version will support push notifications.</div>
          </div>
        </div>

        {/* Current Alerts */}
        <div style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,overflow:'hidden',marginBottom:14}}>
          <div style={{padding:'14px 16px',borderBottom:`0.5px solid ${T.border}`}}>
            <div style={{fontSize:14,fontWeight:700}}>Current Alerts</div>
          </div>
          <div style={{padding:'10px 16px'}}>
            {printers.filter(p=>p.status==='error').map(p=>(
              <div key={p.id} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 0',borderBottom:`0.5px solid ${T.border}`}}>
                <div style={{width:8,height:8,borderRadius:'50%',background:'#E24B4A',flexShrink:0}}/>
                <div style={{fontSize:13,color:'#A32D2D',fontWeight:500}}>Printer error: {p.name}</div>
              </div>
            ))}
            {overdue.map(m=>(
              <div key={m.id} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 0',borderBottom:`0.5px solid ${T.border}`}}>
                <div style={{width:8,height:8,borderRadius:'50%',background:'#EF9F27',flexShrink:0}}/>
                <div style={{fontSize:13,color:'#854F0B',fontWeight:500}}>Overdue: {m.task} on {m.printer_name}</div>
              </div>
            ))}
            {lowStock.map(f=>(
              <div key={f.id} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 0',borderBottom:`0.5px solid ${T.border}`}}>
                <div style={{width:8,height:8,borderRadius:'50%',background:'#185FA5',flexShrink:0}}/>
                <div style={{fontSize:13,color:T.textSub,fontWeight:500}}>Low stock: {f.brand} {f.material} {f.color} ({f.remaining_pct}%)</div>
              </div>
            ))}
            {!printers.some(p=>p.status==='error')&&!overdue.length&&!lowStock.length&&(
              <div style={{fontSize:13,color:'#1D9E75',fontWeight:500,padding:'8px 0'}}>✓ All clear — no active alerts</div>
            )}
          </div>
        </div>

        {/* Farm Summary */}
        <div style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,overflow:'hidden',marginBottom:14}}>
          <div style={{padding:'14px 16px',borderBottom:`0.5px solid ${T.border}`}}>
            <div style={{fontSize:14,fontWeight:700}}>Farm Summary</div>
          </div>
          <div style={{padding:'4px 0'}}>
            {[
              ['Total Printers',printers.length],
              ['Currently Printing',printing],
              ['Filament Spools',filaments.length],
              ['Inventory Value',`$${invVal.toFixed(2)}`],
              ['Jobs Completed',history.filter(j=>j.status==='completed').length],
              ['Jobs in Queue',queue.length],
              ['Maintenance Upcoming',maintenance.filter(m=>m.status==='upcoming').length],
              ['Maintenance Overdue',overdue.length],
            ].map(([label,val])=>(
              <div key={String(label)} style={{display:'flex',justifyContent:'space-between',padding:'11px 16px',borderBottom:`0.5px solid ${T.border}`}}>
                <span style={{fontSize:13,color:T.textSub}}>{label}</span>
                <span style={{fontSize:13,fontWeight:700,color:T.text}}>{val}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Team shortcut */}
        <div style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,overflow:'hidden',marginBottom:14,cursor:'pointer'}} onClick={()=>nav('team')}>
          <div style={{padding:'14px 16px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div style={{display:'flex',alignItems:'center',gap:12}}>
              <div style={{width:36,height:36,borderRadius:10,background:'#E6F1FB',display:'flex',alignItems:'center',justifyContent:'center'}}>{I.team}</div>
              <div>
                <div style={{fontSize:14,fontWeight:700}}>Team Management</div>
                <div style={{fontSize:11,color:T.textMuted,marginTop:1}}>{teamMembers.length} member{teamMembers.length!==1?'s':''} · {isAdmin?'You can manage roles':'View your role and team'}</div>
              </div>
            </div>
            <span style={{color:'#aaa',fontSize:16}}>→</span>
          </div>
        </div>

                {/* Account */}
        <div style={{background:T.surface,borderRadius:14,border:`0.5px solid ${T.border}`,overflow:'hidden',marginBottom:14}}>
          <div style={{padding:'14px 16px',borderBottom:`0.5px solid ${T.border}`}}>
            <div style={{fontSize:14,fontWeight:700}}>Account</div>
          </div>
          <div style={{padding:'14px 16px',borderBottom:`0.5px solid ${T.border}`}}>
            <div style={{fontSize:11,color:'#aaa',marginBottom:2}}>Signed in as</div>
            <div style={{fontSize:13,fontWeight:600}}>{user?.email}</div>
          </div>
          <div style={{padding:'14px 16px',borderBottom:`0.5px solid ${T.border}`}}>
            <div style={{fontSize:11,color:'#aaa',marginBottom:2}}>Company</div>
            <div style={{fontSize:13,fontWeight:600}}>ForgeByte Technologies LLC</div>
            <div style={{fontSize:11,color:T.textMuted}}>CAD · Additive Mfg · Engineering · Janesville, Wisconsin</div>
          </div>
          <div style={{padding:'14px 16px',borderBottom:`0.5px solid ${T.border}`}}>
            <div style={{fontSize:11,color:'#aaa',marginBottom:2}}>App Version</div>
            <div style={{fontSize:13,fontWeight:600}}>ForgeOS v1.0 · Print Farm Command</div>
          </div>
          <div style={{padding:'14px 16px'}}>
            <button onClick={()=>fbSignOut(auth)} style={{width:'100%',padding:'13px',background:'#FCEBEB',color:'#A32D2D',border:'none',borderRadius:12,fontSize:14,fontWeight:700,cursor:'pointer'}}>Sign Out</button>
          </div>
        </div>
      </div>
    ),

  };

  // ── MODALS ────────────────────────────────────────────────
  const inp=(label:string,key:string,placeholder:string,type='text',defaultVal:any='')=>(
    <div style={{marginBottom:12}}>
      <label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>{label}</label>
      <input type={type} value={form[key]??defaultVal} onChange={e=>setForm((f:any)=>({...f,[key]:e.target.value}))} placeholder={placeholder} style={{width:'100%',padding:'11px 13px',fontSize:14,border:`1px solid ${T.inputBorder}`,borderRadius:10,fontFamily:'inherit',outline:'none',background:T.input,color:T.text}}/>
    </div>
  );
  const sel=(label:string,key:string,opts:string[],defaultVal:string='')=>(
    <div style={{marginBottom:12}}>
      <label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>{label}</label>
      <select value={form[key]||defaultVal} onChange={e=>setForm((f:any)=>({...f,[key]:e.target.value}))} style={{width:'100%',padding:'11px 13px',fontSize:14,border:`1px solid ${T.inputBorder}`,borderRadius:10,fontFamily:'inherit',outline:'none',background:T.input,color:T.text}}>{opts.map(o=><option key={o}>{o}</option>)}</select>
    </div>
  );
  const row2=(a:React.ReactNode,b:React.ReactNode)=><div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>{a}{b}</div>;

  const modalContent:Record<string,React.ReactNode>={
    filament:<>
      <button onClick={()=>{
        setBcResult(null);
        scanWithCamera(async(code)=>{
          if(navigator.vibrate)navigator.vibrate(100);
          const existing=filaments.find(x=>x.barcode===code);
          if(existing){
            // Pre-fill with existing details so user can add another identical spool
            setForm((f:any)=>({
              ...f,
              barcode:code,
              material:existing.material,
              brand:existing.brand,
              color:existing.color,
              weight:existing.weight_g,
              cost:existing.cost_per_kg,
              location:existing.location,
            }));
            showToast(`Same barcode — details pre-filled. Tap Save to add another spool.`);
          } else {
            setForm((f:any)=>({...f,barcode:code}));
            showToast(`New barcode scanned — fill in details and save.`);
          }
        },
        (err)=>showToast(err));
      }} style={{width:'100%',padding:'12px',background:'#185FA5',color:'#fff',border:'none',borderRadius:12,fontSize:14,fontWeight:700,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:8,marginBottom:14}}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round"><path d="M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2"/><line x1="3" y1="12" x2="21" y2="12"/></svg>
        Scan Barcode to Auto-Fill
      </button>
      {form.barcode&&<div style={{fontSize:11,color:T.textMuted,marginBottom:12,fontFamily:'monospace',background:T.surfaceAlt,padding:'6px 10px',borderRadius:6}}>✓ Barcode: {form.barcode}</div>}
      {sel('Material','material',['PLA','PLA+','PLA-CF','PETG','PETG-CF','ABS','ASA','TPU','TPE','Nylon','Nylon-CF','PA12','PA12-CF','PC','PC-ABS','HIPS','PVA','BVOH','CPE','CPE+','PP','PEI (ULTEM)','PEEK','PEKK','PAHT-CF','PHA','Flex','Silk PLA','Matte PLA','Wood Fill','Metal Fill','Glow Fill','Marble Fill','Rainbow','Other'],'PLA')}
      {row2(inp('Brand','brand','Hatchbox'),inp('Color','color','Black'))}
      {row2(inp('Weight (g)','weight','1000','number',1000),sel('Diameter','diameter',['1.75mm','2.85mm','3.00mm'],'1.75mm'))}
      {row2(inp('Purchase Price ($)','purchase_price','24.99','number',24.99),inp('Cost per kg ($)','cost','24.99','number',24.99))}
      {row2(inp('Supplier / Store','supplier','Amazon, local store…'),inp('Storage Location','location','Shelf A'))}
      <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Notes</label><textarea value={form.notes||''} onChange={e=>setForm((f:any)=>({...f,notes:e.target.value}))} placeholder="Print temp, bed temp, special settings…" style={{width:'100%',padding:'10px 12px',fontSize:13,border:'1px solid #e0e0e0',borderRadius:10,fontFamily:'inherit',outline:'none',minHeight:60,resize:'vertical'}}/></div>
    </>,
    equipment:<>
      <button onClick={()=>{
        scanWithCamera((code)=>{
          if(navigator.vibrate)navigator.vibrate(100);
          const existing=equipment.find(x=>x.barcode===code);
          if(existing){
            setForm((f:any)=>({...f,barcode:code,name:existing.name,type:existing.type,serial:existing.serial_number,qty:existing.quantity,location:existing.location,unit_cost:existing.unit_cost||''}));
            showToast('Same item — details pre-filled. Tap Save to add another.');
          } else {
            setForm((f:any)=>({...f,barcode:code}));
            showToast('New barcode scanned — fill in details and save.');
          }
        },(err)=>showToast(err));
      }} style={{width:'100%',padding:'12px',background:'#185FA5',color:'#fff',border:'none',borderRadius:12,fontSize:14,fontWeight:700,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:8,marginBottom:14}}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round"><path d="M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2"/><line x1="3" y1="12" x2="21" y2="12"/></svg>
        Scan Barcode to Auto-Fill
      </button>
      {form.barcode&&<div style={{fontSize:11,color:T.textMuted,marginBottom:12,fontFamily:'monospace',background:T.surfaceAlt,padding:'6px 10px',borderRadius:6}}>✓ Barcode: {form.barcode}</div>}
      {row2(inp('Name','name','Nozzle Set'),sel('Type','type',['Tool','Spare Part','Consumable','Electronics','Safety','Nozzle','Bed','Belt','PTFE Tube','Thermistor','Heater','Fan','Extruder','Frame Part','Other'],'Tool'))}
      {row2(inp('Serial / ID','serial','SN-001'),<div style={{marginBottom:12}}>
        <label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Quantity</label>
        <input type="number" value={form.qty??1} onChange={e=>{const q=parseInt(e.target.value)||1;setForm((f:any)=>({...f,qty:q,total_value:((parseFloat(String(f.unit_cost))||0)*q).toFixed(2)}));}} style={{width:'100%',padding:'11px 13px',fontSize:14,border:`1px solid ${T.inputBorder}`,borderRadius:10,fontFamily:'inherit',outline:'none',background:T.input,color:T.text}}/>
      </div>)}
      {row2(<div style={{marginBottom:12}}>
        <label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Unit Cost ($)</label>
        <input type="number" value={form.unit_cost??0} onChange={e=>{const c=parseFloat(e.target.value)||0;setForm((f:any)=>({...f,unit_cost:e.target.value,total_value:(c*(parseInt(f.qty)||1)).toFixed(2)}));}} style={{width:'100%',padding:'11px 13px',fontSize:14,border:`1px solid ${T.inputBorder}`,borderRadius:10,fontFamily:'inherit',outline:'none',background:T.input,color:T.text}}/>
      </div>,inp('Total Value ($)','total_value',(parseFloat(form.unit_cost||0)*parseInt(form.qty||1)).toFixed(2),'number',0))}
      {row2(inp('Supplier / Vendor','supplier','Amazon, McMaster…'),inp('Purchase Date','purchase_date',new Date().toISOString().split('T')[0],'date',''))}
      {inp('Location','location','Tool Drawer')}
      <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Notes / Specs</label><textarea value={form.notes||''} onChange={e=>setForm((f:any)=>({...f,notes:e.target.value}))} placeholder="Part number, specs, compatible printers…" style={{width:'100%',padding:'10px 12px',fontSize:13,border:'1px solid #e0e0e0',borderRadius:10,fontFamily:'inherit',outline:'none',minHeight:60,resize:'vertical'}}/></div>
    </>,
    printer:<>
      {row2(inp('Printer Name','name','Printer #1'),sel('Model','model',['Prusa MK4','Prusa MK3S+','Prusa XL','Prusa MINI+','Bambu X1C','Bambu P1S','Bambu A1','Bambu A1 Mini','Voron 2.4','Creality K1','Other'],'Prusa MK4'))}
      {inp('Location / Station','location','Station A1')}
      {sel('API Type','api_type',['manual','prusa','bambu','octoprint','klipper'],'manual')}
      {form.api_type==='prusa'&&<>
        {inp('Prusa API Key','prusa_api_key','e.g. G3PIMQ2H4fde47ba — from connect.prusa3d.com → Settings → API Keys')}
        {inp('Local IP (recommended)','prusa_local_ip','192.168.1.xxx — printer screen → Settings → Network')}
        {inp('Printer UUID (cloud fallback)','prusa_uuid','connect.prusa3d.com/printers/[UUID]')}
        <div style={{background:'#E1F5EE',color:'#085041',padding:'8px 12px',borderRadius:8,marginBottom:10,fontSize:11}}>
          💡 <strong>Local IP is faster and more reliable.</strong> Find it on your printer: Settings → Network → IP Address. The API Key is on the printer touchscreen under Settings → Network → PrusaLink.
        </div>
      </>}
      {form.api_type==='bambu'&&<>
        <div style={{background:'#E6F1FB',color:'#185FA5',padding:'10px 12px',borderRadius:8,marginBottom:10,fontSize:12}}>Device ID: Bambu Studio → Device → Device Info. Access Code: on printer touchscreen.</div>
        {inp('Bambu Device ID','bambu_device_id','Your device ID')}
        {inp('Access Code','bambu_access_code','From printer touchscreen')}
      </>}
      {(form.api_type==='octoprint'||form.api_type==='klipper')&&<>
        <div style={{background:'#E6F1FB',color:'#185FA5',padding:'10px 12px',borderRadius:8,marginBottom:10,fontSize:12}}>
          {form.api_type==='klipper'?'Klipper/Moonraker URL (e.g. http://mainsailos.local or IP address)':'OctoPrint URL (e.g. http://192.168.1.100)'}
        </div>
        {inp(form.api_type==='klipper'?'Moonraker URL':'OctoPrint URL','octoprint_url','http://192.168.1.100')}
        {form.api_type==='octoprint'&&inp('OctoPrint API Key','octoprint_api_key','From OctoPrint Settings → Application Keys')}
        {form.api_type==='klipper'&&<div style={{marginBottom:12}}>
          <label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Moonraker API Key (optional)</label>
          <input value={form.octoprint_api_key||''} onChange={e=>setForm((f:any)=>({...f,octoprint_api_key:e.target.value}))} placeholder="Leave blank if no auth configured" style={{width:'100%',padding:'11px 13px',fontSize:14,border:`1px solid ${T.inputBorder}`,borderRadius:10,fontFamily:'inherit',outline:'none',background:T.input,color:T.text}}/>
          <div style={{fontSize:10,color:T.textMuted,marginTop:4}}>Most home Klipper installs have no API key. Add one if you enabled trusted clients auth.</div>
        </div>}
      </>}
      {(!form.api_type||form.api_type==='manual')&&<div style={{background:T.surfaceAlt,color:T.textMuted,padding:'10px 12px',borderRadius:8,fontSize:12}}>Manual mode — no live sync. You can change this later by tapping the printer card.</div>}
      <div style={{height:1,background:'rgba(0,0,0,0.08)',margin:'14px 0'}}/>
      <div style={{fontSize:12,fontWeight:700,color:T.textSub,marginBottom:10,textTransform:'uppercase',letterSpacing:'0.5px'}}>Purchase Info (for cost tracking)</div>
      {row2(inp('Purchase Price ($)','purchase_price','0.00','number',0),inp('Purchase Date','purchase_date',new Date().toISOString().split('T')[0],'date',''))}
      {inp('Supplier / Vendor','supplier','eBay, Prusa Store, Amazon…')}
    </>,
    queue:<>
      {inp('Job / File Name','job_name','bracket_v2.gcode')}
      {customers.length>0&&<div style={{marginBottom:12}}>
        <label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Customer (optional)</label>
        <select value={form.customer_id||''} onChange={e=>setForm((f:any)=>({...f,customer_id:e.target.value}))} style={{width:'100%',padding:'11px 13px',fontSize:14,border:'1px solid #e0e0e0',borderRadius:10,fontFamily:'inherit',outline:'none',background:'#fff'}}>
          <option value="">— Internal / No customer —</option>
          {customers.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>}
      {form.customer_id&&row2(inp('Customer Price ($)','customer_price','0.00','number',0),inp('Job Tags','tags','urgent, prototype…'))}{row2(sel('Material','material',['PLA','PLA+','PLA-CF','PETG','PETG-CF','ABS','ASA','TPU','TPE','Nylon','Nylon-CF','PA12','PA12-CF','PC','PC-ABS','HIPS','PVA','BVOH','CPE','CPE+','PP','PEI (ULTEM)','PEEK','PEKK','PAHT-CF','PHA','Flex','Silk PLA','Matte PLA','Wood Fill','Metal Fill','Glow Fill','Marble Fill','Rainbow','Other'],'PLA'),sel('Priority','priority',['high','normal','low'],'normal'))}{row2(inp('Duration (min)','duration','60','number',60),inp('Filament (g)','filament_g','50','number',50))}<div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Notes</label><textarea value={form.notes||''} onChange={e=>setForm((f:any)=>({...f,notes:e.target.value}))} placeholder="Customer order, special settings…" style={{width:'100%',padding:'11px 13px',fontSize:14,border:'1px solid #e0e0e0',borderRadius:10,fontFamily:'inherit',outline:'none',minHeight:70,resize:'vertical'}}/></div></>,
    adjustFilament:<>
      <div style={{marginBottom:16}}>
        <div style={{fontSize:13,fontWeight:600,color:T.textSub,marginBottom:4}}>{form.brand} {form.material} {form.color}</div>
        <div style={{fontSize:12,color:T.textMuted,marginBottom:16}}>Current: {form.remaining}% · {form.weight}g total · {Math.round((form.weight*form.remaining/100))}g remaining</div>
        <label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:8}}>Remaining amount</label>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:12}}>
          <div>
            <div style={{fontSize:11,color:'#aaa',marginBottom:4}}>Percentage (%)</div>
            <input type="number" min="0" max="100" value={form.remaining||0} onChange={e=>setForm((f:any)=>({...f,remaining:Math.min(100,Math.max(0,parseInt(e.target.value)||0))}))} style={{width:'100%',padding:'10px 12px',fontSize:18,fontWeight:700,border:'1.5px solid #185FA5',borderRadius:10,fontFamily:'inherit',outline:'none',textAlign:'center'}}/>
          </div>
          <div>
            <div style={{fontSize:11,color:'#aaa',marginBottom:4}}>Grams remaining</div>
            <input type="number" min="0" max={form.weight||1000} value={Math.round((form.weight||1000)*(form.remaining||0)/100)} onChange={e=>{const g=parseInt(e.target.value)||0;const pct=Math.round(Math.min(100,Math.max(0,g/(form.weight||1000)*100)));setForm((f:any)=>({...f,remaining:pct}));}} style={{width:'100%',padding:'10px 12px',fontSize:18,fontWeight:700,border:'1px solid #e0e0e0',borderRadius:10,fontFamily:'inherit',outline:'none',textAlign:'center'}}/>
          </div>
        </div>
        <div style={{height:12,background:'#f0f0f0',borderRadius:6,overflow:'hidden',marginBottom:8}}>
          <div style={{height:'100%',borderRadius:6,background:form.remaining<20?'#E24B4A':'#185FA5',width:`${form.remaining||0}%`,transition:'width 0.2s'}}/>
        </div>
        <div style={{display:'flex',justifyContent:'space-between',marginBottom:16}}>
          {[100,75,50,25,10,0].map(v=>(
            <button key={v} onClick={()=>setForm((f:any)=>({...f,remaining:v}))} style={{flex:1,margin:'0 2px',padding:'8px 0',background:form.remaining===v?'#185FA5':'#f0f0f0',color:form.remaining===v?'#fff':'#555',border:'none',borderRadius:8,fontSize:12,fontWeight:600,cursor:'pointer'}}>{v}%</button>
          ))}
        </div>
      </div>
    </>,
    prusaConnect:<>
      <div style={{background:'#E6F1FB',color:'#185FA5',padding:'12px 14px',borderRadius:10,marginBottom:14,fontSize:13}}>
        Get your API key from: connect.prusa3d.com → Your printer → Settings → API Key
      </div>
      {inp('Printer Name','name','My Prusa MK4')}
      {inp('Prusa Connect API Key','prusa_api_key','e.g. G3PIMQ2H4fde47ba')}
      {inp('Printer UUID','prusa_uuid','From URL: connect.prusa3d.com/printers/[UUID]')}
      {inp('Local IP Address (optional but recommended)','prusa_local_ip','192.168.1.xxx — for direct local connection')}
      <div style={{background:'#E1F5EE',color:'#085041',padding:'8px 12px',borderRadius:8,marginBottom:10,fontSize:11}}>
        💡 Adding your printer's local IP enables faster, more reliable data via PrusaLink on your local network.
        Find it at: Printer screen → Settings → Network → IP Address
      </div>
      {sel('Model','model',['Prusa MK4','Prusa MK3S+','Prusa XL','Prusa MINI+','Other'],'Prusa MK4')}
      {inp('Location / Station','location','Station B1')}
    </>,
    editPrinter:<>
      <div style={{marginBottom:14}}>
        <div style={{fontSize:12,color:T.textMuted,marginBottom:12}}>Tap a field to edit. Changes save immediately.</div>
        {inp('Printer Name','name','Printer #1')}
        {row2(sel('Model','model',['Prusa MK4','Prusa MK3S+','Prusa XL','Prusa MINI+','Bambu X1C','Bambu P1S','Bambu A1','Voron 2.4','Other'],'Prusa MK4'),inp('Location','location','Station A1'))}
        {sel('API Type','api_type',['manual','prusa','bambu','octoprint','klipper'],'manual')}
        {(form.api_type==='prusa')&&<>
          <div style={{background:'#E6F1FB',color:'#185FA5',padding:'10px 12px',borderRadius:8,marginBottom:10,fontSize:12}}>
            Find these at connect.prusa3d.com → Your Printer → Settings
          </div>
          {inp('Prusa Connect API Key','prusa_api_key','e.g. G3PIMQ2H4fde47ba')}
          {inp('Printer UUID','prusa_uuid','From URL: connect.prusa3d.com/printers/[UUID]')}
      {inp('Local IP Address (optional but recommended)','prusa_local_ip','192.168.1.xxx — for direct local connection')}
      <div style={{background:'#E1F5EE',color:'#085041',padding:'8px 12px',borderRadius:8,marginBottom:10,fontSize:11}}>
        💡 Adding your printer's local IP enables faster, more reliable data via PrusaLink on your local network.
        Find it at: Printer screen → Settings → Network → IP Address
      </div>
        </>}
        {(form.api_type==='bambu')&&<>
          <div style={{background:'#E6F1FB',color:'#185FA5',padding:'10px 12px',borderRadius:8,marginBottom:10,fontSize:12}}>
            Find Device ID in Bambu Studio → Device → Device Info
          </div>
          {inp('Bambu Device ID','bambu_device_id','Your device ID')}
          {inp('Access Code','bambu_access_code','Shown on printer screen')}
        </>}
        {(form.api_type==='octoprint')&&<>
          <div style={{background:'#E6F1FB',color:'#185FA5',padding:'10px 12px',borderRadius:8,marginBottom:10,fontSize:12}}>
            OctoPrint URL example: http://192.168.1.100 (local network IP)
          </div>
          {inp('OctoPrint URL','octoprint_url','http://192.168.1.100')}
          {inp('API Key','octoprint_api_key','From OctoPrint Settings → API')}
        </>}
        {(form.api_type==='manual')&&<div style={{background:T.surfaceAlt,color:T.textMuted,padding:'10px 12px',borderRadius:8,fontSize:12}}>
          Manual mode — status updated manually. Switch to Prusa, Bambu, or OctoPrint for live sync.
        </div>}
      </div>
    </>,
    newTicket:<>
      <div style={{background:'#E6F1FB',color:'#185FA5',padding:'10px 12px',borderRadius:8,marginBottom:12,fontSize:12}}>
        Tickets are sent to all Admins, Management, and IT staff immediately.
      </div>
      {sel('Category','category',['Hardware Issue','Software Issue','Network/Connectivity','Printer Problem','Account Access','Equipment Failure','Security Concern','General IT Help','Other'],'Hardware Issue')}
      {inp('Subject','subject','Brief description of the issue')}
      {sel('Priority','priority',['critical','high','medium','low'],'medium')}
      {inp('Location / Workstation','location','Station A1, Office, Shop Floor…')}
      <div style={{marginBottom:12}}>
        <label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Description</label>
        <textarea value={form.description||''} onChange={e=>setForm((f:any)=>({...f,description:e.target.value}))} placeholder="Describe the issue in detail — what happened, what you were doing, any error messages…" style={{width:'100%',padding:'11px 13px',fontSize:13,border:`1px solid ${T.inputBorder}`,borderRadius:10,fontFamily:'inherit',outline:'none',minHeight:100,resize:'vertical',background:T.input,color:T.text}}/>
      </div>
      {inp('Steps to Reproduce (optional)','steps','1. Opened app  2. Clicked…')}
    </>,
    newCustomer:<>
      {row2(inp('Company / Name','name','ForgeByte Technologies'),inp('Contact Person','contact','John Smith'))}
      {row2(inp('Email','email','contact@company.com'),inp('Phone','phone','555-000-0000'))}
      {inp('Address','address','123 Main St, City, State')}
      {row2(inp('Default Material','default_material','PLA'),inp('Default Color','default_color','Black'))}
      {row2(inp('Hourly Rate ($)','hourly_rate','65.00','number',65),inp('Material Markup (%)','markup','20','number',20))}
      <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Notes</label><textarea value={form.notes||''} onChange={e=>setForm((f:any)=>({...f,notes:e.target.value}))} placeholder="Special requirements, preferred materials…" style={{width:'100%',padding:'10px 12px',fontSize:13,border:'1px solid #e0e0e0',borderRadius:10,fontFamily:'inherit',outline:'none',minHeight:60,resize:'vertical'}}/></div>
    </>,
    maintenance:<>
      {row2(sel('Printer','printer_name',printers.map(p=>p.name),printers[0]?.name||''),sel('Task','task',['Nozzle Replacement','Bed Leveling','Belt Tension Check','PTFE Tube Replacement','Lubrication','Firmware Update','Full Inspection','Cleaning','Extruder Maintenance','Hotend Replacement','Heatbed Replacement','Calibration','Part Replacement','Other'],'Nozzle Replacement'))}
      {row2(inp('Due Date','due_date',dFwd(7),'date',dFwd(7)),sel('Urgency','urgency',['high','med','low'],'med'))}
      {row2(inp('Est. Parts Cost ($)','parts_cost','0.00','number',0),inp('Est. Labor Time (min)','labor_min','30','number',30))}
      {inp('Parts / Materials Needed','parts_needed','e.g. 0.4mm nozzle, PTFE tube…')}
      <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Notes</label><textarea value={form.notes||''} onChange={e=>setForm((f:any)=>({...f,notes:e.target.value}))} placeholder="Details, part numbers, procedure…" style={{width:'100%',padding:'10px 12px',fontSize:13,border:'1px solid #e0e0e0',borderRadius:10,fontFamily:'inherit',outline:'none',minHeight:60,resize:'vertical'}}/></div>
    </>,
    newWorkOrder:<>
      {inp('Work Order Title','title','e.g. Replace nozzle on Printer #2')}
      {row2(sel('Printer','printer_name',printers.map(p=>p.name),printers[0]?.name||''),sel('Urgency','urgency',['high','medium','low'],'medium'))}
      {row2(inp('Due Date','due_date',dFwd(3),'date',''),inp('Assigned To','assigned_to','Technician name'))}
      {row2(inp('Est. Parts Cost ($)','parts_cost','0.00','number',0),inp('Est. Labor (min)','labor_min','30','number',30))}
      <div style={{marginBottom:8}}>
        <label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Parts from Inventory</label>
        <input value={partSearch} onChange={e=>setPartSearch(e.target.value)} placeholder="Search equipment inventory…" style={{width:'100%',padding:'9px 12px',fontSize:13,border:'1px solid #e0e0e0',borderRadius:8,fontFamily:'inherit',outline:'none',marginBottom:6}}/>
        {partSearch&&equipment.filter(e=>e.name.toLowerCase().includes(partSearch.toLowerCase())&&e.quantity>0).slice(0,5).map(e=>(
          <div key={e.id} onClick={()=>{const parts=[...(form.parts_used||[]),{id:e.id,name:e.name,qty:1}];setForm((f:any)=>({...f,parts_used:parts}));setPartSearch('');}} style={{padding:'8px 10px',background:T.surfaceAlt,borderRadius:8,marginBottom:4,cursor:'pointer',display:'flex',justifyContent:'space-between',fontSize:12}}>
            <span>{e.name}</span><span style={{color:T.textMuted}}>Stock: {e.quantity}</span>
          </div>
        ))}
        {(form.parts_used||[]).length>0&&(
          <div style={{background:'#E6F1FB',borderRadius:8,padding:'8px 10px',marginTop:4}}>
            {(form.parts_used||[]).map((p:any,i:number)=>(
              <div key={i} style={{display:'flex',alignItems:'center',gap:8,marginBottom:4,fontSize:12}}>
                <span style={{flex:1}}>{p.name}</span>
                <input type="number" value={p.qty} min={1} onChange={e=>{const parts=[...(form.parts_used||[])];parts[i]={...parts[i],qty:parseInt(e.target.value)||1};setForm((f:any)=>({...f,parts_used:parts}));}} style={{width:50,padding:'3px 6px',border:'1px solid #e0e0e0',borderRadius:6,textAlign:'center',fontSize:12}}/>
                <button onClick={()=>{const parts=(form.parts_used||[]).filter((_:any,j:number)=>j!==i);setForm((f:any)=>({...f,parts_used:parts}));}} style={{width:20,height:20,background:'none',border:'none',cursor:'pointer',color:'#E24B4A',fontSize:14}}>✕</button>
              </div>
            ))}
          </div>
        )}
      </div>
      <div style={{marginBottom:12}}><label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Description / Instructions</label><textarea value={form.description||''} onChange={e=>setForm((f:any)=>({...f,description:e.target.value}))} placeholder="Describe the work to be done…" style={{width:'100%',padding:'10px 12px',fontSize:13,border:'1px solid #e0e0e0',borderRadius:10,fontFamily:'inherit',outline:'none',minHeight:70,resize:'vertical'}}/></div>
    </>,
    newPurchase:<>
      <div style={{background:'#E6F1FB',color:'#185FA5',padding:'10px 12px',borderRadius:8,marginBottom:12,fontSize:12}}>
        Full Purchase Order — add line items below. {!canCreatePO&&<strong>Note: requires Lead or Admin approval.</strong>}
      </div>
      {inp('PO Title / Description','title','e.g. Monthly filament restock — April')}
      {row2(inp('Vendor / Supplier','vendor','Amazon, McMaster-Carr, Prusa Store…'),inp('Needed By','needed_by',dFwd(7),'date',''))}
      {row2(sel('Priority','urgency',['urgent','normal','low'],'normal'),sel('Ship To','ship_to',['Main Shop','Warehouse','Office','Other'],'Main Shop'))}
      {inp('Vendor Contact / URL','vendor_contact','vendor@email.com or amazon.com/…')}
      <div style={{marginBottom:4}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:6}}>
          <label style={{fontSize:12,fontWeight:700,color:T.textSub}}>Line Items</label>
          <button onClick={()=>{const items=[...(form.line_items||[]),{name:'',type:'equipment',qty:1,unit_price:0,notes:''}];setForm((f:any)=>({...f,line_items:items}));}} style={{padding:'4px 10px',background:'#185FA5',color:'#fff',border:'none',borderRadius:6,fontSize:11,fontWeight:600,cursor:'pointer'}}>+ Add Item</button>
        </div>
        {(form.line_items||[{name:'',type:'equipment',qty:1,unit_price:0,notes:''}]).map((item:any,i:number)=>{
          const updateItem=(key:string,val:any)=>{const items=[...(form.line_items||[{name:'',type:'equipment',qty:1,unit_price:0,notes:''}])];items[i]={...items[i],[key]:val};setForm((f:any)=>({...f,line_items:items}));};
          return(
            <div key={i} style={{background:T.statBg,borderRadius:10,padding:10,marginBottom:8}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:6}}>
                <span style={{fontSize:11,fontWeight:700,color:T.textMuted}}>Item {i+1}</span>
                {(form.line_items||[]).length>1&&<button onClick={()=>{const items=(form.line_items||[]).filter((_:any,j:number)=>j!==i);setForm((f:any)=>({...f,line_items:items}));}} style={{width:20,height:20,background:'none',border:'none',cursor:'pointer',color:'#E24B4A',fontSize:14}}>✕</button>}
              </div>
              <div style={{marginBottom:6}}><input value={item.name||''} onChange={e=>updateItem('name',e.target.value)} placeholder="Item name / part number" style={{width:'100%',padding:'8px 10px',fontSize:13,border:'1px solid #e0e0e0',borderRadius:8,fontFamily:'inherit',outline:'none'}}/></div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:6,marginBottom:6}}>
                <select value={item.type||'equipment'} onChange={e=>updateItem('type',e.target.value)} style={{padding:'7px 8px',fontSize:12,border:'1px solid #e0e0e0',borderRadius:8,fontFamily:'inherit',outline:'none',background:'#fff'}}>
                  <option value="equipment">Equipment</option><option value="filament">Filament</option><option value="consumable">Consumable</option><option value="safety">Safety</option><option value="other">Other</option>
                </select>
                <input type="number" value={item.qty||1} min={1} onChange={e=>updateItem('qty',parseInt(e.target.value)||1)} placeholder="Qty" style={{padding:'7px 8px',fontSize:13,border:'1px solid #e0e0e0',borderRadius:8,fontFamily:'inherit',outline:'none',textAlign:'center'}}/>
                <input type="number" value={item.unit_price||''} onChange={e=>updateItem('unit_price',parseFloat(e.target.value)||0)} placeholder="Unit $" style={{padding:'7px 8px',fontSize:13,border:'1px solid #e0e0e0',borderRadius:8,fontFamily:'inherit',outline:'none'}}/>
              </div>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <input value={item.notes||''} onChange={e=>updateItem('notes',e.target.value)} placeholder="Notes / specs…" style={{flex:1,marginRight:8,padding:'6px 8px',fontSize:12,border:'1px solid #e0e0e0',borderRadius:8,fontFamily:'inherit',outline:'none'}}/>
                <span style={{fontSize:12,fontWeight:700,color:'#185FA5',flexShrink:0}}>${((item.qty||1)*(item.unit_price||0)).toFixed(2)}</span>
              </div>
            </div>
          );
        })}
        <div style={{background:'#185FA5',color:'#fff',padding:'10px 14px',borderRadius:10,display:'flex',justifyContent:'space-between',fontWeight:700,fontSize:13}}>
          <span>PO Total</span>
          <span>${(form.line_items||[{qty:1,unit_price:0}]).reduce((s:number,i:any)=>s+((i.qty||1)*(i.unit_price||0)),0).toFixed(2)}</span>
        </div>
      </div>
      <div style={{marginBottom:12,marginTop:10}}><label style={{fontSize:12,fontWeight:600,color:T.textSub,display:'block',marginBottom:5}}>Justification / Notes</label><textarea value={form.reason||''} onChange={e=>setForm((f:any)=>({...f,reason:e.target.value}))} placeholder="Why is this purchase needed? Reference WO# if applicable." style={{width:'100%',padding:'10px 12px',fontSize:13,border:'1px solid #e0e0e0',borderRadius:10,fontFamily:'inherit',outline:'none',minHeight:60,resize:'vertical'}}/></div>
    </>,
  };
  const modalTitles:Record<string,string>={filament:'Add Filament Spool',equipment:'Add Equipment',printer:'Add Printer',queue:'Add to Print Queue',maintenance:form.editing?'Edit Maintenance Task':'Schedule Maintenance',adjustFilament:'Adjust Filament',prusaConnect:'Connect Prusa Printer',editPrinter:'Edit Printer',newCustomer:'Add Customer',editCustomer:'Edit Customer',newWorkOrder:'New Work Order',newPurchase:'New Purchase Order'};

  const sections=[...new Set(ALL_NAV.map(n=>n.section))];

  return(
    <div style={{display:'flex',height:'100vh',width:'100vw',overflow:'hidden',background:T.bg,fontFamily:"'Inter',system-ui,sans-serif",color:T.text}}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');*{box-sizing:border-box;margin:0;padding:0}::-webkit-scrollbar{width:4px}::-webkit-scrollbar-thumb{background:rgba(0,0,0,0.15);border-radius:4px}`}</style>

      {/* Desktop sidebar */}
      {!isMobile&&(
        <div style={{width:210,flexShrink:0,background:'#fff',borderRight:'0.5px solid rgba(0,0,0,0.1)',display:'flex',flexDirection:'column',overflowY:'auto'}}>
          <div style={{padding:'14px 16px',borderBottom:`0.5px solid ${T.border}`,display:'flex',alignItems:'center',gap:10}}>
            <img src={LOGO} alt="" style={{width:34,borderRadius:6}}/>
            <div><div style={{fontSize:13,fontWeight:800,color:'#185FA5',letterSpacing:'0.5px',textTransform:'uppercase'}}>ForgeOS</div><div style={{fontSize:9,color:T.textMuted,marginTop:1}}>Print Farm & Inventory</div></div>
          </div>
          {sections.map(sec=>(
            <div key={sec} style={{padding:'8px 0 2px',borderBottom:'0.5px solid rgba(0,0,0,0.05)'}}>
              <div style={{fontSize:9,fontWeight:700,color:T.textMuted,padding:'4px 16px 4px',letterSpacing:'1px',textTransform:'uppercase'}}>{sec}</div>
              {ALL_NAV.filter(n=>n.section===sec).map(n=>(
                <div key={n.id} onClick={()=>nav(n.id)} style={{display:'flex',alignItems:'center',gap:9,padding:'8px 16px',cursor:'pointer',fontSize:12,color:page===n.id?T.blue:T.textSub,background:page===n.id?'#EBF4FF':'transparent',borderRight:page===n.id?`2px solid ${T.blue}`:'2px solid transparent',fontWeight:page===n.id?600:400,transition:'all 0.1s',borderRadius:'0 0 0 0'}}>
                  <div style={{width:14,height:14,opacity:page===n.id?1:0.6}}>{I[n.id]}</div>{n.label}
                </div>
              ))}
            </div>
          ))}
          <div style={{marginTop:'auto',padding:'12px 16px',borderTop:`0.5px solid ${T.border}`}}>
            <div style={{fontSize:10,fontWeight:600,color:T.textMuted}}>Janesville, Wisconsin</div>
            <div style={{fontSize:10,color:T.textMuted,marginTop:4}}>{user.email}</div>
            <button onClick={()=>fbSignOut(auth)} style={{marginTop:8,width:'100%',padding:'7px',background:'transparent',border:'0.5px solid rgba(0,0,0,0.15)',borderRadius:8,fontSize:12,cursor:'pointer',color:T.textSub}}>Sign Out</button>
          </div>
        </div>
      )}

      <div style={{flex:1,display:'flex',flexDirection:'column',overflow:'hidden',minWidth:0}}>
        {/* Topbar */}
        <div style={{height:52,background:T.topbar,borderBottom:`0.5px solid ${T.topbarBorder}`,display:'flex',alignItems:'center',justifyContent:'space-between',padding:'0 16px',flexShrink:0,gap:8}}>
          <div style={{display:'flex',alignItems:'center',gap:10,minWidth:0}}>
            {isMobile&&<img src={LOGO} alt="" style={{width:28,borderRadius:5,flexShrink:0}}/>}
            <div style={{fontSize:isMobile?16:15,fontWeight:800,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',color:T.text,letterSpacing:'-0.3px'}}>{pageTitle}</div>
            {toast&&<div style={{fontSize:12,color:'#1D9E75',fontWeight:600,whiteSpace:'nowrap'}}>{toast}</div>}
          </div>
          <div style={{display:'flex',gap:6,flexShrink:0}}>
            {!isMobile&&<span style={{fontSize:11,color:T.textMuted,paddingRight:10,borderRight:`0.5px solid ${T.border}`,marginRight:2,alignSelf:'center'}}>ForgeByte Technologies LLC</span>}
            <button onClick={()=>nav('settings')} style={{position:'relative',width:36,height:36,background:T.surfaceAlt,border:'none',borderRadius:9,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
              <div style={{width:18,height:18,color:T.textSub}}>{I.settings}</div>
              {hasAlerts&&<div style={{position:'absolute',top:6,right:6,width:8,height:8,borderRadius:'50%',background:'#E24B4A',border:'2px solid #fff'}}/>}
            </button>
            {/* Profile avatar button */}
            <button onClick={()=>setShowProfile(true)} style={{width:36,height:36,background:isAdmin?'#185FA5':userRole==='management'?'#7F77DD':userRole==='it'?'#D4537E':userRole==='lead'?'#1D9E75':'#EF9F27',border:'none',borderRadius:'50%',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,color:'#fff',fontSize:13,fontWeight:700}}>
              {(userProfile?.name||user?.email||'?').charAt(0).toUpperCase()}
            </button>
            <button onClick={()=>{setModal('filament');setForm({});}} style={{padding:'7px 12px',background:'#f0f0f0',color:T.textSub,border:'none',borderRadius:9,fontSize:12,fontWeight:600,cursor:'pointer'}}>+ Filament</button>
            <button onClick={()=>{setModal('printer');setForm({});}} style={{padding:'7px 12px',background:'#185FA5',color:'#fff',border:'none',borderRadius:9,fontSize:12,fontWeight:600,cursor:'pointer'}}>+ Printer</button>
          </div>
        </div>

        {/* Page content */}
        <div style={{flex:1,overflowY:'auto',padding:isMobile?'14px 14px 90px':'16px 20px',background:T.bg}}>
          {pages[page]||pages.dashboard}
        </div>
      </div>

      {/* Mobile bottom nav */}
      {isMobile&&(
        <nav style={{position:'fixed',bottom:0,left:0,right:0,background:T.topbar,borderTop:`0.5px solid ${T.topbarBorder}`,display:'flex',padding:'0 4px',paddingBottom:'env(safe-area-inset-bottom)',zIndex:100,height:62}}>
          {BOTTOM_NAV.map(n=>(
            <button key={n.id} onClick={()=>n.id==='more'?setDrawer(true):nav(n.id)}
              style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:3,border:'none',background:'transparent',cursor:'pointer',color:page===n.id&&n.id!=='more'?T.blue:T.textMuted,padding:'6px 0',position:'relative'}}>
              {page===n.id&&n.id!=='more'&&<div style={{position:'absolute',top:0,left:'50%',transform:'translateX(-50%)',width:24,height:3,background:T.blue,borderRadius:'0 0 3px 3px'}}/>}
              <div style={{width:22,height:22}}>{I[n.id]}</div>
              <span style={{fontSize:9,fontWeight:600}}>{n.label}</span>
            </button>
          ))}
        </nav>
      )}

      {/* Mobile drawer */}
      {isMobile&&drawer&&(
        <div style={{position:'fixed',inset:0,zIndex:200}}>
          <div onClick={()=>setDrawer(false)} style={{position:'absolute',inset:0,background:'rgba(0,0,0,0.4)'}}/>
          <div style={{position:'absolute',bottom:0,left:0,right:0,background:T.surface,borderRadius:'20px 20px 0 0',padding:'16px 16px',paddingBottom:'calc(16px + env(safe-area-inset-bottom))',maxHeight:'80vh',overflowY:'auto'}}>
            <div style={{width:36,height:4,background:'#ddd',borderRadius:2,margin:'0 auto 16px'}}/>
            <div style={{fontSize:11,fontWeight:700,color:'#bbb',letterSpacing:'0.8px',textTransform:'uppercase',marginBottom:8}}>All Pages</div>
            {ALL_NAV.map(n=>(
              <div key={n.id} onClick={()=>nav(n.id)} style={{display:'flex',alignItems:'center',gap:14,padding:'13px 8px',cursor:'pointer',borderRadius:12,background:page===n.id?'#EBF4FF':'transparent',color:page===n.id?T.blue:T.text,fontWeight:page===n.id?700:500,fontSize:15}}>
                <div style={{width:20,height:20}}>{I[n.id]}</div>{n.label}
              </div>
            ))}
            <div style={{marginTop:16,paddingTop:16,borderTop:`0.5px solid ${T.border}`}}>
              <div style={{fontSize:12,color:'#aaa',marginBottom:8}}>{user.email}</div>
              <button onClick={()=>{nav('settings');}} style={{width:'100%',padding:'12px',background:'#f0f0f0',border:'none',borderRadius:12,fontSize:14,fontWeight:600,cursor:'pointer',color:T.textSub,marginBottom:8,display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
                <div style={{width:16,height:16}}>{I.settings}</div>Settings{hasAlerts&&<span style={{background:'#E24B4A',color:'#fff',fontSize:10,fontWeight:700,padding:'1px 6px',borderRadius:10}}>!</span>}
              </button>
              <button onClick={()=>fbSignOut(auth)} style={{width:'100%',padding:'12px',background:'#FCEBEB',border:'none',borderRadius:12,fontSize:14,fontWeight:600,cursor:'pointer',color:'#A32D2D'}}>Sign Out</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal */}
      {/* Profile Sheet */}
      {showProfile&&(
        <div onClick={()=>setShowProfile(false)} style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:1000,display:'flex',alignItems:'flex-end',justifyContent:'center'}}>
          <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:'20px 20px 0 0',padding:'20px',width:'100%',maxWidth:520,maxHeight:'85vh',overflowY:'auto',paddingBottom:'calc(20px + env(safe-area-inset-bottom))'}}>
            <div style={{width:36,height:4,background:'#ddd',borderRadius:2,margin:'0 auto 20px'}}/>
            {/* Avatar + name */}
            <div style={{textAlign:'center',marginBottom:20}}>
              <div style={{width:72,height:72,borderRadius:'50%',background:isAdmin?'#185FA5':userRole==='lead'?'#1D9E75':'#EF9F27',margin:'0 auto 12px',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontSize:28,fontWeight:700}}>
                {(userProfile?.name||user?.email||'?').charAt(0).toUpperCase()}
              </div>
              <div style={{fontSize:18,fontWeight:700,marginBottom:4,color:T.text}}>{userProfile?.name||user?.email?.split('@')[0]||'User'}</div>
              <div style={{fontSize:13,color:T.textMuted,marginBottom:8}}>{user?.email}</div>
              <span style={{fontSize:12,fontWeight:700,padding:'5px 16px',borderRadius:20,background:isAdmin?'#185FA5':userRole==='lead'?'#1D9E75':'#EF9F27',color:'#fff'}}>
                {isAdmin?'Administrator':userRole==='lead'?'Lead':'Technician'}
              </span>
            </div>
            {/* Role description */}
            <div style={{background:T.statBg,borderRadius:12,padding:'12px 14px',marginBottom:16}}>
              <div style={{fontSize:12,fontWeight:700,color:T.textSub,marginBottom:6}}>Your Permissions</div>
              {isAdmin&&<>
                <div style={{fontSize:12,color:T.textSub,marginBottom:3}}>✓ Full system access</div>
                <div style={{fontSize:12,color:T.textSub,marginBottom:3}}>✓ Approve work orders & purchase orders</div>
                <div style={{fontSize:12,color:T.textSub,marginBottom:3}}>✓ Manage team roles</div>
                <div style={{fontSize:12,color:T.textSub,marginBottom:3}}>✓ View all costs and reports</div>
                <div style={{fontSize:12,color:T.textSub}}>✓ Override any action in the system</div>
              </>}
              {userRole==='lead'&&<>
                <div style={{fontSize:12,color:T.textSub,marginBottom:3}}>✓ Approve work orders</div>
                <div style={{fontSize:12,color:T.textSub,marginBottom:3}}>✓ Approve purchase orders</div>
                <div style={{fontSize:12,color:T.textSub,marginBottom:3}}>✓ View all data and reports</div>
                <div style={{fontSize:12,color:T.textMuted,marginBottom:3}}>✗ Cannot manage team roles</div>
                <div style={{fontSize:12,color:T.textMuted}}>✗ Cannot change system settings</div>
              </>}
              {userRole==='tech'&&<>
                <div style={{fontSize:12,color:T.textSub,marginBottom:3}}>✓ Create and manage work orders</div>
                <div style={{fontSize:12,color:T.textSub,marginBottom:3}}>✓ Submit purchase requests</div>
                <div style={{fontSize:12,color:T.textSub,marginBottom:3}}>✓ Update maintenance tasks</div>
                <div style={{fontSize:12,color:T.textSub,marginBottom:3}}>✓ Checkout parts from inventory</div>
                <div style={{fontSize:12,color:T.textMuted,marginBottom:3}}>✗ Cannot approve work orders or POs</div>
                <div style={{fontSize:12,color:T.textMuted}}>✗ Cannot manage team or settings</div>
              </>}
            </div>
            {/* Company info */}
            <div style={{background:T.statBg,borderRadius:12,padding:'12px 14px',marginBottom:16}}>
              <div style={{fontSize:12,fontWeight:700,color:T.textSub,marginBottom:6}}>Company</div>
              <div style={{fontSize:13,fontWeight:600}}>ForgeByte Technologies LLC</div>
              <div style={{fontSize:11,color:T.textMuted,marginTop:2}}>CAD · Additive Mfg · Engineering · Janesville, Wisconsin</div>
            </div>
            <div style={{display:'flex',gap:10}}>
              <button onClick={()=>setShowProfile(false)} style={{flex:1,padding:'13px',background:T.surfaceAlt,border:'none',borderRadius:12,fontSize:14,fontWeight:600,cursor:'pointer',color:T.textSub}}>Close</button>
              <button onClick={()=>{setShowProfile(false);fbSignOut(auth);}} style={{flex:1,padding:'13px',background:'#FCEBEB',border:'none',borderRadius:12,fontSize:14,fontWeight:700,cursor:'pointer',color:'#A32D2D'}}>Sign Out</button>
            </div>
          </div>
        </div>
      )}

      {modal&&(
        <div onClick={()=>setModal(null)} style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:1000,display:'flex',alignItems:'flex-end',justifyContent:'center'}}>
          <div onClick={e=>e.stopPropagation()} style={{background:T.surface,borderRadius:'20px 20px 0 0',padding:'20px',width:'100%',maxWidth:520,maxHeight:'90vh',overflowY:'auto',paddingBottom:'calc(20px + env(safe-area-inset-bottom))',color:T.text}}>
            <div style={{width:36,height:4,background:'#ddd',borderRadius:2,margin:'0 auto 16px'}}/>
            <div style={{fontSize:17,fontWeight:700,marginBottom:16,color:T.text}}>{modalTitles[modal]}</div>
            {modalContent[modal]}
            <div style={{display:'flex',gap:10,marginTop:8}}>
              <button onClick={()=>setModal(null)} style={{flex:1,padding:'13px',background:T.surfaceAlt,border:'none',borderRadius:12,fontSize:14,fontWeight:600,cursor:'pointer',color:T.textSub}}>Cancel</button>
              <button onClick={saveModal} style={{flex:2,padding:'13px',background:'#185FA5',color:'#fff',border:'none',borderRadius:12,fontSize:14,fontWeight:700,cursor:'pointer'}}>Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
